// Auto-generated SVG Icon Catalog from @thesvg/react

export type SvgBrand = 'aws' | 'azure' | 'gcp' | 'devtool' | 'DevTools' | 'microsoft' | 'Microsoft' | 'hosting' | 'Hosting';

export interface SvgIconItem {
  key: string;
  name: string;
  brand: SvgBrand;
}

export const SVG_CATALOG: Record<SvgBrand, SvgIconItem[]> = {
  "DevTools": [],
  "Microsoft": [],
  "Hosting": [],
  "aws": [
    {
      "key": "aws-amazon-api-gateway",
      "name": "Amazon api Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-api-gateway-endpoint",
      "name": "Amazon api Gateway Endpoint",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-appflow",
      "name": "Amazon appflow",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-application-recovery-controller",
      "name": "Amazon application Recovery Controller",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-athena",
      "name": "Amazon athena",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-athena-data-source-connectors",
      "name": "Amazon athena Data Source Connectors",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-augmented-ai-a2i",
      "name": "Amazon augmented AI A2i",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-aurora",
      "name": "Amazon aurora",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-aurora-amazon-aurora-instance-alternate",
      "name": "Amazon aurora Amazon Aurora Instance Alternate",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-aurora-amazon-rds-instance",
      "name": "Amazon aurora Amazon Rds Instance",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-aurora-amazon-rds-instance-aternate",
      "name": "Amazon aurora Amazon Rds Instance Aternate",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-aurora-trusted-language-extensions-for-postgresql",
      "name": "Amazon aurora Trusted Language Extensions For Postgresql",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-bedrock",
      "name": "Amazon bedrock",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-bedrock-agentcore",
      "name": "Amazon bedrock Agentcore",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-braket",
      "name": "Amazon braket",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-chandelier",
      "name": "Amazon braket Chandelier",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-chip",
      "name": "Amazon braket Chip",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-embedded-simulator",
      "name": "Amazon braket Embedded Simulator",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-managed-simulator",
      "name": "Amazon braket Managed Simulator",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-noise-simulator",
      "name": "Amazon braket Noise Simulator",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-qpu",
      "name": "Amazon braket Qpu",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-simulator",
      "name": "Amazon braket Simulator",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-simulator-1",
      "name": "Amazon braket Simulator 1",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-simulator-2",
      "name": "Amazon braket Simulator 2",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-simulator-3",
      "name": "Amazon braket Simulator 3",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-simulator-4",
      "name": "Amazon braket Simulator 4",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-state-vector",
      "name": "Amazon braket State Vector",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-braket-tensor-network",
      "name": "Amazon braket Tensor Network",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-chime",
      "name": "Amazon chime",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-chime-sdk",
      "name": "Amazon chime SDK",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-cloud-directory",
      "name": "Amazon cloud Directory",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-cloudfront",
      "name": "Amazon cloudfront",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudfront-download-distribution",
      "name": "Amazon cloudfront Download Distribution",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudfront-edge-location",
      "name": "Amazon cloudfront Edge Location",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudfront-functions",
      "name": "Amazon cloudfront Functions",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudfront-streaming-distribution",
      "name": "Amazon cloudfront Streaming Distribution",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-cloudsearch",
      "name": "Amazon cloudsearch",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudsearch-search-documents",
      "name": "Amazon cloudsearch Search Documents",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-cloudwatch",
      "name": "Amazon cloudwatch",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-alarm",
      "name": "Amazon cloudwatch Alarm",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-cross-account-observability",
      "name": "Amazon cloudwatch Cross Account Observability",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-data-protection",
      "name": "Amazon cloudwatch Data Protection",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-event-event-based",
      "name": "Amazon cloudwatch Event Event Based",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-event-time-based",
      "name": "Amazon cloudwatch Event Time Based",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-evidently",
      "name": "Amazon cloudwatch Evidently",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-logs",
      "name": "Amazon cloudwatch Logs",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-metrics-insights",
      "name": "Amazon cloudwatch Metrics Insights",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-rule",
      "name": "Amazon cloudwatch Rule",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-rum",
      "name": "Amazon cloudwatch Rum",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-cloudwatch-synthetics",
      "name": "Amazon cloudwatch Synthetics",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-codecatalyst",
      "name": "Amazon codecatalyst",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-codeguru",
      "name": "Amazon codeguru",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-codewhisperer",
      "name": "Amazon codewhisperer",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-cognito",
      "name": "Amazon cognito",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-comprehend",
      "name": "Amazon comprehend",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-comprehend-medical",
      "name": "Amazon comprehend Medical",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-connect",
      "name": "Amazon connect",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-corretto",
      "name": "Amazon corretto",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-data-firehose",
      "name": "Amazon data Firehose",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-datazone",
      "name": "Amazon datazone",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-datazone-business-data-catalog",
      "name": "Amazon datazone Business Data Catalog",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-datazone-data-portal",
      "name": "Amazon datazone Data Portal",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-datazone-data-projects",
      "name": "Amazon datazone Data Projects",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-dcv",
      "name": "Amazon dcv",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-detective",
      "name": "Amazon detective",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-devops-guru",
      "name": "Amazon devops Guru",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-devops-guru-insights",
      "name": "Amazon devops Guru Insights",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-documentdb",
      "name": "Amazon documentdb",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-documentdb-elastic-clusters",
      "name": "Amazon documentdb Elastic Clusters",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-dynamodb",
      "name": "Amazon dynamodb",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-amazon-dynamodb-accelerator",
      "name": "Amazon dynamodb Amazon Dynamodb Accelerator",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-attribute",
      "name": "Amazon dynamodb Attribute",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-attributes",
      "name": "Amazon dynamodb Attributes",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-global-secondary-index",
      "name": "Amazon dynamodb Global Secondary Index",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-item",
      "name": "Amazon dynamodb Item",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-items",
      "name": "Amazon dynamodb Items",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-standard-access-table-class",
      "name": "Amazon dynamodb Standard Access Table Class",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-standard-infrequent-access-table-class",
      "name": "Amazon dynamodb Standard Infrequent Access Table Class",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-stream",
      "name": "Amazon dynamodb Stream",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-dynamodb-table",
      "name": "Amazon dynamodb Table",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-ec2",
      "name": "Amazon ec2",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-ami",
      "name": "Amazon ec2 Ami",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-ec2-auto-scaling",
      "name": "Amazon ec2 Auto Scaling",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-auto-scaling",
      "name": "Amazon ec2 Auto Scaling",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-aws-microservice-extractor-for-net",
      "name": "Amazon ec2 AWS Microservice Extractor For Net",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-db-instance",
      "name": "Amazon ec2 DB Instance",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-elastic-ip-address",
      "name": "Amazon ec2 Elastic IP Address",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-ec2-image-builder",
      "name": "Amazon ec2 Image Builder",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-instance",
      "name": "Amazon ec2 Instance",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-instance-with-cloudwatch",
      "name": "Amazon ec2 Instance With Cloudwatch",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-instances",
      "name": "Amazon ec2 Instances",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-rescue",
      "name": "Amazon ec2 Rescue",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-ec2-spot-instance",
      "name": "Amazon ec2 Spot Instance",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-ecs-anywhere",
      "name": "Amazon ecs Anywhere",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-efs",
      "name": "Amazon efs",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-eks-anywhere",
      "name": "Amazon eks Anywhere",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-eks-distro",
      "name": "Amazon eks Distro",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elastic-block-store",
      "name": "Amazon elastic Block Store",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-block-store-amazon-data-lifecycle-manager",
      "name": "Amazon elastic Block Store Amazon Data Lifecycle Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-block-store-multiple-volumes",
      "name": "Amazon elastic Block Store Multiple Volumes",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-block-store-snapshot",
      "name": "Amazon elastic Block Store Snapshot",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-block-store-volume",
      "name": "Amazon elastic Block Store Volume",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-block-store-volume-gp3",
      "name": "Amazon elastic Block Store Volume Gp3",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elastic-container-registry",
      "name": "Amazon elastic Container Registry",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-registry-image",
      "name": "Amazon elastic Container Registry Image",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-registry-registry",
      "name": "Amazon elastic Container Registry Registry",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elastic-container-service",
      "name": "Amazon elastic Container Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-container-1",
      "name": "Amazon elastic Container Service Container 1",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-container-2",
      "name": "Amazon elastic Container Service Container 2",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-container-3",
      "name": "Amazon elastic Container Service Container 3",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-copiiot-cli",
      "name": "Amazon elastic Container Service Copiiot Cli",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-ecs-service-connect",
      "name": "Amazon elastic Container Service ECS Service Connect",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-service",
      "name": "Amazon elastic Container Service Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-container-service-task",
      "name": "Amazon elastic Container Service Task",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-efs-intelligent-tiering",
      "name": "Amazon elastic File System EFS Intelligent Tiering",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-efs-one-zone",
      "name": "Amazon elastic File System EFS One Zone",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-efs-one-zone-infrequent-access",
      "name": "Amazon elastic File System EFS One Zone Infrequent Access",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-efs-standard",
      "name": "Amazon elastic File System EFS Standard",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-efs-standard-infrequent-access",
      "name": "Amazon elastic File System EFS Standard Infrequent Access",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-elastic-throughput",
      "name": "Amazon elastic File System Elastic Throughput",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-file-system-file-system",
      "name": "Amazon elastic File System File System",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elastic-inference",
      "name": "Amazon elastic Inference",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elastic-kubernetes-service",
      "name": "Amazon elastic Kubernetes Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elastic-kubernetes-service-eks-on-outposts",
      "name": "Amazon elastic Kubernetes Service EKS On Outposts",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elastic-vmware-service",
      "name": "Amazon elastic Vmware Service",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-elasticache",
      "name": "Amazon elasticache",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elasticache-cache-node",
      "name": "Amazon elasticache Cache Node",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elasticache-elasticache-for-memcached",
      "name": "Amazon elasticache Elasticache For Memcached",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elasticache-elasticache-for-redis",
      "name": "Amazon elasticache Elasticache For Redis",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-elasticache-elasticache-for-valkey",
      "name": "Amazon elasticache Elasticache For Valkey",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-emr",
      "name": "Amazon emr",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-emr-cluster",
      "name": "Amazon emr Cluster",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-emr-emr-engine",
      "name": "Amazon emr EMR Engine",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-emr-hdfs-cluster",
      "name": "Amazon emr Hdfs Cluster",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-eventbridge",
      "name": "Amazon eventbridge",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-custom-event-bus",
      "name": "Amazon eventbridge Custom Event Bus",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-default-event-bus",
      "name": "Amazon eventbridge Default Event Bus",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-pipes",
      "name": "Amazon eventbridge Pipes",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-rule",
      "name": "Amazon eventbridge Rule",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-saas-partner-event",
      "name": "Amazon eventbridge Saas Partner Event",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-scheduler",
      "name": "Amazon eventbridge Scheduler",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-schema",
      "name": "Amazon eventbridge Schema",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-eventbridge-schema-registry",
      "name": "Amazon eventbridge Schema Registry",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-file-cache",
      "name": "Amazon file Cache",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-file-cache-hybrid-nfs-linked-datasets",
      "name": "Amazon file Cache Hybrid Nfs Linked Datasets",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-file-cache-on-premises-nfs-linked-datasets",
      "name": "Amazon file Cache On Premises Nfs Linked Datasets",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-file-cache-s3-linked-datasets",
      "name": "Amazon file Cache S3 Linked Datasets",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-finspace",
      "name": "Amazon finspace",
      "brand": "aws"
    },
    {
      "key": "amazon-fire-tv",
      "name": "Amazon fire TV",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-forecast",
      "name": "Amazon forecast",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-fraud-detector",
      "name": "Amazon fraud Detector",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-fsx",
      "name": "Amazon fsx",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-fsx-for-lustre",
      "name": "Amazon fsx For Lustre",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-fsx-for-netapp-ontap",
      "name": "Amazon fsx For Netapp Ontap",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-fsx-for-openzfs",
      "name": "Amazon fsx For Openzfs",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-fsx-for-wfs",
      "name": "Amazon fsx For Wfs",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-gamelift-servers",
      "name": "Amazon gamelift Servers",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-gamelift-streams",
      "name": "Amazon gamelift Streams",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-guardduty",
      "name": "Amazon guardduty",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-inspector",
      "name": "Amazon inspector",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-inspector-agent",
      "name": "Amazon inspector Agent",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-interactive-video-service",
      "name": "Amazon interactive Video Service",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-kendra",
      "name": "Amazon kendra",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-keyspaces",
      "name": "Amazon keyspaces",
      "brand": "aws"
    },
    {
      "key": "amazon-kindle",
      "name": "Amazon kindle",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-kinesis",
      "name": "Amazon kinesis",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-kinesis-data-streams",
      "name": "Amazon kinesis Data Streams",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-kinesis-video-streams",
      "name": "Amazon kinesis Video Streams",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-lex",
      "name": "Amazon lex",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-lightsail",
      "name": "Amazon lightsail",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-lightsail-for-research",
      "name": "Amazon lightsail For Research",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-location-service",
      "name": "Amazon location Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-location-service-geofence",
      "name": "Amazon location Service Geofence",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-location-service-map",
      "name": "Amazon location Service Map",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-location-service-place",
      "name": "Amazon location Service Place",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-location-service-routes",
      "name": "Amazon location Service Routes",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-location-service-track",
      "name": "Amazon location Service Track",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-lookout-for-equipment",
      "name": "Amazon lookout For Equipment",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-lookout-for-vision",
      "name": "Amazon lookout For Vision",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-macie",
      "name": "Amazon macie",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-managed-blockchain",
      "name": "Amazon managed Blockchain",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-managed-blockchain-blockchain",
      "name": "Amazon managed Blockchain Blockchain",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-managed-grafana",
      "name": "Amazon managed Grafana",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-managed-service-for-apache-flink",
      "name": "Amazon managed Service For Apache Flink",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-managed-service-for-prometheus",
      "name": "Amazon managed Service For Prometheus",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-managed-streaming-for-apache-kafka",
      "name": "Amazon managed Streaming For Apache Kafka",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-managed-workflows-for-apache-airflow",
      "name": "Amazon managed Workflows For Apache Airflow",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-memorydb",
      "name": "Amazon memorydb",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-monitron",
      "name": "Amazon monitron",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-mq",
      "name": "Amazon mq",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-mq-broker",
      "name": "Amazon mq Broker",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-msk-amazon-msk-connect",
      "name": "Amazon msk Amazon Msk Connect",
      "brand": "aws"
    },
    {
      "key": "amazon-music",
      "name": "Amazon music",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-neptune",
      "name": "Amazon neptune",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-nova",
      "name": "Amazon nova",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-opensearch-service",
      "name": "Amazon opensearch Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-cluster-administrator-node",
      "name": "Amazon opensearch Service Cluster Administrator Node",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-data-node",
      "name": "Amazon opensearch Service Data Node",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-index",
      "name": "Amazon opensearch Service Index",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-observability",
      "name": "Amazon opensearch Service Observability",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-opensearch-dashboards",
      "name": "Amazon opensearch Service Opensearch Dashboards",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-opensearch-ingestion",
      "name": "Amazon opensearch Service Opensearch Ingestion",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-traces",
      "name": "Amazon opensearch Service Traces",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-opensearch-service-ultrawarm-node",
      "name": "Amazon opensearch Service Ultrawarm Node",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-personalize",
      "name": "Amazon personalize",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-pinpoint",
      "name": "Amazon pinpoint",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-pinpoint-apis",
      "name": "Amazon pinpoint Apis",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-pinpoint-journey",
      "name": "Amazon pinpoint Journey",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-polly",
      "name": "Amazon polly",
      "brand": "aws"
    },
    {
      "key": "amazon-prime",
      "name": "Amazon prime",
      "brand": "aws"
    },
    {
      "key": "amazon-q",
      "name": "Amazon q",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-q",
      "name": "Amazon q",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-quick-suite",
      "name": "Amazon quick Suite",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-rds",
      "name": "Amazon rds",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rds-blue-green-deployments",
      "name": "Amazon rds Blue Green Deployments",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rds-multi-az",
      "name": "Amazon rds Multi Az",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rds-multi-az-db-cluster",
      "name": "Amazon rds Multi Az DB Cluster",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rds-optimized-writes",
      "name": "Amazon rds Optimized Writes",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rds-trusted-language-extensions-for-postgresql",
      "name": "Amazon rds Trusted Language Extensions For Postgresql",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-redshift",
      "name": "Amazon redshift",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-auto-copy",
      "name": "Amazon redshift Auto Copy",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-data-sharing-governance",
      "name": "Amazon redshift Data Sharing Governance",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-dense-compute-node",
      "name": "Amazon redshift Dense Compute Node",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-dense-storage-node",
      "name": "Amazon redshift Dense Storage Node",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-ml",
      "name": "Amazon redshift ML",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-query-editor-v2-0",
      "name": "Amazon redshift Query Editor V2 0",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-ra3",
      "name": "Amazon redshift Ra3",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-redshift-streaming-ingestion",
      "name": "Amazon redshift Streaming Ingestion",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-rekognition",
      "name": "Amazon rekognition",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rekognition-image",
      "name": "Amazon rekognition Image",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-rekognition-video",
      "name": "Amazon rekognition Video",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-route-53",
      "name": "Amazon route 53",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-route-53-readiness-checks",
      "name": "Amazon route 53 Readiness Checks",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-route-53-resolver",
      "name": "Amazon route 53 Resolver",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-route-53-resolver-dns-firewall",
      "name": "Amazon route 53 Resolver DNS Firewall",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-route-53-resolver-query-logging",
      "name": "Amazon route 53 Resolver Query Logging",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-route-53-route-table",
      "name": "Amazon route 53 Route Table",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-route-53-routing-controls",
      "name": "Amazon route 53 Routing Controls",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-s3-on-outposts",
      "name": "Amazon s3 On Outposts",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-sagemaker",
      "name": "Amazon sagemaker",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-sagemaker-ai",
      "name": "Amazon sagemaker AI",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-sagemaker-ai-canvas",
      "name": "Amazon sagemaker AI Canvas",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-sagemaker-ai-geospatial-ml",
      "name": "Amazon sagemaker AI Geospatial ML",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-sagemaker-ai-model",
      "name": "Amazon sagemaker AI Model",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-sagemaker-ai-notebook",
      "name": "Amazon sagemaker AI Notebook",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-sagemaker-ai-shadow-testing",
      "name": "Amazon sagemaker AI Shadow Testing",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-sagemaker-ai-train",
      "name": "Amazon sagemaker AI Train",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-sagemaker-ground-truth",
      "name": "Amazon sagemaker Ground Truth",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-sagemaker-studio-lab",
      "name": "Amazon sagemaker Studio Lab",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-security-lake",
      "name": "Amazon security Lake",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-simple-email-service",
      "name": "Amazon simple Email Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-email-service-email",
      "name": "Amazon simple Email Service Email",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-simple-notification-service",
      "name": "Amazon simple Notification Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-notification-service-email-notification",
      "name": "Amazon simple Notification Service Email Notification",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-notification-service-http-notification",
      "name": "Amazon simple Notification Service Http Notification",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-notification-service-topic",
      "name": "Amazon simple Notification Service Topic",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-simple-queue-service",
      "name": "Amazon simple Queue Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-queue-service-message",
      "name": "Amazon simple Queue Service Message",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-queue-service-queue",
      "name": "Amazon simple Queue Service Queue",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-simple-storage-service",
      "name": "Amazon simple Storage Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-bucket",
      "name": "Amazon simple Storage Service Bucket",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-bucket-with-objects",
      "name": "Amazon simple Storage Service Bucket With Objects",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-directory-bucket",
      "name": "Amazon simple Storage Service Directory Bucket",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-general-access-points",
      "name": "Amazon simple Storage Service General Access Points",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-simple-storage-service-glacier",
      "name": "Amazon simple Storage Service Glacier",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-glacier-archive",
      "name": "Amazon simple Storage Service Glacier Archive",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-glacier-vault",
      "name": "Amazon simple Storage Service Glacier Vault",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-object",
      "name": "Amazon simple Storage Service Object",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-batch-operations",
      "name": "Amazon simple Storage Service S3 Batch Operations",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-express-one-zone",
      "name": "Amazon simple Storage Service S3 Express One Zone",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-glacier-deep-archive",
      "name": "Amazon simple Storage Service S3 Glacier Deep Archive",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-glacier-flexible-retrieval",
      "name": "Amazon simple Storage Service S3 Glacier Flexible Retrieval",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-glacier-instant-retrieval",
      "name": "Amazon simple Storage Service S3 Glacier Instant Retrieval",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-intelligent-tiering",
      "name": "Amazon simple Storage Service S3 Intelligent Tiering",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-multi-region-access-points",
      "name": "Amazon simple Storage Service S3 Multi Region Access Points",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-object-lambda",
      "name": "Amazon simple Storage Service S3 Object Lambda",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-object-lambda-access-points",
      "name": "Amazon simple Storage Service S3 Object Lambda Access Points",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-object-lock",
      "name": "Amazon simple Storage Service S3 Object Lock",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-on-outposts",
      "name": "Amazon simple Storage Service S3 On Outposts",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-one-zone-ia",
      "name": "Amazon simple Storage Service S3 One Zone Ia",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-replication",
      "name": "Amazon simple Storage Service S3 Replication",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-replication-time-control",
      "name": "Amazon simple Storage Service S3 Replication Time Control",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-select",
      "name": "Amazon simple Storage Service S3 Select",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-standard",
      "name": "Amazon simple Storage Service S3 Standard",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-standard-ia",
      "name": "Amazon simple Storage Service S3 Standard Ia",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-storage-lens",
      "name": "Amazon simple Storage Service S3 Storage Lens",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-tables",
      "name": "Amazon simple Storage Service S3 Tables",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-s3-vectors",
      "name": "Amazon simple Storage Service S3 Vectors",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-simple-storage-service-vpc-access-points",
      "name": "Amazon simple Storage Service VPC Access Points",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-textract",
      "name": "Amazon textract",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-textract-analyze-lending",
      "name": "Amazon textract Analyze Lending",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-timestream",
      "name": "Amazon timestream",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-transcribe",
      "name": "Amazon transcribe",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-translate",
      "name": "Amazon translate",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-verified-permissions",
      "name": "Amazon verified Permissions",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-virtual-private-cloud",
      "name": "Amazon virtual Private Cloud",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-carrier-gateway",
      "name": "Amazon vpc Carrier Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-customer-gateway",
      "name": "Amazon vpc Customer Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-elastic-network-adapter",
      "name": "Amazon vpc Elastic Network Adapter",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-elastic-network-interface",
      "name": "Amazon vpc Elastic Network Interface",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-endpoints",
      "name": "Amazon vpc Endpoints",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-flow-logs",
      "name": "Amazon vpc Flow Logs",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-internet-gateway",
      "name": "Amazon vpc Internet Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-vpc-lattice",
      "name": "Amazon vpc Lattice",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-nat-gateway",
      "name": "Amazon vpc NAT Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-network-access-analyzer",
      "name": "Amazon vpc Network Access Analyzer",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-network-access-control-list",
      "name": "Amazon vpc Network Access Control List",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-peering-connection",
      "name": "Amazon vpc Peering Connection",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-reachability-analyzer",
      "name": "Amazon vpc Reachability Analyzer",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-router",
      "name": "Amazon vpc Router",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-traffic-mirroring",
      "name": "Amazon vpc Traffic Mirroring",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-virtual-private-cloud-vpc",
      "name": "Amazon vpc Virtual Private Cloud VPC",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-vpn-connection",
      "name": "Amazon vpc VPN Connection",
      "brand": "aws"
    },
    {
      "key": "aws-res-amazon-vpc-vpn-gateway",
      "name": "Amazon vpc VPN Gateway",
      "brand": "aws"
    },
    {
      "key": "amazon-web-services",
      "name": "Amazon web Services",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-workdocs",
      "name": "Amazon workdocs",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-workdocs-sdk",
      "name": "Amazon workdocs SDK",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-workmail",
      "name": "Amazon workmail",
      "brand": "aws"
    },
    {
      "key": "aws-amazon-workspaces",
      "name": "Amazon workspaces",
      "brand": "aws"
    },
    {
      "key": "aws-cat-analytics",
      "name": "Analytics",
      "brand": "aws"
    },
    {
      "key": "aws-apache-mxnet-on-aws",
      "name": "Apache Mxnet On AWS",
      "brand": "aws"
    },
    {
      "key": "aws-cat-application-integration",
      "name": "Application Integration",
      "brand": "aws"
    },
    {
      "key": "aws-cat-artificial-intelligence",
      "name": "Artificial Intelligence",
      "brand": "aws"
    },
    {
      "key": "aws-group-auto-scaling-group",
      "name": "Auto Scaling Group",
      "brand": "aws"
    },
    {
      "key": "aws-group-aws-account",
      "name": "AWS Account",
      "brand": "aws"
    },
    {
      "key": "aws-aws-activate",
      "name": "AWS Activate",
      "brand": "aws"
    },
    {
      "key": "aws-aws-amplify",
      "name": "AWS Amplify",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-amplify-aws-amplify-studio",
      "name": "AWS Amplify AWS Amplify Studio",
      "brand": "aws"
    },
    {
      "key": "aws-aws-app-mesh",
      "name": "AWS App Mesh",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-app-mesh-mesh",
      "name": "AWS App Mesh Mesh",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-app-mesh-virtual-gateway",
      "name": "AWS App Mesh Virtual Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-app-mesh-virtual-node",
      "name": "AWS App Mesh Virtual Node",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-app-mesh-virtual-router",
      "name": "AWS App Mesh Virtual Router",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-app-mesh-virtual-service",
      "name": "AWS App Mesh Virtual Service",
      "brand": "aws"
    },
    {
      "key": "aws-aws-app-runner",
      "name": "AWS App Runner",
      "brand": "aws"
    },
    {
      "key": "aws-aws-app-studio",
      "name": "AWS App Studio",
      "brand": "aws"
    },
    {
      "key": "aws-aws-appconfig",
      "name": "AWS Appconfig",
      "brand": "aws"
    },
    {
      "key": "aws-aws-appfabric",
      "name": "AWS Appfabric",
      "brand": "aws"
    },
    {
      "key": "aws-aws-application-auto-scaling",
      "name": "AWS Application Auto Scaling",
      "brand": "aws"
    },
    {
      "key": "aws-aws-application-discovery-service",
      "name": "AWS Application Discovery Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-application-discovery-service-aws-agentless-collector",
      "name": "AWS Application Discovery Service AWS Agentless Collector",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-application-discovery-service-aws-discovery-agent",
      "name": "AWS Application Discovery Service AWS Discovery Agent",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-application-discovery-service-migration-evaluator-collector",
      "name": "AWS Application Discovery Service Migration Evaluator Collector",
      "brand": "aws"
    },
    {
      "key": "aws-aws-application-migration-service",
      "name": "AWS Application Migration Service",
      "brand": "aws"
    },
    {
      "key": "aws-aws-appsync",
      "name": "AWS Appsync",
      "brand": "aws"
    },
    {
      "key": "aws-aws-artifact",
      "name": "AWS Artifact",
      "brand": "aws"
    },
    {
      "key": "aws-aws-audit-manager",
      "name": "AWS Audit Manager",
      "brand": "aws"
    },
    {
      "key": "aws-aws-auto-scaling",
      "name": "AWS Auto Scaling",
      "brand": "aws"
    },
    {
      "key": "aws-aws-b2b-data-interchange",
      "name": "AWS B2b Data Interchange",
      "brand": "aws"
    },
    {
      "key": "aws-aws-backint-agent",
      "name": "AWS Backint Agent",
      "brand": "aws"
    },
    {
      "key": "aws-aws-backup",
      "name": "AWS Backup",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-audit-manager",
      "name": "AWS Backup Audit Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-aws-backup-for-aws-cloudformation",
      "name": "AWS Backup AWS Backup For AWS Cloudformation",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-aws-backup-support-for-amazon-fsx-for-netapp-ontap",
      "name": "AWS Backup AWS Backup Support For Amazon Fsx For Netapp Ontap",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-aws-backup-support-for-amazon-s3",
      "name": "AWS Backup AWS Backup Support For Amazon S3",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-aws-backup-support-for-vmware-workloads",
      "name": "AWS Backup AWS Backup Support For Vmware Workloads",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-backup-plan",
      "name": "AWS Backup Backup Plan",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-backup-restore",
      "name": "AWS Backup Backup Restore",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-backup-vault",
      "name": "AWS Backup Backup Vault",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-compliance-reporting",
      "name": "AWS Backup Compliance Reporting",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-compute",
      "name": "AWS Backup Compute",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-database",
      "name": "AWS Backup Database",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-gateway",
      "name": "AWS Backup Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-legal-hold",
      "name": "AWS Backup Legal Hold",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-recovery-point-objective",
      "name": "AWS Backup Recovery Point Objective",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-recovery-time-objective",
      "name": "AWS Backup Recovery Time Objective",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-storage",
      "name": "AWS Backup Storage",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-vault-lock",
      "name": "AWS Backup Vault Lock",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-virtual-machine",
      "name": "AWS Backup Virtual Machine",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-backup-virtual-machine-monitor",
      "name": "AWS Backup Virtual Machine Monitor",
      "brand": "aws"
    },
    {
      "key": "aws-aws-batch",
      "name": "AWS Batch",
      "brand": "aws"
    },
    {
      "key": "aws-aws-billing-conductor",
      "name": "AWS Billing Conductor",
      "brand": "aws"
    },
    {
      "key": "aws-aws-budgets",
      "name": "AWS Budgets",
      "brand": "aws"
    },
    {
      "key": "aws-aws-certificate-manager",
      "name": "AWS Certificate Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-certificate-manager-certificate-authority",
      "name": "AWS Certificate Manager Certificate Authority",
      "brand": "aws"
    },
    {
      "key": "aws-aws-chatbot",
      "name": "AWS Chatbot",
      "brand": "aws"
    },
    {
      "key": "aws-aws-clean-rooms",
      "name": "AWS Clean Rooms",
      "brand": "aws"
    },
    {
      "key": "aws-aws-client-vpn",
      "name": "AWS Client VPN",
      "brand": "aws"
    },
    {
      "key": "aws-group-aws-cloud",
      "name": "AWS Cloud",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloud-control-api",
      "name": "AWS Cloud Control API",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloud-development-kit",
      "name": "AWS Cloud Development Kit",
      "brand": "aws"
    },
    {
      "key": "aws-group-aws-cloud-logo",
      "name": "AWS Cloud Logo",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloud-map",
      "name": "AWS Cloud Map",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud-map-namespace",
      "name": "AWS Cloud Map Namespace",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud-map-resource",
      "name": "AWS Cloud Map Resource",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud-map-service",
      "name": "AWS Cloud Map Service",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloud-wan",
      "name": "AWS Cloud Wan",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud-wan-core-network-edge",
      "name": "AWS Cloud Wan Core Network Edge",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud-wan-segment-network",
      "name": "AWS Cloud Wan Segment Network",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud-wan-transit-gateway-route-table-attachment",
      "name": "AWS Cloud Wan Transit Gateway Route Table Attachment",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloud9",
      "name": "AWS Cloud9",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloud9-cloud9",
      "name": "AWS Cloud9 Cloud9",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloudformation",
      "name": "AWS Cloudformation",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloudformation-change-set",
      "name": "AWS Cloudformation Change Set",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloudformation-stack",
      "name": "AWS Cloudformation Stack",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloudformation-template",
      "name": "AWS Cloudformation Template",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloudhsm",
      "name": "AWS Cloudhsm",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloudshell",
      "name": "AWS Cloudshell",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cloudtrail",
      "name": "AWS Cloudtrail",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-cloudtrail-cloudtrail-lake",
      "name": "AWS Cloudtrail Cloudtrail Lake",
      "brand": "aws"
    },
    {
      "key": "aws-aws-codeartifact",
      "name": "AWS Codeartifact",
      "brand": "aws"
    },
    {
      "key": "aws-aws-codebuild",
      "name": "AWS Codebuild",
      "brand": "aws"
    },
    {
      "key": "aws-aws-codecommit",
      "name": "AWS Codecommit",
      "brand": "aws"
    },
    {
      "key": "aws-aws-codedeploy",
      "name": "AWS Codedeploy",
      "brand": "aws"
    },
    {
      "key": "aws-aws-codepipeline",
      "name": "AWS Codepipeline",
      "brand": "aws"
    },
    {
      "key": "aws-aws-command-line-interface",
      "name": "AWS Command Line Interface",
      "brand": "aws"
    },
    {
      "key": "aws-aws-compute-optimizer",
      "name": "AWS Compute Optimizer",
      "brand": "aws"
    },
    {
      "key": "aws-aws-config",
      "name": "AWS Config",
      "brand": "aws"
    },
    {
      "key": "aws-aws-console-mobile-application",
      "name": "AWS Console Mobile Application",
      "brand": "aws"
    },
    {
      "key": "aws-aws-control-tower",
      "name": "AWS Control Tower",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cost-and-usage-report",
      "name": "AWS Cost And Usage Report",
      "brand": "aws"
    },
    {
      "key": "aws-aws-cost-explorer",
      "name": "AWS Cost Explorer",
      "brand": "aws"
    },
    {
      "key": "aws-aws-data-exchange",
      "name": "AWS Data Exchange",
      "brand": "aws"
    },
    {
      "key": "aws-aws-data-transfer-terminal",
      "name": "AWS Data Transfer Terminal",
      "brand": "aws"
    },
    {
      "key": "aws-aws-database-migration-service",
      "name": "AWS Database Migration Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-database-migration-service-database-migration-workflow-or-job",
      "name": "AWS Database Migration Service Database Migration Workflow Or Job",
      "brand": "aws"
    },
    {
      "key": "aws-aws-datasync",
      "name": "AWS Datasync",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-datasync-agent",
      "name": "AWS Datasync Agent",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-datasync-discovery",
      "name": "AWS Datasync Discovery",
      "brand": "aws"
    },
    {
      "key": "aws-aws-deadline-cloud",
      "name": "AWS Deadline Cloud",
      "brand": "aws"
    },
    {
      "key": "aws-aws-deep-learning-amis",
      "name": "AWS Deep Learning Amis",
      "brand": "aws"
    },
    {
      "key": "aws-aws-deep-learning-containers",
      "name": "AWS Deep Learning Containers",
      "brand": "aws"
    },
    {
      "key": "aws-aws-deepracer",
      "name": "AWS Deepracer",
      "brand": "aws"
    },
    {
      "key": "aws-aws-device-farm",
      "name": "AWS Device Farm",
      "brand": "aws"
    },
    {
      "key": "aws-aws-devops-agent",
      "name": "AWS Devops Agent",
      "brand": "aws"
    },
    {
      "key": "aws-aws-direct-connect",
      "name": "AWS Direct Connect",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-direct-connect-gateway",
      "name": "AWS Direct Connect Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-aws-directory-service",
      "name": "AWS Directory Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-directory-service-ad-connector",
      "name": "AWS Directory Service Ad Connector",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-directory-service-aws-managed-microsoft-ad",
      "name": "AWS Directory Service AWS Managed Microsoft Ad",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-directory-service-simple-ad",
      "name": "AWS Directory Service Simple Ad",
      "brand": "aws"
    },
    {
      "key": "aws-aws-distro-for-opentelemetry",
      "name": "AWS Distro For Opentelemetry",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elastic-beanstalk",
      "name": "AWS Elastic Beanstalk",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-elastic-beanstalk-application",
      "name": "AWS Elastic Beanstalk Application",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-elastic-beanstalk-deployment",
      "name": "AWS Elastic Beanstalk Deployment",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elastic-disaster-recovery",
      "name": "AWS Elastic Disaster Recovery",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-appliances-software",
      "name": "AWS Elemental Appliances Software",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-conductor",
      "name": "AWS Elemental Conductor",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-delta",
      "name": "AWS Elemental Delta",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-link",
      "name": "AWS Elemental Link",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-live",
      "name": "AWS Elemental Live",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-mediaconnect",
      "name": "AWS Elemental Mediaconnect",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-elemental-mediaconnect-mediaconnect-gateway",
      "name": "AWS Elemental Mediaconnect Mediaconnect Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-mediaconvert",
      "name": "AWS Elemental Mediaconvert",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-medialive",
      "name": "AWS Elemental Medialive",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-mediapackage",
      "name": "AWS Elemental Mediapackage",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-mediastore",
      "name": "AWS Elemental Mediastore",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-mediatailor",
      "name": "AWS Elemental Mediatailor",
      "brand": "aws"
    },
    {
      "key": "aws-aws-elemental-server",
      "name": "AWS Elemental Server",
      "brand": "aws"
    },
    {
      "key": "aws-aws-end-user-messaging",
      "name": "AWS End User Messaging",
      "brand": "aws"
    },
    {
      "key": "aws-aws-entity-resolution",
      "name": "AWS Entity Resolution",
      "brand": "aws"
    },
    {
      "key": "aws-aws-express-workflows",
      "name": "AWS Express Workflows",
      "brand": "aws"
    },
    {
      "key": "aws-aws-fargate",
      "name": "AWS Fargate",
      "brand": "aws"
    },
    {
      "key": "aws-aws-fault-injection-service",
      "name": "AWS Fault Injection Service",
      "brand": "aws"
    },
    {
      "key": "aws-aws-firewall-manager",
      "name": "AWS Firewall Manager",
      "brand": "aws"
    },
    {
      "key": "aws-aws-global-accelerator",
      "name": "AWS Global Accelerator",
      "brand": "aws"
    },
    {
      "key": "aws-aws-glue",
      "name": "AWS Glue",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-glue-aws-glue-for-ray",
      "name": "AWS Glue AWS Glue For Ray",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-glue-crawler",
      "name": "AWS Glue Crawler",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-glue-data-catalog",
      "name": "AWS Glue Data Catalog",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-glue-data-quality",
      "name": "AWS Glue Data Quality",
      "brand": "aws"
    },
    {
      "key": "aws-aws-glue-databrew",
      "name": "AWS Glue Databrew",
      "brand": "aws"
    },
    {
      "key": "aws-aws-ground-station",
      "name": "AWS Ground Station",
      "brand": "aws"
    },
    {
      "key": "aws-aws-health-dashboard",
      "name": "AWS Health Dashboard",
      "brand": "aws"
    },
    {
      "key": "aws-aws-healthimaging",
      "name": "AWS Healthimaging",
      "brand": "aws"
    },
    {
      "key": "aws-aws-healthlake",
      "name": "AWS Healthlake",
      "brand": "aws"
    },
    {
      "key": "aws-aws-healthomics",
      "name": "AWS Healthomics",
      "brand": "aws"
    },
    {
      "key": "aws-aws-healthscribe",
      "name": "AWS Healthscribe",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iam-identity-center",
      "name": "AWS IAM Identity Center",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-add-on",
      "name": "AWS Identity Access Management Add On",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-aws-sts",
      "name": "AWS Identity Access Management AWS Sts",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-aws-sts-alternate",
      "name": "AWS Identity Access Management AWS Sts Alternate",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-data-encryption-key",
      "name": "AWS Identity Access Management Data Encryption Key",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-encrypted-data",
      "name": "AWS Identity Access Management Encrypted Data",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-iam-access-analyzer",
      "name": "AWS Identity Access Management IAM Access Analyzer",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-iam-roles-anywhere",
      "name": "AWS Identity Access Management IAM Roles Anywhere",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-long-term-security-credential",
      "name": "AWS Identity Access Management Long Term Security Credential",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-mfa-token",
      "name": "AWS Identity Access Management Mfa Token",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-permissions",
      "name": "AWS Identity Access Management Permissions",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-role",
      "name": "AWS Identity Access Management Role",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-identity-access-management-temporary-security-credential",
      "name": "AWS Identity Access Management Temporary Security Credential",
      "brand": "aws"
    },
    {
      "key": "aws-aws-identity-and-access-management",
      "name": "AWS Identity And Access Management",
      "brand": "aws"
    },
    {
      "key": "aws-aws-infrastructure-composer",
      "name": "AWS Infrastructure Composer",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-action",
      "name": "AWS IoT Action",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-actuator",
      "name": "AWS IoT Actuator",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-alexa-enabled-device",
      "name": "AWS IoT Alexa Enabled Device",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-alexa-skill",
      "name": "AWS IoT Alexa Skill",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-alexa-voice-service",
      "name": "AWS IoT Alexa Voice Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-certificate",
      "name": "AWS IoT Certificate",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-core",
      "name": "AWS IoT Core",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-core-device-advisor",
      "name": "AWS IoT Core Device Advisor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-core-device-location",
      "name": "AWS IoT Core Device Location",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-desired-state",
      "name": "AWS IoT Desired State",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-device-defender",
      "name": "AWS IoT Device Defender",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-device-defender-iot-device-jobs",
      "name": "AWS IoT Device Defender IoT Device Jobs",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-device-gateway",
      "name": "AWS IoT Device Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-device-management",
      "name": "AWS IoT Device Management",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-device-management-fleet-hub",
      "name": "AWS IoT Device Management Fleet Hub",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-echo",
      "name": "AWS IoT Echo",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-events",
      "name": "AWS IoT Events",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-expresslink",
      "name": "AWS IoT Expresslink",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-fire-tv",
      "name": "AWS IoT Fire TV",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-fire-tv-stick",
      "name": "AWS IoT Fire TV Stick",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-fleetwise",
      "name": "AWS IoT Fleetwise",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-greengrass",
      "name": "AWS IoT Greengrass",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-artifact",
      "name": "AWS IoT Greengrass Artifact",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-component",
      "name": "AWS IoT Greengrass Component",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-component-machine-learning",
      "name": "AWS IoT Greengrass Component Machine Learning",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-component-nucleus",
      "name": "AWS IoT Greengrass Component Nucleus",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-component-private",
      "name": "AWS IoT Greengrass Component Private",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-component-public",
      "name": "AWS IoT Greengrass Component Public",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-connector",
      "name": "AWS IoT Greengrass Connector",
      "brand": "aws"
    },
    {
      "key": "aws-group-aws-iot-greengrass-deployment",
      "name": "AWS IoT Greengrass Deployment",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-interprocess-communication",
      "name": "AWS IoT Greengrass Interprocess Communication",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-protocol",
      "name": "AWS IoT Greengrass Protocol",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-recipe",
      "name": "AWS IoT Greengrass Recipe",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-greengrass-stream-manager",
      "name": "AWS IoT Greengrass Stream Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-http-protocol",
      "name": "AWS IoT Http Protocol",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-http2-protocol",
      "name": "AWS IoT Http2 Protocol",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-lambda-function",
      "name": "AWS IoT Lambda Function",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-lorawan-protocol",
      "name": "AWS IoT Lorawan Protocol",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-mqtt-protocol",
      "name": "AWS IoT MQTT Protocol",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-over-air-update",
      "name": "AWS IoT Over Air Update",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-policy",
      "name": "AWS IoT Policy",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-reported-state",
      "name": "AWS IoT Reported State",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sailboat",
      "name": "AWS IoT Sailboat",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sensor",
      "name": "AWS IoT Sensor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-servo",
      "name": "AWS IoT Servo",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-shadow",
      "name": "AWS IoT Shadow",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-simulator",
      "name": "AWS IoT Simulator",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-sitewise",
      "name": "AWS IoT Sitewise",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sitewise-asset",
      "name": "AWS IoT Sitewise Asset",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sitewise-asset-hierarchy",
      "name": "AWS IoT Sitewise Asset Hierarchy",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sitewise-asset-model",
      "name": "AWS IoT Sitewise Asset Model",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sitewise-asset-properties",
      "name": "AWS IoT Sitewise Asset Properties",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-sitewise-data-streams",
      "name": "AWS IoT Sitewise Data Streams",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-bank",
      "name": "AWS IoT Thing Bank",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-bicycle",
      "name": "AWS IoT Thing Bicycle",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-camera",
      "name": "AWS IoT Thing Camera",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-car",
      "name": "AWS IoT Thing Car",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-cart",
      "name": "AWS IoT Thing Cart",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-coffee-pot",
      "name": "AWS IoT Thing Coffee Pot",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-door-lock",
      "name": "AWS IoT Thing Door Lock",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-factory",
      "name": "AWS IoT Thing Factory",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-freertos-device",
      "name": "AWS IoT Thing Freertos Device",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-generic",
      "name": "AWS IoT Thing Generic",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-house",
      "name": "AWS IoT Thing House",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-humidity-sensor",
      "name": "AWS IoT Thing Humidity Sensor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-industrial-pc",
      "name": "AWS IoT Thing Industrial Pc",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-lightbulb",
      "name": "AWS IoT Thing Lightbulb",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-medical-emergency",
      "name": "AWS IoT Thing Medical Emergency",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-plc",
      "name": "AWS IoT Thing Plc",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-police-emergency",
      "name": "AWS IoT Thing Police Emergency",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-relay",
      "name": "AWS IoT Thing Relay",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-stacklight",
      "name": "AWS IoT Thing Stacklight",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-temperature-humidity-sensor",
      "name": "AWS IoT Thing Temperature Humidity Sensor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-temperature-sensor",
      "name": "AWS IoT Thing Temperature Sensor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-temperature-vibration-sensor",
      "name": "AWS IoT Thing Temperature Vibration Sensor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-thermostat",
      "name": "AWS IoT Thing Thermostat",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-travel",
      "name": "AWS IoT Thing Travel",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-utility",
      "name": "AWS IoT Thing Utility",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-vibration-sensor",
      "name": "AWS IoT Thing Vibration Sensor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-thing-windfarm",
      "name": "AWS IoT Thing Windfarm",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-iot-topic",
      "name": "AWS IoT Topic",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iot-twinmaker",
      "name": "AWS IoT Twinmaker",
      "brand": "aws"
    },
    {
      "key": "aws-aws-iq",
      "name": "AWS Iq",
      "brand": "aws"
    },
    {
      "key": "aws-aws-key-management-service",
      "name": "AWS Key Management Service",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-key-management-service-external-key-store",
      "name": "AWS Key Management Service External Key Store",
      "brand": "aws"
    },
    {
      "key": "aws-aws-lake-formation",
      "name": "AWS Lake Formation",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-lake-formation-data-lake",
      "name": "AWS Lake Formation Data Lake",
      "brand": "aws"
    },
    {
      "key": "aws-aws-lambda",
      "name": "AWS Lambda",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-lambda-lambda-function",
      "name": "AWS Lambda Lambda Function",
      "brand": "aws"
    },
    {
      "key": "aws-aws-launch-wizard",
      "name": "AWS Launch Wizard",
      "brand": "aws"
    },
    {
      "key": "aws-aws-license-manager",
      "name": "AWS License Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-license-manager-application-discovery",
      "name": "AWS License Manager Application Discovery",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-license-manager-license-blending",
      "name": "AWS License Manager License Blending",
      "brand": "aws"
    },
    {
      "key": "aws-aws-local-zones",
      "name": "AWS Local Zones",
      "brand": "aws"
    },
    {
      "key": "aws-aws-mainframe-modernization",
      "name": "AWS Mainframe Modernization",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-mainframe-modernization-analyzer",
      "name": "AWS Mainframe Modernization Analyzer",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-mainframe-modernization-compiler",
      "name": "AWS Mainframe Modernization Compiler",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-mainframe-modernization-converter",
      "name": "AWS Mainframe Modernization Converter",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-mainframe-modernization-developer",
      "name": "AWS Mainframe Modernization Developer",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-mainframe-modernization-runtime",
      "name": "AWS Mainframe Modernization Runtime",
      "brand": "aws"
    },
    {
      "key": "aws-aws-managed-services",
      "name": "AWS Managed Services",
      "brand": "aws"
    },
    {
      "key": "aws-aws-management-console",
      "name": "AWS Management Console",
      "brand": "aws"
    },
    {
      "key": "aws-aws-marketplace-dark",
      "name": "AWS Marketplace Dark",
      "brand": "aws"
    },
    {
      "key": "aws-aws-marketplace-light",
      "name": "AWS Marketplace Light",
      "brand": "aws"
    },
    {
      "key": "aws-aws-migration-evaluator",
      "name": "AWS Migration Evaluator",
      "brand": "aws"
    },
    {
      "key": "aws-aws-migration-hub",
      "name": "AWS Migration Hub",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-migration-hub-refactor-spaces-applications",
      "name": "AWS Migration Hub Refactor Spaces Applications",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-migration-hub-refactor-spaces-environments",
      "name": "AWS Migration Hub Refactor Spaces Environments",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-migration-hub-refactor-spaces-services",
      "name": "AWS Migration Hub Refactor Spaces Services",
      "brand": "aws"
    },
    {
      "key": "aws-aws-network-firewall",
      "name": "AWS Network Firewall",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-network-firewall-endpoints",
      "name": "AWS Network Firewall Endpoints",
      "brand": "aws"
    },
    {
      "key": "aws-aws-neuron",
      "name": "AWS Neuron",
      "brand": "aws"
    },
    {
      "key": "aws-aws-nitro-enclaves",
      "name": "AWS Nitro Enclaves",
      "brand": "aws"
    },
    {
      "key": "aws-aws-organizations",
      "name": "AWS Organizations",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-organizations-account",
      "name": "AWS Organizations Account",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-organizations-management-account",
      "name": "AWS Organizations Management Account",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-organizations-organizational-unit",
      "name": "AWS Organizations Organizational Unit",
      "brand": "aws"
    },
    {
      "key": "aws-aws-outposts-family",
      "name": "AWS Outposts Family",
      "brand": "aws"
    },
    {
      "key": "aws-aws-outposts-rack",
      "name": "AWS Outposts Rack",
      "brand": "aws"
    },
    {
      "key": "aws-aws-outposts-servers",
      "name": "AWS Outposts Servers",
      "brand": "aws"
    },
    {
      "key": "aws-aws-panorama",
      "name": "AWS Panorama",
      "brand": "aws"
    },
    {
      "key": "aws-aws-parallel-cluster",
      "name": "AWS Parallel Cluster",
      "brand": "aws"
    },
    {
      "key": "aws-aws-parallel-computing-service",
      "name": "AWS Parallel Computing Service",
      "brand": "aws"
    },
    {
      "key": "aws-aws-partner-central",
      "name": "AWS Partner Central",
      "brand": "aws"
    },
    {
      "key": "aws-aws-payment-cryptography",
      "name": "AWS Payment Cryptography",
      "brand": "aws"
    },
    {
      "key": "aws-aws-private-certificate-authority",
      "name": "AWS Private Certificate Authority",
      "brand": "aws"
    },
    {
      "key": "aws-aws-privatelink",
      "name": "AWS Privatelink",
      "brand": "aws"
    },
    {
      "key": "aws-aws-professional-services",
      "name": "AWS Professional Services",
      "brand": "aws"
    },
    {
      "key": "aws-aws-proton",
      "name": "AWS Proton",
      "brand": "aws"
    },
    {
      "key": "aws-aws-repost",
      "name": "AWS Repost",
      "brand": "aws"
    },
    {
      "key": "aws-aws-repost-private",
      "name": "AWS Repost Private",
      "brand": "aws"
    },
    {
      "key": "aws-aws-resilience-hub",
      "name": "AWS Resilience Hub",
      "brand": "aws"
    },
    {
      "key": "aws-aws-resource-access-manager",
      "name": "AWS Resource Access Manager",
      "brand": "aws"
    },
    {
      "key": "aws-aws-resource-explorer",
      "name": "AWS Resource Explorer",
      "brand": "aws"
    },
    {
      "key": "aws-aws-rtb-fabric",
      "name": "AWS Rtb Fabric",
      "brand": "aws"
    },
    {
      "key": "aws-aws-secrets-manager",
      "name": "AWS Secrets Manager",
      "brand": "aws"
    },
    {
      "key": "aws-aws-security-agent",
      "name": "AWS Security Agent",
      "brand": "aws"
    },
    {
      "key": "aws-aws-security-hub",
      "name": "AWS Security Hub",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-security-hub-finding",
      "name": "AWS Security Hub Finding",
      "brand": "aws"
    },
    {
      "key": "aws-aws-security-incident-response",
      "name": "AWS Security Incident Response",
      "brand": "aws"
    },
    {
      "key": "aws-aws-serverless-application-repository",
      "name": "AWS Serverless Application Repository",
      "brand": "aws"
    },
    {
      "key": "aws-aws-service-catalog",
      "name": "AWS Service Catalog",
      "brand": "aws"
    },
    {
      "key": "aws-aws-service-management-connector",
      "name": "AWS Service Management Connector",
      "brand": "aws"
    },
    {
      "key": "aws-aws-shield",
      "name": "AWS Shield",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-shield-aws-shield-advanced",
      "name": "AWS Shield AWS Shield Advanced",
      "brand": "aws"
    },
    {
      "key": "aws-aws-signer",
      "name": "AWS Signer",
      "brand": "aws"
    },
    {
      "key": "aws-aws-simspace-weaver",
      "name": "AWS Simspace Weaver",
      "brand": "aws"
    },
    {
      "key": "aws-aws-site-to-site-vpn",
      "name": "AWS Site To Site VPN",
      "brand": "aws"
    },
    {
      "key": "aws-aws-snowball",
      "name": "AWS Snowball",
      "brand": "aws"
    },
    {
      "key": "aws-aws-snowball-edge",
      "name": "AWS Snowball Edge",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-snowball-snowball-import-export",
      "name": "AWS Snowball Snowball Import Export",
      "brand": "aws"
    },
    {
      "key": "aws-aws-step-functions",
      "name": "AWS Step Functions",
      "brand": "aws"
    },
    {
      "key": "aws-aws-storage-gateway",
      "name": "AWS Storage Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-amazon-fsx-file-gateway",
      "name": "AWS Storage Gateway Amazon Fsx File Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-amazon-s3-file-gateway",
      "name": "AWS Storage Gateway Amazon S3 File Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-cached-volume",
      "name": "AWS Storage Gateway Cached Volume",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-file-gateway",
      "name": "AWS Storage Gateway File Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-noncached-volume",
      "name": "AWS Storage Gateway Noncached Volume",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-tape-gateway",
      "name": "AWS Storage Gateway Tape Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-virtual-tape-library",
      "name": "AWS Storage Gateway Virtual Tape Library",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-storage-gateway-volume-gateway",
      "name": "AWS Storage Gateway Volume Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-aws-supply-chain",
      "name": "AWS Supply Chain",
      "brand": "aws"
    },
    {
      "key": "aws-aws-support",
      "name": "AWS Support",
      "brand": "aws"
    },
    {
      "key": "aws-aws-systems-manager",
      "name": "AWS Systems Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-application-manager",
      "name": "AWS Systems Manager Application Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-automation",
      "name": "AWS Systems Manager Automation",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-change-calendar",
      "name": "AWS Systems Manager Change Calendar",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-change-manager",
      "name": "AWS Systems Manager Change Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-compliance",
      "name": "AWS Systems Manager Compliance",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-distributor",
      "name": "AWS Systems Manager Distributor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-documents",
      "name": "AWS Systems Manager Documents",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-incident-manager",
      "name": "AWS Systems Manager Incident Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-inventory",
      "name": "AWS Systems Manager Inventory",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-maintenance-windows",
      "name": "AWS Systems Manager Maintenance Windows",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-opscenter",
      "name": "AWS Systems Manager Opscenter",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-parameter-store",
      "name": "AWS Systems Manager Parameter Store",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-patch-manager",
      "name": "AWS Systems Manager Patch Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-run-command",
      "name": "AWS Systems Manager Run Command",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-session-manager",
      "name": "AWS Systems Manager Session Manager",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-systems-manager-state-manager",
      "name": "AWS Systems Manager State Manager",
      "brand": "aws"
    },
    {
      "key": "aws-aws-telco-network-builder",
      "name": "AWS Telco Network Builder",
      "brand": "aws"
    },
    {
      "key": "aws-aws-thinkbox-deadline",
      "name": "AWS Thinkbox Deadline",
      "brand": "aws"
    },
    {
      "key": "aws-aws-thinkbox-frost",
      "name": "AWS Thinkbox Frost",
      "brand": "aws"
    },
    {
      "key": "aws-aws-thinkbox-krakatoa",
      "name": "AWS Thinkbox Krakatoa",
      "brand": "aws"
    },
    {
      "key": "aws-aws-thinkbox-stoke",
      "name": "AWS Thinkbox Stoke",
      "brand": "aws"
    },
    {
      "key": "aws-aws-thinkbox-xmesh",
      "name": "AWS Thinkbox Xmesh",
      "brand": "aws"
    },
    {
      "key": "aws-aws-tools-and-sdks",
      "name": "AWS Tools And Sdks",
      "brand": "aws"
    },
    {
      "key": "aws-aws-training-certification",
      "name": "AWS Training Certification",
      "brand": "aws"
    },
    {
      "key": "aws-aws-transfer-family",
      "name": "AWS Transfer Family",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-transfer-family-aws-as2",
      "name": "AWS Transfer Family AWS As2",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-transfer-family-aws-ftp",
      "name": "AWS Transfer Family AWS Ftp",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-transfer-family-aws-ftps",
      "name": "AWS Transfer Family AWS Ftps",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-transfer-family-aws-sftp",
      "name": "AWS Transfer Family AWS Sftp",
      "brand": "aws"
    },
    {
      "key": "aws-aws-transform",
      "name": "AWS Transform",
      "brand": "aws"
    },
    {
      "key": "aws-aws-transit-gateway",
      "name": "AWS Transit Gateway",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-transit-gateway-attachment",
      "name": "AWS Transit Gateway Attachment",
      "brand": "aws"
    },
    {
      "key": "aws-aws-trusted-advisor",
      "name": "AWS Trusted Advisor",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-trusted-advisor-checklist",
      "name": "AWS Trusted Advisor Checklist",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-trusted-advisor-checklist-cost",
      "name": "AWS Trusted Advisor Checklist Cost",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-trusted-advisor-checklist-fault-tolerant",
      "name": "AWS Trusted Advisor Checklist Fault Tolerant",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-trusted-advisor-checklist-performance",
      "name": "AWS Trusted Advisor Checklist Performance",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-trusted-advisor-checklist-security",
      "name": "AWS Trusted Advisor Checklist Security",
      "brand": "aws"
    },
    {
      "key": "aws-aws-user-notifications",
      "name": "AWS User Notifications",
      "brand": "aws"
    },
    {
      "key": "aws-aws-verified-access",
      "name": "AWS Verified Access",
      "brand": "aws"
    },
    {
      "key": "aws-aws-waf",
      "name": "AWS WAF",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-bad-bot",
      "name": "AWS WAF Bad Bot",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-bot",
      "name": "AWS WAF Bot",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-bot-control",
      "name": "AWS WAF Bot Control",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-filtering-rule",
      "name": "AWS WAF Filtering Rule",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-labels",
      "name": "AWS WAF Labels",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-managed-rule",
      "name": "AWS WAF Managed Rule",
      "brand": "aws"
    },
    {
      "key": "aws-res-aws-waf-rule",
      "name": "AWS WAF Rule",
      "brand": "aws"
    },
    {
      "key": "aws-aws-wavelength",
      "name": "AWS Wavelength",
      "brand": "aws"
    },
    {
      "key": "aws-aws-well-architected-tool",
      "name": "AWS Well Architected Tool",
      "brand": "aws"
    },
    {
      "key": "aws-aws-wickr",
      "name": "AWS Wickr",
      "brand": "aws"
    },
    {
      "key": "aws-aws-x-ray",
      "name": "AWS X Ray",
      "brand": "aws"
    },
    {
      "key": "aws-cat-blockchain",
      "name": "Blockchain",
      "brand": "aws"
    },
    {
      "key": "aws-bottlerocket",
      "name": "Bottlerocket",
      "brand": "aws"
    },
    {
      "key": "aws-cat-business-applications",
      "name": "Business Applications",
      "brand": "aws"
    },
    {
      "key": "aws-cat-cloud-financial-management",
      "name": "Cloud Financial Management",
      "brand": "aws"
    },
    {
      "key": "aws-cat-compute",
      "name": "Compute",
      "brand": "aws"
    },
    {
      "key": "aws-cat-containers",
      "name": "Containers",
      "brand": "aws"
    },
    {
      "key": "aws-group-corporate-data-center",
      "name": "Corporate Data Center",
      "brand": "aws"
    },
    {
      "key": "aws-cat-customer-enablement",
      "name": "Customer Enablement",
      "brand": "aws"
    },
    {
      "key": "aws-cat-customer-experience",
      "name": "Customer Experience",
      "brand": "aws"
    },
    {
      "key": "aws-cat-databases",
      "name": "Databases",
      "brand": "aws"
    },
    {
      "key": "aws-cat-developer-tools",
      "name": "Developer Tools",
      "brand": "aws"
    },
    {
      "key": "aws-group-ec2-instance-contents",
      "name": "EC2 Instance Contents",
      "brand": "aws"
    },
    {
      "key": "aws-elastic-fabric-adapter",
      "name": "Elastic Fabric Adapter",
      "brand": "aws"
    },
    {
      "key": "aws-elastic-load-balancing",
      "name": "Elastic Load Balancing",
      "brand": "aws"
    },
    {
      "key": "aws-res-elastic-load-balancing-application-load-balancer",
      "name": "Elastic Load Balancing Application Load Balancer",
      "brand": "aws"
    },
    {
      "key": "aws-res-elastic-load-balancing-classic-load-balancer",
      "name": "Elastic Load Balancing Classic Load Balancer",
      "brand": "aws"
    },
    {
      "key": "aws-res-elastic-load-balancing-gateway-load-balancer",
      "name": "Elastic Load Balancing Gateway Load Balancer",
      "brand": "aws"
    },
    {
      "key": "aws-res-elastic-load-balancing-network-load-balancer",
      "name": "Elastic Load Balancing Network Load Balancer",
      "brand": "aws"
    },
    {
      "key": "aws-cat-end-user-computing",
      "name": "End User Computing",
      "brand": "aws"
    },
    {
      "key": "aws-freertos",
      "name": "Freertos",
      "brand": "aws"
    },
    {
      "key": "aws-cat-front-end-web-mobile",
      "name": "Front End Web Mobile",
      "brand": "aws"
    },
    {
      "key": "aws-cat-games",
      "name": "Games",
      "brand": "aws"
    },
    {
      "key": "aws-cat-internet-of-things",
      "name": "Internet Of Things",
      "brand": "aws"
    },
    {
      "key": "aws-cat-management-tools",
      "name": "Management Tools",
      "brand": "aws"
    },
    {
      "key": "aws-cat-media-services",
      "name": "Media Services",
      "brand": "aws"
    },
    {
      "key": "aws-cat-migration-modernization",
      "name": "Migration Modernization",
      "brand": "aws"
    },
    {
      "key": "aws-cat-multicloud-and-hybrid",
      "name": "Multicloud And Hybrid",
      "brand": "aws"
    },
    {
      "key": "aws-cat-networking-content-delivery",
      "name": "Networking Content Delivery",
      "brand": "aws"
    },
    {
      "key": "aws-open-3d-engine",
      "name": "Open 3d Engine",
      "brand": "aws"
    },
    {
      "key": "aws-oracle-database-at-aws",
      "name": "Oracle Database At AWS",
      "brand": "aws"
    },
    {
      "key": "aws-group-private-subnet",
      "name": "Private Subnet",
      "brand": "aws"
    },
    {
      "key": "aws-group-public-subnet",
      "name": "Public Subnet",
      "brand": "aws"
    },
    {
      "key": "aws-pytorch-on-aws",
      "name": "Pytorch On AWS",
      "brand": "aws"
    },
    {
      "key": "aws-cat-quantum-technologies",
      "name": "Quantum Technologies",
      "brand": "aws"
    },
    {
      "key": "aws-red-hat-openshift-service-on-aws",
      "name": "Red Hat Openshift Service On AWS",
      "brand": "aws"
    },
    {
      "key": "aws-group-region",
      "name": "Region",
      "brand": "aws"
    },
    {
      "key": "aws-reserved-instance-reporting",
      "name": "Reserved Instance Reporting",
      "brand": "aws"
    },
    {
      "key": "aws-cat-satellite",
      "name": "Satellite",
      "brand": "aws"
    },
    {
      "key": "aws-savings-plans",
      "name": "Savings Plans",
      "brand": "aws"
    },
    {
      "key": "aws-cat-security-identity",
      "name": "Security Identity",
      "brand": "aws"
    },
    {
      "key": "aws-group-server-contents",
      "name": "Server Contents",
      "brand": "aws"
    },
    {
      "key": "aws-cat-serverless",
      "name": "Serverless",
      "brand": "aws"
    },
    {
      "key": "aws-group-spot-fleet",
      "name": "Spot Fleet",
      "brand": "aws"
    },
    {
      "key": "aws-cat-storage",
      "name": "Storage",
      "brand": "aws"
    },
    {
      "key": "aws-tensorflow-on-aws",
      "name": "Tensorflow On AWS",
      "brand": "aws"
    },
    {
      "key": "aws-group-virtual-private-cloud-vpc",
      "name": "Virtual Private Cloud VPC",
      "brand": "aws"
    }
  ],
  "azure": [
    {
      "key": "azure-abs-member",
      "name": "Abs Member",
      "brand": "azure"
    },
    {
      "key": "azure-active-directory-connect-health",
      "name": "Active Directory Connect Health",
      "brand": "azure"
    },
    {
      "key": "azure-activity-log",
      "name": "Activity Log",
      "brand": "azure"
    },
    {
      "key": "azure-administrative-units",
      "name": "Administrative Units",
      "brand": "azure"
    },
    {
      "key": "azure-advisor",
      "name": "Advisor",
      "brand": "azure"
    },
    {
      "key": "azure-ai-at-edge",
      "name": "AI At Edge",
      "brand": "azure"
    },
    {
      "key": "azure-ai-studio",
      "name": "AI Studio",
      "brand": "azure"
    },
    {
      "key": "azure-aks-automatic",
      "name": "Aks Automatic",
      "brand": "azure"
    },
    {
      "key": "azure-aks-istio",
      "name": "Aks Istio",
      "brand": "azure"
    },
    {
      "key": "azure-aks-network-policy",
      "name": "Aks Network Policy",
      "brand": "azure"
    },
    {
      "key": "azure-alerts",
      "name": "Alerts",
      "brand": "azure"
    },
    {
      "key": "azure-all-resources",
      "name": "All Resources",
      "brand": "azure"
    },
    {
      "key": "azure-analysis-services",
      "name": "Analysis Services",
      "brand": "azure"
    },
    {
      "key": "azure-anomaly-detector",
      "name": "Anomaly Detector",
      "brand": "azure"
    },
    {
      "key": "azure-api-center",
      "name": "API Center",
      "brand": "azure"
    },
    {
      "key": "azure-api-connections",
      "name": "API Connections",
      "brand": "azure"
    },
    {
      "key": "azure-api-management-services",
      "name": "API Management Services",
      "brand": "azure"
    },
    {
      "key": "azure-api-proxy",
      "name": "API Proxy",
      "brand": "azure"
    },
    {
      "key": "azure-app-compliance-automation",
      "name": "App Compliance Automation",
      "brand": "azure"
    },
    {
      "key": "azure-app-configuration",
      "name": "App Configuration",
      "brand": "azure"
    },
    {
      "key": "azure-app-registrations",
      "name": "App Registrations",
      "brand": "azure"
    },
    {
      "key": "azure-app-service-certificates",
      "name": "App Service Certificates",
      "brand": "azure"
    },
    {
      "key": "azure-app-service-domains",
      "name": "App Service Domains",
      "brand": "azure"
    },
    {
      "key": "azure-app-service-environments",
      "name": "App Service Environments",
      "brand": "azure"
    },
    {
      "key": "azure-app-service-plans",
      "name": "App Service Plans",
      "brand": "azure"
    },
    {
      "key": "azure-app-services",
      "name": "App Services",
      "brand": "azure"
    },
    {
      "key": "azure-app-space",
      "name": "App Space",
      "brand": "azure"
    },
    {
      "key": "azure-app-space-component",
      "name": "App Space Component",
      "brand": "azure"
    },
    {
      "key": "azure-applens",
      "name": "Applens",
      "brand": "azure"
    },
    {
      "key": "azure-application-gateway-containers",
      "name": "Application Gateway Containers",
      "brand": "azure"
    },
    {
      "key": "azure-application-gateways",
      "name": "Application Gateways",
      "brand": "azure"
    },
    {
      "key": "azure-application-group",
      "name": "Application Group",
      "brand": "azure"
    },
    {
      "key": "azure-application-insights",
      "name": "Application Insights",
      "brand": "azure"
    },
    {
      "key": "azure-application-security-groups",
      "name": "Application Security Groups",
      "brand": "azure"
    },
    {
      "key": "azure-aquila",
      "name": "Aquila",
      "brand": "azure"
    },
    {
      "key": "azure-arc-data-services",
      "name": "Arc Data Services",
      "brand": "azure"
    },
    {
      "key": "azure-arc-kubernetes",
      "name": "Arc Kubernetes",
      "brand": "azure"
    },
    {
      "key": "azure-arc-machines",
      "name": "Arc Machines",
      "brand": "azure"
    },
    {
      "key": "azure-arc-postgresql",
      "name": "Arc Postgresql",
      "brand": "azure"
    },
    {
      "key": "azure-arc-sql-managed-instance",
      "name": "Arc SQL Managed Instance",
      "brand": "azure"
    },
    {
      "key": "azure-arc-sql-server",
      "name": "Arc SQL Server",
      "brand": "azure"
    },
    {
      "key": "azure-atm-multistack",
      "name": "Atm Multistack",
      "brand": "azure"
    },
    {
      "key": "azure-auto-scale",
      "name": "Auto Scale",
      "brand": "azure"
    },
    {
      "key": "azure-automanaged-vm",
      "name": "Automanaged VM",
      "brand": "azure"
    },
    {
      "key": "azure-automation-accounts",
      "name": "Automation Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-availability-sets",
      "name": "Availability Sets",
      "brand": "azure"
    },
    {
      "key": "azure-avs-vm",
      "name": "Avs VM",
      "brand": "azure"
    },
    {
      "key": "azure-azure-a",
      "name": "Azure A",
      "brand": "azure"
    },
    {
      "key": "azure-azure-ad-b2c",
      "name": "Azure Ad B2c",
      "brand": "azure"
    },
    {
      "key": "azure-azure-api-for-fhir",
      "name": "Azure API For Fhir",
      "brand": "azure"
    },
    {
      "key": "azure-azure-app-testing",
      "name": "Azure App Testing",
      "brand": "azure"
    },
    {
      "key": "azure-azure-applied-ai-services",
      "name": "Azure Applied AI Services",
      "brand": "azure"
    },
    {
      "key": "azure-azure-arc",
      "name": "Azure Arc",
      "brand": "azure"
    },
    {
      "key": "azure-azure-backup-center",
      "name": "Azure Backup Center",
      "brand": "azure"
    },
    {
      "key": "azure-azure-blockchain-service",
      "name": "Azure Blockchain Service",
      "brand": "azure"
    },
    {
      "key": "azure-azure-center-for-sap",
      "name": "Azure Center For Sap",
      "brand": "azure"
    },
    {
      "key": "azure-azure-chaos-studio",
      "name": "Azure Chaos Studio",
      "brand": "azure"
    },
    {
      "key": "azure-azure-cloud-shell",
      "name": "Azure Cloud Shell",
      "brand": "azure"
    },
    {
      "key": "azure-azure-communication-services",
      "name": "Azure Communication Services",
      "brand": "azure"
    },
    {
      "key": "azure-azure-communications-gateway",
      "name": "Azure Communications Gateway",
      "brand": "azure"
    },
    {
      "key": "azure-azure-compute-galleries",
      "name": "Azure Compute Galleries",
      "brand": "azure"
    },
    {
      "key": "azure-azure-consumption-commitment",
      "name": "Azure Consumption Commitment",
      "brand": "azure"
    },
    {
      "key": "azure-azure-container-storage",
      "name": "Azure Container Storage",
      "brand": "azure"
    },
    {
      "key": "azure-azure-cosmos-db",
      "name": "Azure Cosmos DB",
      "brand": "azure"
    },
    {
      "key": "azure-azure-data-catalog",
      "name": "Azure Data Catalog",
      "brand": "azure"
    },
    {
      "key": "azure-azure-data-explorer-clusters",
      "name": "Azure Data Explorer Clusters",
      "brand": "azure"
    },
    {
      "key": "azure-azure-database-mariadb-server",
      "name": "Azure Database Mariadb Server",
      "brand": "azure"
    },
    {
      "key": "azure-azure-database-migration-services",
      "name": "Azure Database Migration Services",
      "brand": "azure"
    },
    {
      "key": "azure-azure-database-mysql-server",
      "name": "Azure Database Mysql Server",
      "brand": "azure"
    },
    {
      "key": "azure-azure-database-postgresql-server",
      "name": "Azure Database Postgresql Server",
      "brand": "azure"
    },
    {
      "key": "azure-azure-database-postgresql-server-group",
      "name": "Azure Database Postgresql Server Group",
      "brand": "azure"
    },
    {
      "key": "azure-azure-databox-gateway",
      "name": "Azure Databox Gateway",
      "brand": "azure"
    },
    {
      "key": "azure-azure-databricks",
      "name": "Azure Databricks",
      "brand": "azure"
    },
    {
      "key": "azure-azure-deployment-environments",
      "name": "Azure Deployment Environments",
      "brand": "azure"
    },
    {
      "key": "azure-azure-dev-tunnels",
      "name": "Azure Dev Tunnels",
      "brand": "azure"
    },
    {
      "key": "azure-azure-devops",
      "name": "Azure Devops",
      "brand": "azure"
    },
    {
      "key": "azure-azure-edge-hardware-center",
      "name": "Azure Edge Hardware Center",
      "brand": "azure"
    },
    {
      "key": "azure-azure-experimentation-studio",
      "name": "Azure Experimentation Studio",
      "brand": "azure"
    },
    {
      "key": "azure-azure-fileshares",
      "name": "Azure Fileshares",
      "brand": "azure"
    },
    {
      "key": "azure-azure-firewall-manager",
      "name": "Azure Firewall Manager",
      "brand": "azure"
    },
    {
      "key": "azure-azure-firewall-policy",
      "name": "Azure Firewall Policy",
      "brand": "azure"
    },
    {
      "key": "azure-azure-hcp-cache",
      "name": "Azure Hcp Cache",
      "brand": "azure"
    },
    {
      "key": "azure-azure-hpc-workbenches",
      "name": "Azure HPC Workbenches",
      "brand": "azure"
    },
    {
      "key": "azure-azure-hybrid-center",
      "name": "Azure Hybrid Center",
      "brand": "azure"
    },
    {
      "key": "azure-azure-information-protection",
      "name": "Azure Information Protection",
      "brand": "azure"
    },
    {
      "key": "azure-azure-iot-operations",
      "name": "Azure IoT Operations",
      "brand": "azure"
    },
    {
      "key": "azure-azure-lighthouse",
      "name": "Azure Lighthouse",
      "brand": "azure"
    },
    {
      "key": "azure-azure-linux",
      "name": "Azure Linux",
      "brand": "azure"
    },
    {
      "key": "azure-azure-load-testing",
      "name": "Azure Load Testing",
      "brand": "azure"
    },
    {
      "key": "azure-azure-local",
      "name": "Azure Local",
      "brand": "azure"
    },
    {
      "key": "azure-azure-managed-grafana",
      "name": "Azure Managed Grafana",
      "brand": "azure"
    },
    {
      "key": "azure-azure-managed-redis",
      "name": "Azure Managed Redis",
      "brand": "azure"
    },
    {
      "key": "azure-azure-maps-accounts",
      "name": "Azure Maps Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-azure-media-service",
      "name": "Azure Media Service",
      "brand": "azure"
    },
    {
      "key": "azure-azure-migrate",
      "name": "Azure Migrate",
      "brand": "azure"
    },
    {
      "key": "azure-azure-monitor-dashboard",
      "name": "Azure Monitor Dashboard",
      "brand": "azure"
    },
    {
      "key": "azure-azure-monitor-pipeline",
      "name": "Azure Monitor Pipeline",
      "brand": "azure"
    },
    {
      "key": "azure-azure-monitors-for-sap-solutions",
      "name": "Azure Monitors For Sap Solutions",
      "brand": "azure"
    },
    {
      "key": "azure-azure-netapp-files",
      "name": "Azure Netapp Files",
      "brand": "azure"
    },
    {
      "key": "azure-azure-network-function-manager",
      "name": "Azure Network Function Manager",
      "brand": "azure"
    },
    {
      "key": "azure-azure-network-function-manager-functions",
      "name": "Azure Network Function Manager Functions",
      "brand": "azure"
    },
    {
      "key": "azure-azure-object-understanding",
      "name": "Azure Object Understanding",
      "brand": "azure"
    },
    {
      "key": "azure-azure-openai",
      "name": "Azure Openai",
      "brand": "azure"
    },
    {
      "key": "azure-azure-operator-5g-core",
      "name": "Azure Operator 5g Core",
      "brand": "azure"
    },
    {
      "key": "azure-azure-operator-insights",
      "name": "Azure Operator Insights",
      "brand": "azure"
    },
    {
      "key": "azure-azure-operator-nexus",
      "name": "Azure Operator Nexus",
      "brand": "azure"
    },
    {
      "key": "azure-azure-operator-service-manager",
      "name": "Azure Operator Service Manager",
      "brand": "azure"
    },
    {
      "key": "azure-azure-orbital",
      "name": "Azure Orbital",
      "brand": "azure"
    },
    {
      "key": "azure-azure-programmable-connectivity",
      "name": "Azure Programmable Connectivity",
      "brand": "azure"
    },
    {
      "key": "azure-azure-quotas",
      "name": "Azure Quotas",
      "brand": "azure"
    },
    {
      "key": "azure-azure-red-hat-openshift",
      "name": "Azure Red Hat Openshift",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sentinel",
      "name": "Azure Sentinel",
      "brand": "azure"
    },
    {
      "key": "azure-azure-service-bus",
      "name": "Azure Service Bus",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sphere",
      "name": "Azure Sphere",
      "brand": "azure"
    },
    {
      "key": "azure-azure-spring-apps",
      "name": "Azure Spring Apps",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sql",
      "name": "Azure SQL",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sql-edge",
      "name": "Azure SQL Edge",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sql-server-stretch-databases",
      "name": "Azure SQL Server Stretch Databases",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sql-vm",
      "name": "Azure SQL VM",
      "brand": "azure"
    },
    {
      "key": "azure-azure-stack",
      "name": "Azure Stack",
      "brand": "azure"
    },
    {
      "key": "azure-azure-stack-edge",
      "name": "Azure Stack Edge",
      "brand": "azure"
    },
    {
      "key": "azure-azure-stack-hci-sizer",
      "name": "Azure Stack Hci Sizer",
      "brand": "azure"
    },
    {
      "key": "azure-azure-storage-mover",
      "name": "Azure Storage Mover",
      "brand": "azure"
    },
    {
      "key": "azure-azure-support-center-blue",
      "name": "Azure Support Center Blue",
      "brand": "azure"
    },
    {
      "key": "azure-azure-sustainability",
      "name": "Azure Sustainability",
      "brand": "azure"
    },
    {
      "key": "azure-azure-synapse-analytics",
      "name": "Azure Synapse Analytics",
      "brand": "azure"
    },
    {
      "key": "azure-azure-token-service",
      "name": "Azure Token Service",
      "brand": "azure"
    },
    {
      "key": "azure-azure-video-indexer",
      "name": "Azure Video Indexer",
      "brand": "azure"
    },
    {
      "key": "azure-azure-virtual-desktop",
      "name": "Azure Virtual Desktop",
      "brand": "azure"
    },
    {
      "key": "azure-azure-vmware-solution",
      "name": "Azure Vmware Solution",
      "brand": "azure"
    },
    {
      "key": "azure-azure-workbooks",
      "name": "Azure Workbooks",
      "brand": "azure"
    },
    {
      "key": "azure-azureattestation",
      "name": "Azureattestation",
      "brand": "azure"
    },
    {
      "key": "azure-azurite",
      "name": "Azurite",
      "brand": "azure"
    },
    {
      "key": "azure-backlog",
      "name": "Backlog",
      "brand": "azure"
    },
    {
      "key": "azure-backup-vault",
      "name": "Backup Vault",
      "brand": "azure"
    },
    {
      "key": "azure-bare-metal-infrastructure",
      "name": "Bare Metal Infrastructure",
      "brand": "azure"
    },
    {
      "key": "azure-bastions",
      "name": "Bastions",
      "brand": "azure"
    },
    {
      "key": "azure-batch-accounts",
      "name": "Batch Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-batch-ai",
      "name": "Batch AI",
      "brand": "azure"
    },
    {
      "key": "azure-biz-talk",
      "name": "Biz Talk",
      "brand": "azure"
    },
    {
      "key": "azure-blob",
      "name": "Blob",
      "brand": "azure"
    },
    {
      "key": "azure-blob-block",
      "name": "Blob Block",
      "brand": "azure"
    },
    {
      "key": "azure-blob-page",
      "name": "Blob Page",
      "brand": "azure"
    },
    {
      "key": "azure-blockchain-applications",
      "name": "Blockchain Applications",
      "brand": "azure"
    },
    {
      "key": "azure-blueprints",
      "name": "Blueprints",
      "brand": "azure"
    },
    {
      "key": "azure-bonsai",
      "name": "Bonsai",
      "brand": "azure"
    },
    {
      "key": "azure-bot-services",
      "name": "Bot Services",
      "brand": "azure"
    },
    {
      "key": "azure-branch",
      "name": "Branch",
      "brand": "azure"
    },
    {
      "key": "azure-breeze",
      "name": "Breeze",
      "brand": "azure"
    },
    {
      "key": "azure-browser",
      "name": "Browser",
      "brand": "azure"
    },
    {
      "key": "azure-bug",
      "name": "Bug",
      "brand": "azure"
    },
    {
      "key": "azure-builds",
      "name": "Builds",
      "brand": "azure"
    },
    {
      "key": "azure-business-process-tracking",
      "name": "Business Process Tracking",
      "brand": "azure"
    },
    {
      "key": "azure-cache",
      "name": "Cache",
      "brand": "azure"
    },
    {
      "key": "azure-cache-redis",
      "name": "Cache Redis",
      "brand": "azure"
    },
    {
      "key": "azure-capacity",
      "name": "Capacity",
      "brand": "azure"
    },
    {
      "key": "azure-capacity-reservation-groups",
      "name": "Capacity Reservation Groups",
      "brand": "azure"
    },
    {
      "key": "azure-cdn-profiles",
      "name": "CDN Profiles",
      "brand": "azure"
    },
    {
      "key": "azure-central-service-instance-for-sap",
      "name": "Central Service Instance For Sap",
      "brand": "azure"
    },
    {
      "key": "azure-ceres",
      "name": "Ceres",
      "brand": "azure"
    },
    {
      "key": "azure-change-analysis",
      "name": "Change Analysis",
      "brand": "azure"
    },
    {
      "key": "azure-client-apps",
      "name": "Client Apps",
      "brand": "azure"
    },
    {
      "key": "azure-cloud-services-classic",
      "name": "Cloud Services Classic",
      "brand": "azure"
    },
    {
      "key": "azure-cloud-services-extended-support",
      "name": "Cloud Services Extended Support",
      "brand": "azure"
    },
    {
      "key": "azure-cloudtest",
      "name": "Cloudtest",
      "brand": "azure"
    },
    {
      "key": "azure-code",
      "name": "Code",
      "brand": "azure"
    },
    {
      "key": "azure-code-optimization",
      "name": "Code Optimization",
      "brand": "azure"
    },
    {
      "key": "azure-cognitive-search",
      "name": "Cognitive Search",
      "brand": "azure"
    },
    {
      "key": "azure-cognitive-services",
      "name": "Cognitive Services",
      "brand": "azure"
    },
    {
      "key": "azure-cognitive-services-decisions",
      "name": "Cognitive Services Decisions",
      "brand": "azure"
    },
    {
      "key": "azure-collaborative-service",
      "name": "Collaborative Service",
      "brand": "azure"
    },
    {
      "key": "azure-commit",
      "name": "Commit",
      "brand": "azure"
    },
    {
      "key": "azure-community-images",
      "name": "Community Images",
      "brand": "azure"
    },
    {
      "key": "azure-compliance",
      "name": "Compliance",
      "brand": "azure"
    },
    {
      "key": "azure-compliance-center",
      "name": "Compliance Center",
      "brand": "azure"
    },
    {
      "key": "azure-compute-fleet",
      "name": "Compute Fleet",
      "brand": "azure"
    },
    {
      "key": "azure-computer-vision",
      "name": "Computer Vision",
      "brand": "azure"
    },
    {
      "key": "azure-conditional-access",
      "name": "Conditional Access",
      "brand": "azure"
    },
    {
      "key": "azure-confidential-ledgers",
      "name": "Confidential Ledgers",
      "brand": "azure"
    },
    {
      "key": "azure-connected-cache",
      "name": "Connected Cache",
      "brand": "azure"
    },
    {
      "key": "azure-connected-vehicle-platform",
      "name": "Connected Vehicle Platform",
      "brand": "azure"
    },
    {
      "key": "azure-connections",
      "name": "Connections",
      "brand": "azure"
    },
    {
      "key": "azure-consortium",
      "name": "Consortium",
      "brand": "azure"
    },
    {
      "key": "azure-container-apps-environments",
      "name": "Container Apps Environments",
      "brand": "azure"
    },
    {
      "key": "azure-container-instances",
      "name": "Container Instances",
      "brand": "azure"
    },
    {
      "key": "azure-container-registries",
      "name": "Container Registries",
      "brand": "azure"
    },
    {
      "key": "azure-container-services-deprecated",
      "name": "Container Services Deprecated",
      "brand": "azure"
    },
    {
      "key": "azure-content-moderators",
      "name": "Content Moderators",
      "brand": "azure"
    },
    {
      "key": "azure-content-safety",
      "name": "Content Safety",
      "brand": "azure"
    },
    {
      "key": "azure-controls",
      "name": "Controls",
      "brand": "azure"
    },
    {
      "key": "azure-controls-horizontal",
      "name": "Controls Horizontal",
      "brand": "azure"
    },
    {
      "key": "azure-cost-alerts",
      "name": "Cost Alerts",
      "brand": "azure"
    },
    {
      "key": "azure-cost-analysis",
      "name": "Cost Analysis",
      "brand": "azure"
    },
    {
      "key": "azure-cost-budgets",
      "name": "Cost Budgets",
      "brand": "azure"
    },
    {
      "key": "azure-cost-export",
      "name": "Cost Export",
      "brand": "azure"
    },
    {
      "key": "azure-cost-management",
      "name": "Cost Management",
      "brand": "azure"
    },
    {
      "key": "azure-cost-management-and-billing",
      "name": "Cost Management And Billing",
      "brand": "azure"
    },
    {
      "key": "azure-counter",
      "name": "Counter",
      "brand": "azure"
    },
    {
      "key": "azure-cubes",
      "name": "Cubes",
      "brand": "azure"
    },
    {
      "key": "azure-custom-ip-prefix",
      "name": "Custom IP Prefix",
      "brand": "azure"
    },
    {
      "key": "azure-custom-vision",
      "name": "Custom Vision",
      "brand": "azure"
    },
    {
      "key": "azure-customer-lockbox-for-microsoft-azure",
      "name": "Customer Lockbox For Microsoft Azure",
      "brand": "azure"
    },
    {
      "key": "azure-dashboard",
      "name": "Dashboard",
      "brand": "azure"
    },
    {
      "key": "azure-dashboard-hub",
      "name": "Dashboard Hub",
      "brand": "azure"
    },
    {
      "key": "azure-data-box",
      "name": "Data Box",
      "brand": "azure"
    },
    {
      "key": "azure-data-collection-rules",
      "name": "Data Collection Rules",
      "brand": "azure"
    },
    {
      "key": "azure-data-factories",
      "name": "Data Factories",
      "brand": "azure"
    },
    {
      "key": "azure-data-lake-analytics",
      "name": "Data Lake Analytics",
      "brand": "azure"
    },
    {
      "key": "azure-data-lake-storage-gen1",
      "name": "Data Lake Storage Gen1",
      "brand": "azure"
    },
    {
      "key": "azure-data-lake-store-gen1",
      "name": "Data Lake Store Gen1",
      "brand": "azure"
    },
    {
      "key": "azure-data-share-invitations",
      "name": "Data Share Invitations",
      "brand": "azure"
    },
    {
      "key": "azure-data-shares",
      "name": "Data Shares",
      "brand": "azure"
    },
    {
      "key": "azure-data-virtualization",
      "name": "Data Virtualization",
      "brand": "azure"
    },
    {
      "key": "azure-database-instance-for-sap",
      "name": "Database Instance For Sap",
      "brand": "azure"
    },
    {
      "key": "azure-ddos-protection-plans",
      "name": "Ddos Protection Plans",
      "brand": "azure"
    },
    {
      "key": "azure-dedicated-hsm",
      "name": "Dedicated Hsm",
      "brand": "azure"
    },
    {
      "key": "azure-defender-cm-local-manager",
      "name": "Defender Cm Local Manager",
      "brand": "azure"
    },
    {
      "key": "azure-defender-dcs-controller",
      "name": "Defender Dcs Controller",
      "brand": "azure"
    },
    {
      "key": "azure-defender-distributer-control-system",
      "name": "Defender Distributer Control System",
      "brand": "azure"
    },
    {
      "key": "azure-defender-engineering-station",
      "name": "Defender Engineering Station",
      "brand": "azure"
    },
    {
      "key": "azure-defender-external-management",
      "name": "Defender External Management",
      "brand": "azure"
    },
    {
      "key": "azure-defender-freezer-monitor",
      "name": "Defender Freezer Monitor",
      "brand": "azure"
    },
    {
      "key": "azure-defender-historian",
      "name": "Defender Historian",
      "brand": "azure"
    },
    {
      "key": "azure-defender-hmi",
      "name": "Defender Hmi",
      "brand": "azure"
    },
    {
      "key": "azure-defender-industrial-packaging-system",
      "name": "Defender Industrial Packaging System",
      "brand": "azure"
    },
    {
      "key": "azure-defender-industrial-printer",
      "name": "Defender Industrial Printer",
      "brand": "azure"
    },
    {
      "key": "azure-defender-industrial-robot",
      "name": "Defender Industrial Robot",
      "brand": "azure"
    },
    {
      "key": "azure-defender-industrial-scale-system",
      "name": "Defender Industrial Scale System",
      "brand": "azure"
    },
    {
      "key": "azure-defender-marquee",
      "name": "Defender Marquee",
      "brand": "azure"
    },
    {
      "key": "azure-defender-meter",
      "name": "Defender Meter",
      "brand": "azure"
    },
    {
      "key": "azure-defender-plc",
      "name": "Defender Plc",
      "brand": "azure"
    },
    {
      "key": "azure-defender-pneumatic-device",
      "name": "Defender Pneumatic Device",
      "brand": "azure"
    },
    {
      "key": "azure-defender-programable-board",
      "name": "Defender Programable Board",
      "brand": "azure"
    },
    {
      "key": "azure-defender-relay",
      "name": "Defender Relay",
      "brand": "azure"
    },
    {
      "key": "azure-defender-robot-controller",
      "name": "Defender Robot Controller",
      "brand": "azure"
    },
    {
      "key": "azure-defender-rtu",
      "name": "Defender Rtu",
      "brand": "azure"
    },
    {
      "key": "azure-defender-sensor",
      "name": "Defender Sensor",
      "brand": "azure"
    },
    {
      "key": "azure-defender-slot",
      "name": "Defender Slot",
      "brand": "azure"
    },
    {
      "key": "azure-defender-web-guiding-system",
      "name": "Defender Web Guiding System",
      "brand": "azure"
    },
    {
      "key": "azure-detonation",
      "name": "Detonation",
      "brand": "azure"
    },
    {
      "key": "azure-dev-console",
      "name": "Dev Console",
      "brand": "azure"
    },
    {
      "key": "azure-device-compliance",
      "name": "Device Compliance",
      "brand": "azure"
    },
    {
      "key": "azure-device-configuration",
      "name": "Device Configuration",
      "brand": "azure"
    },
    {
      "key": "azure-device-enrollment",
      "name": "Device Enrollment",
      "brand": "azure"
    },
    {
      "key": "azure-device-provisioning-services",
      "name": "Device Provisioning Services",
      "brand": "azure"
    },
    {
      "key": "azure-device-security-apple",
      "name": "Device Security Apple",
      "brand": "azure"
    },
    {
      "key": "azure-device-security-google",
      "name": "Device Security Google",
      "brand": "azure"
    },
    {
      "key": "azure-device-security-windows",
      "name": "Device Security Windows",
      "brand": "azure"
    },
    {
      "key": "azure-device-update-iot-hub",
      "name": "Device Update IoT Hub",
      "brand": "azure"
    },
    {
      "key": "azure-devices",
      "name": "Devices",
      "brand": "azure"
    },
    {
      "key": "azure-devops-starter",
      "name": "Devops Starter",
      "brand": "azure"
    },
    {
      "key": "azure-devtest-labs",
      "name": "Devtest Labs",
      "brand": "azure"
    },
    {
      "key": "azure-diagnostics-settings",
      "name": "Diagnostics Settings",
      "brand": "azure"
    },
    {
      "key": "azure-digital-twins",
      "name": "Digital Twins",
      "brand": "azure"
    },
    {
      "key": "azure-disk-encryption-sets",
      "name": "Disk Encryption Sets",
      "brand": "azure"
    },
    {
      "key": "azure-disk-pool",
      "name": "Disk Pool",
      "brand": "azure"
    },
    {
      "key": "azure-disks",
      "name": "Disks",
      "brand": "azure"
    },
    {
      "key": "azure-disks-classic",
      "name": "Disks Classic",
      "brand": "azure"
    },
    {
      "key": "azure-disks-snapshots",
      "name": "Disks Snapshots",
      "brand": "azure"
    },
    {
      "key": "azure-dns-multistack",
      "name": "DNS Multistack",
      "brand": "azure"
    },
    {
      "key": "azure-dns-private-resolver",
      "name": "DNS Private Resolver",
      "brand": "azure"
    },
    {
      "key": "azure-dns-security-policy",
      "name": "DNS Security Policy",
      "brand": "azure"
    },
    {
      "key": "azure-dns-zones",
      "name": "DNS Zones",
      "brand": "azure"
    },
    {
      "key": "azure-download",
      "name": "Download",
      "brand": "azure"
    },
    {
      "key": "azure-ebooks",
      "name": "Ebooks",
      "brand": "azure"
    },
    {
      "key": "azure-edge-actions",
      "name": "Edge Actions",
      "brand": "azure"
    },
    {
      "key": "azure-edge-management",
      "name": "Edge Management",
      "brand": "azure"
    },
    {
      "key": "azure-edge-storage-accelerator",
      "name": "Edge Storage Accelerator",
      "brand": "azure"
    },
    {
      "key": "azure-education",
      "name": "Education",
      "brand": "azure"
    },
    {
      "key": "azure-elastic-job-agents",
      "name": "Elastic Job Agents",
      "brand": "azure"
    },
    {
      "key": "azure-elastic-san",
      "name": "Elastic San",
      "brand": "azure"
    },
    {
      "key": "azure-endpoint-analytics",
      "name": "Endpoint Analytics",
      "brand": "azure"
    },
    {
      "key": "azure-engage-center-connect",
      "name": "Engage Center Connect",
      "brand": "azure"
    },
    {
      "key": "azure-enterprise-applications",
      "name": "Enterprise Applications",
      "brand": "azure"
    },
    {
      "key": "azure-entra-connect",
      "name": "Entra Connect",
      "brand": "azure"
    },
    {
      "key": "azure-entra-connect-health",
      "name": "Entra Connect Health",
      "brand": "azure"
    },
    {
      "key": "azure-entra-connect-sync",
      "name": "Entra Connect Sync",
      "brand": "azure"
    },
    {
      "key": "azure-entra-domain-services",
      "name": "Entra Domain Services",
      "brand": "azure"
    },
    {
      "key": "azure-entra-global-secure-access",
      "name": "Entra Global Secure Access",
      "brand": "azure"
    },
    {
      "key": "azure-entra-id-protection",
      "name": "Entra Id Protection",
      "brand": "azure"
    },
    {
      "key": "azure-entra-identity-custom-roles",
      "name": "Entra Identity Custom Roles",
      "brand": "azure"
    },
    {
      "key": "azure-entra-identity-licenses",
      "name": "Entra Identity Licenses",
      "brand": "azure"
    },
    {
      "key": "azure-entra-identity-risky-signins",
      "name": "Entra Identity Risky Signins",
      "brand": "azure"
    },
    {
      "key": "azure-entra-identity-risky-users",
      "name": "Entra Identity Risky Users",
      "brand": "azure"
    },
    {
      "key": "azure-entra-identity-roles-and-administrators",
      "name": "Entra Identity Roles And Administrators",
      "brand": "azure"
    },
    {
      "key": "azure-entra-internet-access",
      "name": "Entra Internet Access",
      "brand": "azure"
    },
    {
      "key": "azure-entra-managed-identities",
      "name": "Entra Managed Identities",
      "brand": "azure"
    },
    {
      "key": "azure-entra-private-access",
      "name": "Entra Private Access",
      "brand": "azure"
    },
    {
      "key": "azure-entra-privleged-identity-management",
      "name": "Entra Privleged Identity Management",
      "brand": "azure"
    },
    {
      "key": "azure-entra-verified-id",
      "name": "Entra Verified Id",
      "brand": "azure"
    },
    {
      "key": "azure-error",
      "name": "Error",
      "brand": "azure"
    },
    {
      "key": "azure-event-grid-domains",
      "name": "Event Grid Domains",
      "brand": "azure"
    },
    {
      "key": "azure-event-grid-subscriptions",
      "name": "Event Grid Subscriptions",
      "brand": "azure"
    },
    {
      "key": "azure-event-grid-topics",
      "name": "Event Grid Topics",
      "brand": "azure"
    },
    {
      "key": "azure-event-hub-clusters",
      "name": "Event Hub Clusters",
      "brand": "azure"
    },
    {
      "key": "azure-event-hubs",
      "name": "Event Hubs",
      "brand": "azure"
    },
    {
      "key": "azure-exchange-access",
      "name": "Exchange Access",
      "brand": "azure"
    },
    {
      "key": "azure-exchange-on-premises-access",
      "name": "Exchange On Premises Access",
      "brand": "azure"
    },
    {
      "key": "azure-express-route-traffic-collector",
      "name": "Express Route Traffic Collector",
      "brand": "azure"
    },
    {
      "key": "azure-expressroute-circuits",
      "name": "Expressroute Circuits",
      "brand": "azure"
    },
    {
      "key": "azure-expressroute-direct",
      "name": "Expressroute Direct",
      "brand": "azure"
    },
    {
      "key": "azure-extendedsecurityupdates",
      "name": "Extendedsecurityupdates",
      "brand": "azure"
    },
    {
      "key": "azure-extensions",
      "name": "Extensions",
      "brand": "azure"
    },
    {
      "key": "azure-external-id",
      "name": "External Id",
      "brand": "azure"
    },
    {
      "key": "azure-external-id-modified",
      "name": "External Id Modified",
      "brand": "azure"
    },
    {
      "key": "azure-external-identities",
      "name": "External Identities",
      "brand": "azure"
    },
    {
      "key": "azure-face-apis",
      "name": "Face Apis",
      "brand": "azure"
    },
    {
      "key": "azure-feature-previews",
      "name": "Feature Previews",
      "brand": "azure"
    },
    {
      "key": "azure-fhir-service",
      "name": "Fhir Service",
      "brand": "azure"
    },
    {
      "key": "azure-fiji",
      "name": "Fiji",
      "brand": "azure"
    },
    {
      "key": "azure-file",
      "name": "File",
      "brand": "azure"
    },
    {
      "key": "azure-files",
      "name": "Files",
      "brand": "azure"
    },
    {
      "key": "azure-firewalls",
      "name": "Firewalls",
      "brand": "azure"
    },
    {
      "key": "azure-folder-blank",
      "name": "Folder Blank",
      "brand": "azure"
    },
    {
      "key": "azure-folder-website",
      "name": "Folder Website",
      "brand": "azure"
    },
    {
      "key": "azure-form-recognizers",
      "name": "Form Recognizers",
      "brand": "azure"
    },
    {
      "key": "azure-frd-qa",
      "name": "Frd Qa",
      "brand": "azure"
    },
    {
      "key": "azure-free-services",
      "name": "Free Services",
      "brand": "azure"
    },
    {
      "key": "azure-front-door-and-cdn-profiles",
      "name": "Front Door And CDN Profiles",
      "brand": "azure"
    },
    {
      "key": "azure-ftp",
      "name": "Ftp",
      "brand": "azure"
    },
    {
      "key": "azure-function-apps",
      "name": "Function Apps",
      "brand": "azure"
    },
    {
      "key": "azure-gear",
      "name": "Gear",
      "brand": "azure"
    },
    {
      "key": "azure-genomics",
      "name": "Genomics",
      "brand": "azure"
    },
    {
      "key": "azure-genomics-accounts",
      "name": "Genomics Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-globe-error",
      "name": "Globe Error",
      "brand": "azure"
    },
    {
      "key": "azure-globe-success",
      "name": "Globe Success",
      "brand": "azure"
    },
    {
      "key": "azure-globe-warning",
      "name": "Globe Warning",
      "brand": "azure"
    },
    {
      "key": "azure-groups",
      "name": "Groups",
      "brand": "azure"
    },
    {
      "key": "azure-guide",
      "name": "Guide",
      "brand": "azure"
    },
    {
      "key": "azure-hd-insight-clusters",
      "name": "Hd Insight Clusters",
      "brand": "azure"
    },
    {
      "key": "azure-hdi-aks-cluster",
      "name": "Hdi Aks Cluster",
      "brand": "azure"
    },
    {
      "key": "azure-heart",
      "name": "Heart",
      "brand": "azure"
    },
    {
      "key": "azure-help-and-support",
      "name": "Help And Support",
      "brand": "azure"
    },
    {
      "key": "azure-host-groups",
      "name": "Host Groups",
      "brand": "azure"
    },
    {
      "key": "azure-host-pools",
      "name": "Host Pools",
      "brand": "azure"
    },
    {
      "key": "azure-hosts",
      "name": "Hosts",
      "brand": "azure"
    },
    {
      "key": "azure-hybrid-connectivity-hub",
      "name": "Hybrid Connectivity Hub",
      "brand": "azure"
    },
    {
      "key": "azure-icm-troubleshooting",
      "name": "Icm Troubleshooting",
      "brand": "azure"
    },
    {
      "key": "azure-identity-governance",
      "name": "Identity Governance",
      "brand": "azure"
    },
    {
      "key": "azure-identity-secure-score",
      "name": "Identity Secure Score",
      "brand": "azure"
    },
    {
      "key": "azure-image",
      "name": "Image",
      "brand": "azure"
    },
    {
      "key": "azure-image-definitions",
      "name": "Image Definitions",
      "brand": "azure"
    },
    {
      "key": "azure-image-templates",
      "name": "Image Templates",
      "brand": "azure"
    },
    {
      "key": "azure-image-versions",
      "name": "Image Versions",
      "brand": "azure"
    },
    {
      "key": "azure-images",
      "name": "Images",
      "brand": "azure"
    },
    {
      "key": "azure-immersive-readers",
      "name": "Immersive Readers",
      "brand": "azure"
    },
    {
      "key": "azure-import-export-jobs",
      "name": "Import Export Jobs",
      "brand": "azure"
    },
    {
      "key": "azure-industrial-iot",
      "name": "Industrial IoT",
      "brand": "azure"
    },
    {
      "key": "azure-information",
      "name": "Information",
      "brand": "azure"
    },
    {
      "key": "azure-infrastructure-backup",
      "name": "Infrastructure Backup",
      "brand": "azure"
    },
    {
      "key": "azure-input-output",
      "name": "Input Output",
      "brand": "azure"
    },
    {
      "key": "azure-instance-pools",
      "name": "Instance Pools",
      "brand": "azure"
    },
    {
      "key": "azure-integration-accounts",
      "name": "Integration Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-integration-environments",
      "name": "Integration Environments",
      "brand": "azure"
    },
    {
      "key": "azure-integration-service-environments",
      "name": "Integration Service Environments",
      "brand": "azure"
    },
    {
      "key": "azure-internet-analyzer-profiles",
      "name": "Internet Analyzer Profiles",
      "brand": "azure"
    },
    {
      "key": "azure-intune",
      "name": "Intune",
      "brand": "azure"
    },
    {
      "key": "azure-intune-app-protection",
      "name": "Intune App Protection",
      "brand": "azure"
    },
    {
      "key": "azure-intune-for-education",
      "name": "Intune For Education",
      "brand": "azure"
    },
    {
      "key": "azure-intune-trends",
      "name": "Intune Trends",
      "brand": "azure"
    },
    {
      "key": "azure-iot-central-applications",
      "name": "IoT Central Applications",
      "brand": "azure"
    },
    {
      "key": "azure-iot-edge",
      "name": "IoT Edge",
      "brand": "azure"
    },
    {
      "key": "azure-iot-hub",
      "name": "IoT Hub",
      "brand": "azure"
    },
    {
      "key": "azure-ip-address-manager",
      "name": "IP Address Manager",
      "brand": "azure"
    },
    {
      "key": "azure-ip-groups",
      "name": "IP Groups",
      "brand": "azure"
    },
    {
      "key": "azure-journey-hub",
      "name": "Journey Hub",
      "brand": "azure"
    },
    {
      "key": "azure-key-vaults",
      "name": "Key Vaults",
      "brand": "azure"
    },
    {
      "key": "azure-keys",
      "name": "Keys",
      "brand": "azure"
    },
    {
      "key": "azure-kubernetes-fleet-manager",
      "name": "Kubernetes Fleet Manager",
      "brand": "azure"
    },
    {
      "key": "azure-kubernetes-hub",
      "name": "Kubernetes Hub",
      "brand": "azure"
    },
    {
      "key": "azure-kubernetes-services",
      "name": "Kubernetes Services",
      "brand": "azure"
    },
    {
      "key": "azure-lab-accounts",
      "name": "Lab Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-lab-services",
      "name": "Lab Services",
      "brand": "azure"
    },
    {
      "key": "azure-landing-zone",
      "name": "Landing Zone",
      "brand": "azure"
    },
    {
      "key": "azure-language",
      "name": "Language",
      "brand": "azure"
    },
    {
      "key": "azure-language-understanding",
      "name": "Language Understanding",
      "brand": "azure"
    },
    {
      "key": "azure-launch-portal",
      "name": "Launch Portal",
      "brand": "azure"
    },
    {
      "key": "azure-learn",
      "name": "Learn",
      "brand": "azure"
    },
    {
      "key": "azure-load-balancer-hub",
      "name": "Load Balancer Hub",
      "brand": "azure"
    },
    {
      "key": "azure-load-balancers",
      "name": "Load Balancers",
      "brand": "azure"
    },
    {
      "key": "azure-load-test",
      "name": "Load Test",
      "brand": "azure"
    },
    {
      "key": "azure-load-testing",
      "name": "Load Testing",
      "brand": "azure"
    },
    {
      "key": "azure-local-network-gateways",
      "name": "Local Network Gateways",
      "brand": "azure"
    },
    {
      "key": "azure-location",
      "name": "Location",
      "brand": "azure"
    },
    {
      "key": "azure-log-analytics-query-pack",
      "name": "Log Analytics Query Pack",
      "brand": "azure"
    },
    {
      "key": "azure-log-analytics-workspaces",
      "name": "Log Analytics Workspaces",
      "brand": "azure"
    },
    {
      "key": "azure-log-streaming",
      "name": "Log Streaming",
      "brand": "azure"
    },
    {
      "key": "azure-logic-apps",
      "name": "Logic Apps",
      "brand": "azure"
    },
    {
      "key": "azure-logic-apps-custom-connector",
      "name": "Logic Apps Custom Connector",
      "brand": "azure"
    },
    {
      "key": "azure-logic-apps-template",
      "name": "Logic Apps Template",
      "brand": "azure"
    },
    {
      "key": "azure-machine-learning",
      "name": "Machine Learning",
      "brand": "azure"
    },
    {
      "key": "azure-machine-learning-studio-classic-web-services",
      "name": "Machine Learning Studio Classic Web Services",
      "brand": "azure"
    },
    {
      "key": "azure-machine-learning-studio-web-service-plans",
      "name": "Machine Learning Studio Web Service Plans",
      "brand": "azure"
    },
    {
      "key": "azure-machine-learning-studio-workspaces",
      "name": "Machine Learning Studio Workspaces",
      "brand": "azure"
    },
    {
      "key": "azure-machinesazurearc",
      "name": "Machinesazurearc",
      "brand": "azure"
    },
    {
      "key": "azure-maintenance-configuration",
      "name": "Maintenance Configuration",
      "brand": "azure"
    },
    {
      "key": "azure-managed-applications-center",
      "name": "Managed Applications Center",
      "brand": "azure"
    },
    {
      "key": "azure-managed-database",
      "name": "Managed Database",
      "brand": "azure"
    },
    {
      "key": "azure-managed-desktop",
      "name": "Managed Desktop",
      "brand": "azure"
    },
    {
      "key": "azure-managed-devops-pools",
      "name": "Managed Devops Pools",
      "brand": "azure"
    },
    {
      "key": "azure-managed-file-shares",
      "name": "Managed File Shares",
      "brand": "azure"
    },
    {
      "key": "azure-managed-identities",
      "name": "Managed Identities",
      "brand": "azure"
    },
    {
      "key": "azure-managed-instance-apache-cassandra",
      "name": "Managed Instance Apache Cassandra",
      "brand": "azure"
    },
    {
      "key": "azure-managed-service-fabric",
      "name": "Managed Service Fabric",
      "brand": "azure"
    },
    {
      "key": "azure-management-groups",
      "name": "Management Groups",
      "brand": "azure"
    },
    {
      "key": "azure-management-portal",
      "name": "Management Portal",
      "brand": "azure"
    },
    {
      "key": "azure-marketplace",
      "name": "Marketplace",
      "brand": "azure"
    },
    {
      "key": "azure-marketplace-management",
      "name": "Marketplace Management",
      "brand": "azure"
    },
    {
      "key": "azure-media",
      "name": "Media",
      "brand": "azure"
    },
    {
      "key": "azure-media-file",
      "name": "Media File",
      "brand": "azure"
    },
    {
      "key": "azure-medtech-service",
      "name": "Medtech Service",
      "brand": "azure"
    },
    {
      "key": "azure-mesh-applications",
      "name": "Mesh Applications",
      "brand": "azure"
    },
    {
      "key": "azure-metrics",
      "name": "Metrics",
      "brand": "azure"
    },
    {
      "key": "azure-metrics-advisor",
      "name": "Metrics Advisor",
      "brand": "azure"
    },
    {
      "key": "microsoft-azure",
      "name": "Microsoft Azure",
      "brand": "azure"
    },
    {
      "key": "azure-microsoft-defender-easm",
      "name": "Microsoft Defender Easm",
      "brand": "azure"
    },
    {
      "key": "azure-microsoft-defender-for-cloud",
      "name": "Microsoft Defender For Cloud",
      "brand": "azure"
    },
    {
      "key": "azure-microsoft-defender-for-iot",
      "name": "Microsoft Defender For IoT",
      "brand": "azure"
    },
    {
      "key": "azure-microsoft-dev-box",
      "name": "Microsoft Dev Box",
      "brand": "azure"
    },
    {
      "key": "azure-microsoft-discovery",
      "name": "Microsoft Discovery",
      "brand": "azure"
    },
    {
      "key": "azure-mindaro",
      "name": "Mindaro",
      "brand": "azure"
    },
    {
      "key": "azure-mission-landing-zone",
      "name": "Mission Landing Zone",
      "brand": "azure"
    },
    {
      "key": "azure-mobile",
      "name": "Mobile",
      "brand": "azure"
    },
    {
      "key": "azure-mobile-engagement",
      "name": "Mobile Engagement",
      "brand": "azure"
    },
    {
      "key": "azure-mobile-networks",
      "name": "Mobile Networks",
      "brand": "azure"
    },
    {
      "key": "azure-modular-data-center",
      "name": "Modular Data Center",
      "brand": "azure"
    },
    {
      "key": "azure-module",
      "name": "Module",
      "brand": "azure"
    },
    {
      "key": "azure-monitor",
      "name": "Monitor",
      "brand": "azure"
    },
    {
      "key": "azure-monitor-health-models",
      "name": "Monitor Health Models",
      "brand": "azure"
    },
    {
      "key": "azure-monitor-issues",
      "name": "Monitor Issues",
      "brand": "azure"
    },
    {
      "key": "azure-multi-factor-authentication",
      "name": "Multi Factor Authentication",
      "brand": "azure"
    },
    {
      "key": "azure-multi-tenancy",
      "name": "Multi Tenancy",
      "brand": "azure"
    },
    {
      "key": "azure-multifactor-authentication",
      "name": "Multifactor Authentication",
      "brand": "azure"
    },
    {
      "key": "azure-my-customers",
      "name": "My Customers",
      "brand": "azure"
    },
    {
      "key": "azure-nat",
      "name": "NAT",
      "brand": "azure"
    },
    {
      "key": "azure-network-foundation-hub",
      "name": "Network Foundation Hub",
      "brand": "azure"
    },
    {
      "key": "azure-network-interfaces",
      "name": "Network Interfaces",
      "brand": "azure"
    },
    {
      "key": "azure-network-managers",
      "name": "Network Managers",
      "brand": "azure"
    },
    {
      "key": "azure-network-security-groups",
      "name": "Network Security Groups",
      "brand": "azure"
    },
    {
      "key": "azure-network-security-hub",
      "name": "Network Security Hub",
      "brand": "azure"
    },
    {
      "key": "azure-network-security-perimeters",
      "name": "Network Security Perimeters",
      "brand": "azure"
    },
    {
      "key": "azure-network-watcher",
      "name": "Network Watcher",
      "brand": "azure"
    },
    {
      "key": "azure-notification-hub-namespaces",
      "name": "Notification Hub Namespaces",
      "brand": "azure"
    },
    {
      "key": "azure-notification-hubs",
      "name": "Notification Hubs",
      "brand": "azure"
    },
    {
      "key": "azure-offers",
      "name": "Offers",
      "brand": "azure"
    },
    {
      "key": "azure-on-premises-data-gateways",
      "name": "On Premises Data Gateways",
      "brand": "azure"
    },
    {
      "key": "azure-open-supply-chain-platform",
      "name": "Open Supply Chain Platform",
      "brand": "azure"
    },
    {
      "key": "azure-operation-center",
      "name": "Operation Center",
      "brand": "azure"
    },
    {
      "key": "azure-operation-log-classic",
      "name": "Operation Log Classic",
      "brand": "azure"
    },
    {
      "key": "azure-oracle-database",
      "name": "Oracle Database",
      "brand": "azure"
    },
    {
      "key": "azure-os-images-classic",
      "name": "OS Images Classic",
      "brand": "azure"
    },
    {
      "key": "azure-osconfig",
      "name": "Osconfig",
      "brand": "azure"
    },
    {
      "key": "azure-outbound-connection",
      "name": "Outbound Connection",
      "brand": "azure"
    },
    {
      "key": "azure-partner-namespace",
      "name": "Partner Namespace",
      "brand": "azure"
    },
    {
      "key": "azure-partner-registration",
      "name": "Partner Registration",
      "brand": "azure"
    },
    {
      "key": "azure-partner-topic",
      "name": "Partner Topic",
      "brand": "azure"
    },
    {
      "key": "azure-peering-service",
      "name": "Peering Service",
      "brand": "azure"
    },
    {
      "key": "azure-peerings",
      "name": "Peerings",
      "brand": "azure"
    },
    {
      "key": "azure-personalizers",
      "name": "Personalizers",
      "brand": "azure"
    },
    {
      "key": "azure-planetary-computer-pro",
      "name": "Planetary Computer Pro",
      "brand": "azure"
    },
    {
      "key": "azure-plans",
      "name": "Plans",
      "brand": "azure"
    },
    {
      "key": "azure-policy",
      "name": "Policy",
      "brand": "azure"
    },
    {
      "key": "azure-power",
      "name": "Power",
      "brand": "azure"
    },
    {
      "key": "azure-power-bi-embedded",
      "name": "Power Bi Embedded",
      "brand": "azure"
    },
    {
      "key": "azure-power-platform",
      "name": "Power Platform",
      "brand": "azure"
    },
    {
      "key": "azure-power-up",
      "name": "Power Up",
      "brand": "azure"
    },
    {
      "key": "azure-powershell",
      "name": "Powershell",
      "brand": "azure"
    },
    {
      "key": "azure-preview-features",
      "name": "Preview Features",
      "brand": "azure"
    },
    {
      "key": "azure-private-endpoints",
      "name": "Private Endpoints",
      "brand": "azure"
    },
    {
      "key": "azure-private-link",
      "name": "Private Link",
      "brand": "azure"
    },
    {
      "key": "azure-private-link-service",
      "name": "Private Link Service",
      "brand": "azure"
    },
    {
      "key": "azure-private-link-services",
      "name": "Private Link Services",
      "brand": "azure"
    },
    {
      "key": "azure-process-explorer",
      "name": "Process Explorer",
      "brand": "azure"
    },
    {
      "key": "azure-production-ready-database",
      "name": "Production Ready Database",
      "brand": "azure"
    },
    {
      "key": "azure-promethus",
      "name": "Promethus",
      "brand": "azure"
    },
    {
      "key": "azure-proximity-placement-groups",
      "name": "Proximity Placement Groups",
      "brand": "azure"
    },
    {
      "key": "azure-public-ip-addresses",
      "name": "Public IP Addresses",
      "brand": "azure"
    },
    {
      "key": "azure-public-ip-addresses-classic",
      "name": "Public IP Addresses Classic",
      "brand": "azure"
    },
    {
      "key": "azure-public-ip-prefixes",
      "name": "Public IP Prefixes",
      "brand": "azure"
    },
    {
      "key": "azure-pubsub",
      "name": "Pubsub",
      "brand": "azure"
    },
    {
      "key": "azure-qna-makers",
      "name": "Qna Makers",
      "brand": "azure"
    },
    {
      "key": "azure-quickstart-center",
      "name": "Quickstart Center",
      "brand": "azure"
    },
    {
      "key": "azure-recent",
      "name": "Recent",
      "brand": "azure"
    },
    {
      "key": "azure-recovery-services-vaults",
      "name": "Recovery Services Vaults",
      "brand": "azure"
    },
    {
      "key": "azure-region-management",
      "name": "Region Management",
      "brand": "azure"
    },
    {
      "key": "azure-relays",
      "name": "Relays",
      "brand": "azure"
    },
    {
      "key": "azure-remote-rendering",
      "name": "Remote Rendering",
      "brand": "azure"
    },
    {
      "key": "azure-reservations",
      "name": "Reservations",
      "brand": "azure"
    },
    {
      "key": "azure-reserved-capacity",
      "name": "Reserved Capacity",
      "brand": "azure"
    },
    {
      "key": "azure-reserved-ip-addresses-classic",
      "name": "Reserved IP Addresses Classic",
      "brand": "azure"
    },
    {
      "key": "azure-resource-explorer",
      "name": "Resource Explorer",
      "brand": "azure"
    },
    {
      "key": "azure-resource-graph-explorer",
      "name": "Resource Graph Explorer",
      "brand": "azure"
    },
    {
      "key": "azure-resource-group-list",
      "name": "Resource Group List",
      "brand": "azure"
    },
    {
      "key": "azure-resource-groups",
      "name": "Resource Groups",
      "brand": "azure"
    },
    {
      "key": "azure-resource-guard",
      "name": "Resource Guard",
      "brand": "azure"
    },
    {
      "key": "azure-resource-linked",
      "name": "Resource Linked",
      "brand": "azure"
    },
    {
      "key": "azure-resource-management-private-link",
      "name": "Resource Management Private Link",
      "brand": "azure"
    },
    {
      "key": "azure-resource-mover",
      "name": "Resource Mover",
      "brand": "azure"
    },
    {
      "key": "azure-resources-provider",
      "name": "Resources Provider",
      "brand": "azure"
    },
    {
      "key": "azure-restore-points",
      "name": "Restore Points",
      "brand": "azure"
    },
    {
      "key": "azure-restore-points-collections",
      "name": "Restore Points Collections",
      "brand": "azure"
    },
    {
      "key": "azure-route-filters",
      "name": "Route Filters",
      "brand": "azure"
    },
    {
      "key": "azure-route-tables",
      "name": "Route Tables",
      "brand": "azure"
    },
    {
      "key": "azure-rtos",
      "name": "Rtos",
      "brand": "azure"
    },
    {
      "key": "azure-savings-plans",
      "name": "Savings Plans",
      "brand": "azure"
    },
    {
      "key": "azure-scheduled-actions",
      "name": "Scheduled Actions",
      "brand": "azure"
    },
    {
      "key": "azure-scheduler",
      "name": "Scheduler",
      "brand": "azure"
    },
    {
      "key": "azure-scheduler-job-collections",
      "name": "Scheduler Job Collections",
      "brand": "azure"
    },
    {
      "key": "azure-scvmm-management-servers",
      "name": "Scvmm Management Servers",
      "brand": "azure"
    },
    {
      "key": "azure-search",
      "name": "Search",
      "brand": "azure"
    },
    {
      "key": "azure-search-grid",
      "name": "Search Grid",
      "brand": "azure"
    },
    {
      "key": "azure-security",
      "name": "Security",
      "brand": "azure"
    },
    {
      "key": "azure-security-baselines",
      "name": "Security Baselines",
      "brand": "azure"
    },
    {
      "key": "azure-sendgrid-accounts",
      "name": "Sendgrid Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-server-farm",
      "name": "Server Farm",
      "brand": "azure"
    },
    {
      "key": "azure-serverless-search",
      "name": "Serverless Search",
      "brand": "azure"
    },
    {
      "key": "azure-service-catalog-mad",
      "name": "Service Catalog Mad",
      "brand": "azure"
    },
    {
      "key": "azure-service-endpoint-policies",
      "name": "Service Endpoint Policies",
      "brand": "azure"
    },
    {
      "key": "azure-service-fabric-clusters",
      "name": "Service Fabric Clusters",
      "brand": "azure"
    },
    {
      "key": "azure-service-group-relationships",
      "name": "Service Group Relationships",
      "brand": "azure"
    },
    {
      "key": "azure-service-groups",
      "name": "Service Groups",
      "brand": "azure"
    },
    {
      "key": "azure-service-health",
      "name": "Service Health",
      "brand": "azure"
    },
    {
      "key": "azure-service-providers",
      "name": "Service Providers",
      "brand": "azure"
    },
    {
      "key": "azure-shared-image-galleries",
      "name": "Shared Image Galleries",
      "brand": "azure"
    },
    {
      "key": "azure-signalr",
      "name": "Signalr",
      "brand": "azure"
    },
    {
      "key": "azure-software-as-a-service",
      "name": "Software As A Service",
      "brand": "azure"
    },
    {
      "key": "azure-software-updates",
      "name": "Software Updates",
      "brand": "azure"
    },
    {
      "key": "azure-solutions",
      "name": "Solutions",
      "brand": "azure"
    },
    {
      "key": "azure-sonic-dash",
      "name": "Sonic Dash",
      "brand": "azure"
    },
    {
      "key": "azure-spatial-anchor-accounts",
      "name": "Spatial Anchor Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-speech-services",
      "name": "Speech Services",
      "brand": "azure"
    },
    {
      "key": "azure-spot-vm",
      "name": "Spot VM",
      "brand": "azure"
    },
    {
      "key": "azure-spot-vmss",
      "name": "Spot Vmss",
      "brand": "azure"
    },
    {
      "key": "azure-sql-data-warehouses",
      "name": "SQL Data Warehouses",
      "brand": "azure"
    },
    {
      "key": "azure-sql-database",
      "name": "SQL Database",
      "brand": "azure"
    },
    {
      "key": "azure-sql-database-fleet-manager",
      "name": "SQL Database Fleet Manager",
      "brand": "azure"
    },
    {
      "key": "azure-sql-elastic-pools",
      "name": "SQL Elastic Pools",
      "brand": "azure"
    },
    {
      "key": "azure-sql-managed-instance",
      "name": "SQL Managed Instance",
      "brand": "azure"
    },
    {
      "key": "azure-sql-server",
      "name": "SQL Server",
      "brand": "azure"
    },
    {
      "key": "azure-sql-server-registries",
      "name": "SQL Server Registries",
      "brand": "azure"
    },
    {
      "key": "azure-ssd",
      "name": "Ssd",
      "brand": "azure"
    },
    {
      "key": "azure-ssh-keys",
      "name": "Ssh Keys",
      "brand": "azure"
    },
    {
      "key": "azure-ssis-lift-and-shift-ir",
      "name": "Ssis Lift And Shift Ir",
      "brand": "azure"
    },
    {
      "key": "azure-stack-hci-premium",
      "name": "Stack Hci Premium",
      "brand": "azure"
    },
    {
      "key": "azure-stage-maps",
      "name": "Stage Maps",
      "brand": "azure"
    },
    {
      "key": "azure-static-apps",
      "name": "Static Apps",
      "brand": "azure"
    },
    {
      "key": "azure-storage-accounts",
      "name": "Storage Accounts",
      "brand": "azure"
    },
    {
      "key": "azure-storage-accounts-classic",
      "name": "Storage Accounts Classic",
      "brand": "azure"
    },
    {
      "key": "azure-storage-actions",
      "name": "Storage Actions",
      "brand": "azure"
    },
    {
      "key": "azure-storage-azure-files",
      "name": "Storage Azure Files",
      "brand": "azure"
    },
    {
      "key": "azure-storage-container",
      "name": "Storage Container",
      "brand": "azure"
    },
    {
      "key": "azure-storage-explorer",
      "name": "Storage Explorer",
      "brand": "azure"
    },
    {
      "key": "azure-storage-functions",
      "name": "Storage Functions",
      "brand": "azure"
    },
    {
      "key": "azure-storage-hubs",
      "name": "Storage Hubs",
      "brand": "azure"
    },
    {
      "key": "azure-storage-queue",
      "name": "Storage Queue",
      "brand": "azure"
    },
    {
      "key": "azure-storage-sync-services",
      "name": "Storage Sync Services",
      "brand": "azure"
    },
    {
      "key": "azure-storsimple-data-managers",
      "name": "Storsimple Data Managers",
      "brand": "azure"
    },
    {
      "key": "azure-storsimple-device-managers",
      "name": "Storsimple Device Managers",
      "brand": "azure"
    },
    {
      "key": "azure-stream-analytics-jobs",
      "name": "Stream Analytics Jobs",
      "brand": "azure"
    },
    {
      "key": "azure-subnet",
      "name": "Subnet",
      "brand": "azure"
    },
    {
      "key": "azure-subscriptions",
      "name": "Subscriptions",
      "brand": "azure"
    },
    {
      "key": "azure-system-topic",
      "name": "System Topic",
      "brand": "azure"
    },
    {
      "key": "azure-table",
      "name": "Table",
      "brand": "azure"
    },
    {
      "key": "azure-tag",
      "name": "Tag",
      "brand": "azure"
    },
    {
      "key": "azure-tags",
      "name": "Tags",
      "brand": "azure"
    },
    {
      "key": "azure-targets-management",
      "name": "Targets Management",
      "brand": "azure"
    },
    {
      "key": "azure-template-specs",
      "name": "Template Specs",
      "brand": "azure"
    },
    {
      "key": "azure-templates",
      "name": "Templates",
      "brand": "azure"
    },
    {
      "key": "azure-tenant-properties",
      "name": "Tenant Properties",
      "brand": "azure"
    },
    {
      "key": "azure-tenant-status",
      "name": "Tenant Status",
      "brand": "azure"
    },
    {
      "key": "azure-test-base",
      "name": "Test Base",
      "brand": "azure"
    },
    {
      "key": "azure-tfs-vc-repository",
      "name": "Tfs Vc Repository",
      "brand": "azure"
    },
    {
      "key": "azure-time-series-data-sets",
      "name": "Time Series Data Sets",
      "brand": "azure"
    },
    {
      "key": "azure-time-series-insights-access-policies",
      "name": "Time Series Insights Access Policies",
      "brand": "azure"
    },
    {
      "key": "azure-time-series-insights-environments",
      "name": "Time Series Insights Environments",
      "brand": "azure"
    },
    {
      "key": "azure-time-series-insights-event-sources",
      "name": "Time Series Insights Event Sources",
      "brand": "azure"
    },
    {
      "key": "azure-toolbox",
      "name": "Toolbox",
      "brand": "azure"
    },
    {
      "key": "azure-toolchain-orchestrator",
      "name": "Toolchain Orchestrator",
      "brand": "azure"
    },
    {
      "key": "azure-traffic-manager-profiles",
      "name": "Traffic Manager Profiles",
      "brand": "azure"
    },
    {
      "key": "azure-translator-text",
      "name": "Translator Text",
      "brand": "azure"
    },
    {
      "key": "azure-troubleshoot",
      "name": "Troubleshoot",
      "brand": "azure"
    },
    {
      "key": "azure-universal-print",
      "name": "Universal Print",
      "brand": "azure"
    },
    {
      "key": "azure-update-management-center",
      "name": "Update Management Center",
      "brand": "azure"
    },
    {
      "key": "azure-updates",
      "name": "Updates",
      "brand": "azure"
    },
    {
      "key": "azure-user-privacy",
      "name": "User Privacy",
      "brand": "azure"
    },
    {
      "key": "azure-user-settings",
      "name": "User Settings",
      "brand": "azure"
    },
    {
      "key": "azure-user-subscriptions",
      "name": "User Subscriptions",
      "brand": "azure"
    },
    {
      "key": "azure-users",
      "name": "Users",
      "brand": "azure"
    },
    {
      "key": "azure-verifiable-credentials",
      "name": "Verifiable Credentials",
      "brand": "azure"
    },
    {
      "key": "azure-verification-as-a-service",
      "name": "Verification As A Service",
      "brand": "azure"
    },
    {
      "key": "azure-versions",
      "name": "Versions",
      "brand": "azure"
    },
    {
      "key": "azure-video-analyzers",
      "name": "Video Analyzers",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-clusters",
      "name": "Virtual Clusters",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-enclaves",
      "name": "Virtual Enclaves",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-instance-for-sap",
      "name": "Virtual Instance For Sap",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-machine",
      "name": "Virtual Machine",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-machines-classic",
      "name": "Virtual Machines Classic",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-network-gateways",
      "name": "Virtual Network Gateways",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-networks",
      "name": "Virtual Networks",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-networks-classic",
      "name": "Virtual Networks Classic",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-router",
      "name": "Virtual Router",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-visits-builder",
      "name": "Virtual Visits Builder",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-wan-hub",
      "name": "Virtual Wan Hub",
      "brand": "azure"
    },
    {
      "key": "azure-virtual-wans",
      "name": "Virtual Wans",
      "brand": "azure"
    },
    {
      "key": "azure-vm-app-definitions",
      "name": "VM App Definitions",
      "brand": "azure"
    },
    {
      "key": "azure-vm-app-versions",
      "name": "VM App Versions",
      "brand": "azure"
    },
    {
      "key": "azure-vm-image-version",
      "name": "VM Image Version",
      "brand": "azure"
    },
    {
      "key": "azure-vm-images-classic",
      "name": "VM Images Classic",
      "brand": "azure"
    },
    {
      "key": "azure-vm-scale-sets",
      "name": "VM Scale Sets",
      "brand": "azure"
    },
    {
      "key": "azure-vnet-appliance",
      "name": "Vnet Appliance",
      "brand": "azure"
    },
    {
      "key": "azure-vpnclientwindows",
      "name": "Vpnclientwindows",
      "brand": "azure"
    },
    {
      "key": "azure-wac",
      "name": "Wac",
      "brand": "azure"
    },
    {
      "key": "azure-wac-installer",
      "name": "Wac Installer",
      "brand": "azure"
    },
    {
      "key": "azure-web-app-database",
      "name": "Web App Database",
      "brand": "azure"
    },
    {
      "key": "azure-web-application-firewall-policies-waf",
      "name": "Web Application Firewall Policies WAF",
      "brand": "azure"
    },
    {
      "key": "azure-web-jobs",
      "name": "Web Jobs",
      "brand": "azure"
    },
    {
      "key": "azure-web-slots",
      "name": "Web Slots",
      "brand": "azure"
    },
    {
      "key": "azure-web-test",
      "name": "Web Test",
      "brand": "azure"
    },
    {
      "key": "azure-website-power",
      "name": "Website Power",
      "brand": "azure"
    },
    {
      "key": "azure-website-staging",
      "name": "Website Staging",
      "brand": "azure"
    },
    {
      "key": "azure-windows-notification-services",
      "name": "Windows Notification Services",
      "brand": "azure"
    },
    {
      "key": "azure-windows10-core-services",
      "name": "Windows10 Core Services",
      "brand": "azure"
    },
    {
      "key": "azure-workbooks",
      "name": "Workbooks",
      "brand": "azure"
    },
    {
      "key": "azure-worker-container-app",
      "name": "Worker Container App",
      "brand": "azure"
    },
    {
      "key": "azure-workflow",
      "name": "Workflow",
      "brand": "azure"
    },
    {
      "key": "azure-workload-orchestration",
      "name": "Workload Orchestration",
      "brand": "azure"
    },
    {
      "key": "azure-workspace-gateway",
      "name": "Workspace Gateway",
      "brand": "azure"
    },
    {
      "key": "azure-workspaces",
      "name": "Workspaces",
      "brand": "azure"
    }
  ],
  "gcp": [
    {
      "key": "gcp-access-context-manager",
      "name": "Access Context Manager",
      "brand": "gcp"
    },
    {
      "key": "gcp-administration",
      "name": "Administration",
      "brand": "gcp"
    },
    {
      "key": "google-admob",
      "name": "Admob",
      "brand": "gcp"
    },
    {
      "key": "google-ads",
      "name": "Ads",
      "brand": "gcp"
    },
    {
      "key": "google-adsense",
      "name": "Adsense",
      "brand": "gcp"
    },
    {
      "key": "gcp-advanced-agent-modeling",
      "name": "Advanced Agent Modeling",
      "brand": "gcp"
    },
    {
      "key": "gcp-advanced-solutions-lab",
      "name": "Advanced Solutions Lab",
      "brand": "gcp"
    },
    {
      "key": "gcp-agent-assist",
      "name": "Agent Assist",
      "brand": "gcp"
    },
    {
      "key": "gcp-ai-hub",
      "name": "AI Hub",
      "brand": "gcp"
    },
    {
      "key": "gcp-ai-platform",
      "name": "AI Platform",
      "brand": "gcp"
    },
    {
      "key": "gcp-ai-platform-unified",
      "name": "AI Platform Unified",
      "brand": "gcp"
    },
    {
      "key": "google-analytics",
      "name": "Analytics",
      "brand": "gcp"
    },
    {
      "key": "gcp-analytics-hub",
      "name": "Analytics Hub",
      "brand": "gcp"
    },
    {
      "key": "gcp-anthos",
      "name": "Anthos",
      "brand": "gcp"
    },
    {
      "key": "gcp-anthos-config-management",
      "name": "Anthos Config Management",
      "brand": "gcp"
    },
    {
      "key": "gcp-anthos-service-mesh",
      "name": "Anthos Service Mesh",
      "brand": "gcp"
    },
    {
      "key": "google-antigravity",
      "name": "Antigravity",
      "brand": "gcp"
    },
    {
      "key": "gcp-api",
      "name": "API",
      "brand": "gcp"
    },
    {
      "key": "gcp-api-analytics",
      "name": "API Analytics",
      "brand": "gcp"
    },
    {
      "key": "gcp-api-monetization",
      "name": "API Monetization",
      "brand": "gcp"
    },
    {
      "key": "gcp-apigee-api-platform",
      "name": "Apigee API Platform",
      "brand": "gcp"
    },
    {
      "key": "gcp-apigee-sense",
      "name": "Apigee Sense",
      "brand": "gcp"
    },
    {
      "key": "gcp-app-engine",
      "name": "App Engine",
      "brand": "gcp"
    },
    {
      "key": "google-apps-script",
      "name": "Apps Script",
      "brand": "gcp"
    },
    {
      "key": "gcp-artifact-registry",
      "name": "Artifact Registry",
      "brand": "gcp"
    },
    {
      "key": "gcp-asset-inventory",
      "name": "Asset Inventory",
      "brand": "gcp"
    },
    {
      "key": "google-assistant",
      "name": "Assistant",
      "brand": "gcp"
    },
    {
      "key": "gcp-assured-workloads",
      "name": "Assured Workloads",
      "brand": "gcp"
    },
    {
      "key": "google-authenticator",
      "name": "Authenticator",
      "brand": "gcp"
    },
    {
      "key": "gcp-automl",
      "name": "Automl",
      "brand": "gcp"
    },
    {
      "key": "gcp-automl-natural-language",
      "name": "Automl Natural Language",
      "brand": "gcp"
    },
    {
      "key": "gcp-automl-tables",
      "name": "Automl Tables",
      "brand": "gcp"
    },
    {
      "key": "gcp-automl-translation",
      "name": "Automl Translation",
      "brand": "gcp"
    },
    {
      "key": "gcp-automl-video-intelligence",
      "name": "Automl Video Intelligence",
      "brand": "gcp"
    },
    {
      "key": "gcp-automl-vision",
      "name": "Automl Vision",
      "brand": "gcp"
    },
    {
      "key": "gcp-bare-metal-solutions",
      "name": "Bare Metal Solutions",
      "brand": "gcp"
    },
    {
      "key": "gcp-batch",
      "name": "Batch",
      "brand": "gcp"
    },
    {
      "key": "gcp-beyondcorp",
      "name": "Beyondcorp",
      "brand": "gcp"
    },
    {
      "key": "gcp-bigquery",
      "name": "Bigquery",
      "brand": "gcp"
    },
    {
      "key": "google-bigquery",
      "name": "Bigquery",
      "brand": "gcp"
    },
    {
      "key": "gcp-bigtable",
      "name": "Bigtable",
      "brand": "gcp"
    },
    {
      "key": "google-bigtable",
      "name": "Bigtable",
      "brand": "gcp"
    },
    {
      "key": "gcp-billing",
      "name": "Billing",
      "brand": "gcp"
    },
    {
      "key": "gcp-binary-authorization",
      "name": "Binary Authorization",
      "brand": "gcp"
    },
    {
      "key": "google-calendar",
      "name": "Calendar",
      "brand": "gcp"
    },
    {
      "key": "google-campaign-manager-360",
      "name": "Campaign Manager 360",
      "brand": "gcp"
    },
    {
      "key": "google-cardboard",
      "name": "Cardboard",
      "brand": "gcp"
    },
    {
      "key": "google-cast",
      "name": "Cast",
      "brand": "gcp"
    },
    {
      "key": "gcp-catalog",
      "name": "Catalog",
      "brand": "gcp"
    },
    {
      "key": "gcp-certificate-authority-service",
      "name": "Certificate Authority Service",
      "brand": "gcp"
    },
    {
      "key": "gcp-certificate-manager",
      "name": "Certificate Manager",
      "brand": "gcp"
    },
    {
      "key": "google-chat",
      "name": "Chat",
      "brand": "gcp"
    },
    {
      "key": "google-chrome",
      "name": "Chrome",
      "brand": "gcp"
    },
    {
      "key": "google-chronicle",
      "name": "Chronicle",
      "brand": "gcp"
    },
    {
      "key": "google-classroom",
      "name": "Classroom",
      "brand": "gcp"
    },
    {
      "key": "google-cloud",
      "name": "Cloud",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-api-gateway",
      "name": "Cloud API Gateway",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-apis",
      "name": "Cloud Apis",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-armor",
      "name": "Cloud Armor",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-asset-inventory",
      "name": "Cloud Asset Inventory",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-audit-logs",
      "name": "Cloud Audit Logs",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-build",
      "name": "Cloud Build",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-cdn",
      "name": "Cloud CDN",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-code",
      "name": "Cloud Code",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-composer",
      "name": "Cloud Composer",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-data-fusion",
      "name": "Cloud Data Fusion",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-deploy",
      "name": "Cloud Deploy",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-deployment-manager",
      "name": "Cloud Deployment Manager",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-dns",
      "name": "Cloud DNS",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-domains",
      "name": "Cloud Domains",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-ekm",
      "name": "Cloud Ekm",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-endpoints",
      "name": "Cloud Endpoints",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-external-ip-addresses",
      "name": "Cloud External IP Addresses",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-firewall-rules",
      "name": "Cloud Firewall Rules",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-for-marketing",
      "name": "Cloud For Marketing",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-functions",
      "name": "Cloud Functions",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-generic",
      "name": "Cloud Generic",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-gpu",
      "name": "Cloud GPU",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-healthcare-api",
      "name": "Cloud Healthcare API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-healthcare-marketplace",
      "name": "Cloud Healthcare Marketplace",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-hsm",
      "name": "Cloud Hsm",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-ids",
      "name": "Cloud Ids",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-inference-api",
      "name": "Cloud Inference API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-interconnect",
      "name": "Cloud Interconnect",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-jobs-api",
      "name": "Cloud Jobs API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-load-balancing",
      "name": "Cloud Load Balancing",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-logging",
      "name": "Cloud Logging",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-media-edge",
      "name": "Cloud Media Edge",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-monitoring",
      "name": "Cloud Monitoring",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-nat",
      "name": "Cloud NAT",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-natural-language-api",
      "name": "Cloud Natural Language API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-network",
      "name": "Cloud Network",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-ops",
      "name": "Cloud Ops",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-optimization-ai",
      "name": "Cloud Optimization AI",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-optimization-ai---fleet-routing-api",
      "name": "Cloud Optimization AI   Fleet Routing API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-router",
      "name": "Cloud Router",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-routes",
      "name": "Cloud Routes",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-run",
      "name": "Cloud Run",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-run-for-anthos",
      "name": "Cloud Run For Anthos",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-scheduler",
      "name": "Cloud Scheduler",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-security-scanner",
      "name": "Cloud Security Scanner",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-shell",
      "name": "Cloud Shell",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-spanner",
      "name": "Cloud Spanner",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-sql",
      "name": "Cloud SQL",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-storage",
      "name": "Cloud Storage",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-tasks",
      "name": "Cloud Tasks",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-test-lab",
      "name": "Cloud Test Lab",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-tpu",
      "name": "Cloud Tpu",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-translation-api",
      "name": "Cloud Translation API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-vision-api",
      "name": "Cloud Vision API",
      "brand": "gcp"
    },
    {
      "key": "gcp-cloud-vpn",
      "name": "Cloud VPN",
      "brand": "gcp"
    },
    {
      "key": "google-colab",
      "name": "Colab",
      "brand": "gcp"
    },
    {
      "key": "google-colaboratory",
      "name": "Colaboratory",
      "brand": "gcp"
    },
    {
      "key": "google-cloud-composer",
      "name": "Composer",
      "brand": "gcp"
    },
    {
      "key": "gcp-compute-engine",
      "name": "Compute Engine",
      "brand": "gcp"
    },
    {
      "key": "gcp-configuration-management",
      "name": "Configuration Management",
      "brand": "gcp"
    },
    {
      "key": "gcp-connectivity-test",
      "name": "Connectivity Test",
      "brand": "gcp"
    },
    {
      "key": "gcp-connectors",
      "name": "Connectors",
      "brand": "gcp"
    },
    {
      "key": "gcp-contact-center-ai",
      "name": "Contact Center AI",
      "brand": "gcp"
    },
    {
      "key": "gcp-container-optimized-os",
      "name": "Container Optimized OS",
      "brand": "gcp"
    },
    {
      "key": "google-container-optimized-os",
      "name": "Container Optimized OS",
      "brand": "gcp"
    },
    {
      "key": "gcp-container-registry",
      "name": "Container Registry",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-catalog",
      "name": "Data Catalog",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-labeling",
      "name": "Data Labeling",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-layers",
      "name": "Data Layers",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-loss-prevention-api",
      "name": "Data Loss Prevention API",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-qna",
      "name": "Data Qna",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-studio",
      "name": "Data Studio",
      "brand": "gcp"
    },
    {
      "key": "gcp-data-transfer",
      "name": "Data Transfer",
      "brand": "gcp"
    },
    {
      "key": "gcp-database-migration-service",
      "name": "Database Migration Service",
      "brand": "gcp"
    },
    {
      "key": "gcp-dataflow",
      "name": "Dataflow",
      "brand": "gcp"
    },
    {
      "key": "google-dataflow",
      "name": "Dataflow",
      "brand": "gcp"
    },
    {
      "key": "gcp-datalab",
      "name": "Datalab",
      "brand": "gcp"
    },
    {
      "key": "gcp-dataplex",
      "name": "Dataplex",
      "brand": "gcp"
    },
    {
      "key": "gcp-datapol",
      "name": "Datapol",
      "brand": "gcp"
    },
    {
      "key": "gcp-dataprep",
      "name": "Dataprep",
      "brand": "gcp"
    },
    {
      "key": "gcp-dataproc",
      "name": "Dataproc",
      "brand": "gcp"
    },
    {
      "key": "google-dataproc",
      "name": "Dataproc",
      "brand": "gcp"
    },
    {
      "key": "gcp-dataproc-metastore",
      "name": "Dataproc Metastore",
      "brand": "gcp"
    },
    {
      "key": "gcp-datashare",
      "name": "Datashare",
      "brand": "gcp"
    },
    {
      "key": "gcp-datastore",
      "name": "Datastore",
      "brand": "gcp"
    },
    {
      "key": "gcp-datastream",
      "name": "Datastream",
      "brand": "gcp"
    },
    {
      "key": "gcp-debugger",
      "name": "Debugger",
      "brand": "gcp"
    },
    {
      "key": "gcp-developer-portal",
      "name": "Developer Portal",
      "brand": "gcp"
    },
    {
      "key": "gcp-dialogflow-cx",
      "name": "Dialogflow Cx",
      "brand": "gcp"
    },
    {
      "key": "gcp-dialogflow-insights",
      "name": "Dialogflow Insights",
      "brand": "gcp"
    },
    {
      "key": "google-docs",
      "name": "Docs",
      "brand": "gcp"
    },
    {
      "key": "gcp-document-ai",
      "name": "Document AI",
      "brand": "gcp"
    },
    {
      "key": "google-drive",
      "name": "Drive",
      "brand": "gcp"
    },
    {
      "key": "gcp-early-access-center",
      "name": "Early Access Center",
      "brand": "gcp"
    },
    {
      "key": "google-earth",
      "name": "Earth",
      "brand": "gcp"
    },
    {
      "key": "google-earth-engine",
      "name": "Earth Engine",
      "brand": "gcp"
    },
    {
      "key": "gcp-error-reporting",
      "name": "Error Reporting",
      "brand": "gcp"
    },
    {
      "key": "gcp-eventarc",
      "name": "Eventarc",
      "brand": "gcp"
    },
    {
      "key": "gcp-filestore",
      "name": "Filestore",
      "brand": "gcp"
    },
    {
      "key": "gcp-financial-services-marketplace",
      "name": "Financial Services Marketplace",
      "brand": "gcp"
    },
    {
      "key": "gcp-firestore",
      "name": "Firestore",
      "brand": "gcp"
    },
    {
      "key": "gcp-fleet-engine",
      "name": "Fleet Engine",
      "brand": "gcp"
    },
    {
      "key": "google-fonts",
      "name": "Fonts",
      "brand": "gcp"
    },
    {
      "key": "google-forms",
      "name": "Forms",
      "brand": "gcp"
    },
    {
      "key": "gcp-free-trial",
      "name": "Free Trial",
      "brand": "gcp"
    },
    {
      "key": "gcp-game-servers",
      "name": "Game Servers",
      "brand": "gcp"
    },
    {
      "key": "gcp-gce-systems-management",
      "name": "Gce Systems Management",
      "brand": "gcp"
    },
    {
      "key": "google-gemini",
      "name": "Gemini",
      "brand": "gcp"
    },
    {
      "key": "gcp-genomics",
      "name": "Genomics",
      "brand": "gcp"
    },
    {
      "key": "gcp-gke-on-prem",
      "name": "Gke On Prem",
      "brand": "gcp"
    },
    {
      "key": "gcp-google-cloud-marketplace",
      "name": "Google Cloud Marketplace",
      "brand": "gcp"
    },
    {
      "key": "gcp-google-kubernetes-engine",
      "name": "Google Kubernetes Engine",
      "brand": "gcp"
    },
    {
      "key": "gcp-google-maps-platform",
      "name": "Google Maps Platform",
      "brand": "gcp"
    },
    {
      "key": "gcp-healthcare-nlp-api",
      "name": "Healthcare Nlp API",
      "brand": "gcp"
    },
    {
      "key": "gcp-home",
      "name": "Home",
      "brand": "gcp"
    },
    {
      "key": "google-home",
      "name": "Home",
      "brand": "gcp"
    },
    {
      "key": "gcp-identity-and-access-management",
      "name": "Identity And Access Management",
      "brand": "gcp"
    },
    {
      "key": "gcp-identity-aware-proxy",
      "name": "Identity Aware Proxy",
      "brand": "gcp"
    },
    {
      "key": "gcp-identity-platform",
      "name": "Identity Platform",
      "brand": "gcp"
    },
    {
      "key": "google-idx",
      "name": "Idx",
      "brand": "gcp"
    },
    {
      "key": "gcp-iot-core",
      "name": "IoT Core",
      "brand": "gcp"
    },
    {
      "key": "gcp-iot-edge",
      "name": "IoT Edge",
      "brand": "gcp"
    },
    {
      "key": "google-jules",
      "name": "Jules",
      "brand": "gcp"
    },
    {
      "key": "google-keep",
      "name": "Keep",
      "brand": "gcp"
    },
    {
      "key": "gcp-key-access-justifications",
      "name": "Key Access Justifications",
      "brand": "gcp"
    },
    {
      "key": "gcp-key-management-service",
      "name": "Key Management Service",
      "brand": "gcp"
    },
    {
      "key": "gcp-kuberun",
      "name": "Kuberun",
      "brand": "gcp"
    },
    {
      "key": "gcp-launcher",
      "name": "Launcher",
      "brand": "gcp"
    },
    {
      "key": "google-lens",
      "name": "Lens",
      "brand": "gcp"
    },
    {
      "key": "gcp-local-ssd",
      "name": "Local Ssd",
      "brand": "gcp"
    },
    {
      "key": "gcp-managed-service-for-microsoft-active-directory",
      "name": "Managed Service For Microsoft Active Directory",
      "brand": "gcp"
    },
    {
      "key": "google-maps",
      "name": "Maps",
      "brand": "gcp"
    },
    {
      "key": "google-marketing-platform",
      "name": "Marketing Platform",
      "brand": "gcp"
    },
    {
      "key": "gcp-media-translation-api",
      "name": "Media Translation API",
      "brand": "gcp"
    },
    {
      "key": "google-meet",
      "name": "Meet",
      "brand": "gcp"
    },
    {
      "key": "gcp-memorystore",
      "name": "Memorystore",
      "brand": "gcp"
    },
    {
      "key": "google-messages",
      "name": "Messages",
      "brand": "gcp"
    },
    {
      "key": "gcp-migrate-for-anthos",
      "name": "Migrate For Anthos",
      "brand": "gcp"
    },
    {
      "key": "gcp-migrate-for-compute-engine",
      "name": "Migrate For Compute Engine",
      "brand": "gcp"
    },
    {
      "key": "gcp-my-cloud",
      "name": "My Cloud",
      "brand": "gcp"
    },
    {
      "key": "google-nearby",
      "name": "Nearby",
      "brand": "gcp"
    },
    {
      "key": "gcp-network-connectivity-center",
      "name": "Network Connectivity Center",
      "brand": "gcp"
    },
    {
      "key": "gcp-network-intelligence-center",
      "name": "Network Intelligence Center",
      "brand": "gcp"
    },
    {
      "key": "gcp-network-security",
      "name": "Network Security",
      "brand": "gcp"
    },
    {
      "key": "gcp-network-tiers",
      "name": "Network Tiers",
      "brand": "gcp"
    },
    {
      "key": "gcp-network-topology",
      "name": "Network Topology",
      "brand": "gcp"
    },
    {
      "key": "google-news",
      "name": "News",
      "brand": "gcp"
    },
    {
      "key": "gcp-onboarding",
      "name": "Onboarding",
      "brand": "gcp"
    },
    {
      "key": "gcp-os-configuration-management",
      "name": "OS Configuration Management",
      "brand": "gcp"
    },
    {
      "key": "gcp-os-inventory-management",
      "name": "OS Inventory Management",
      "brand": "gcp"
    },
    {
      "key": "gcp-os-patch-management",
      "name": "OS Patch Management",
      "brand": "gcp"
    },
    {
      "key": "google-palm",
      "name": "Palm",
      "brand": "gcp"
    },
    {
      "key": "gcp-partner-interconnect",
      "name": "Partner Interconnect",
      "brand": "gcp"
    },
    {
      "key": "gcp-partner-portal",
      "name": "Partner Portal",
      "brand": "gcp"
    },
    {
      "key": "google-password-manager",
      "name": "Password Manager",
      "brand": "gcp"
    },
    {
      "key": "google-pay",
      "name": "Pay",
      "brand": "gcp"
    },
    {
      "key": "gcp-performance-dashboard",
      "name": "Performance Dashboard",
      "brand": "gcp"
    },
    {
      "key": "gcp-permissions",
      "name": "Permissions",
      "brand": "gcp"
    },
    {
      "key": "gcp-persistent-disk",
      "name": "Persistent Disk",
      "brand": "gcp"
    },
    {
      "key": "gcp-phishing-protection",
      "name": "Phishing Protection",
      "brand": "gcp"
    },
    {
      "key": "google-photos",
      "name": "Photos",
      "brand": "gcp"
    },
    {
      "key": "google-play",
      "name": "Play",
      "brand": "gcp"
    },
    {
      "key": "google-play-games",
      "name": "Play Games",
      "brand": "gcp"
    },
    {
      "key": "gcp-policy-analyzer",
      "name": "Policy Analyzer",
      "brand": "gcp"
    },
    {
      "key": "gcp-premium-network-tier",
      "name": "Premium Network Tier",
      "brand": "gcp"
    },
    {
      "key": "gcp-private-connectivity",
      "name": "Private Connectivity",
      "brand": "gcp"
    },
    {
      "key": "gcp-private-service-connect",
      "name": "Private Service Connect",
      "brand": "gcp"
    },
    {
      "key": "gcp-producer-portal",
      "name": "Producer Portal",
      "brand": "gcp"
    },
    {
      "key": "gcp-profiler",
      "name": "Profiler",
      "brand": "gcp"
    },
    {
      "key": "gcp-project",
      "name": "Project",
      "brand": "gcp"
    },
    {
      "key": "google-pub-sub",
      "name": "Pub Sub",
      "brand": "gcp"
    },
    {
      "key": "gcp-pubsub",
      "name": "Pubsub",
      "brand": "gcp"
    },
    {
      "key": "gcp-quantum-engine",
      "name": "Quantum Engine",
      "brand": "gcp"
    },
    {
      "key": "gcp-quotas",
      "name": "Quotas",
      "brand": "gcp"
    },
    {
      "key": "gcp-real-world-insights",
      "name": "Real World Insights",
      "brand": "gcp"
    },
    {
      "key": "gcp-recommendations-ai",
      "name": "Recommendations AI",
      "brand": "gcp"
    },
    {
      "key": "gcp-release-notes",
      "name": "Release Notes",
      "brand": "gcp"
    },
    {
      "key": "gcp-retail-api",
      "name": "Retail API",
      "brand": "gcp"
    },
    {
      "key": "gcp-risk-manager",
      "name": "Risk Manager",
      "brand": "gcp"
    },
    {
      "key": "gcp-runtime-config",
      "name": "Runtime Config",
      "brand": "gcp"
    },
    {
      "key": "google-scholar",
      "name": "Scholar",
      "brand": "gcp"
    },
    {
      "key": "google-search-console",
      "name": "Search Console",
      "brand": "gcp"
    },
    {
      "key": "gcp-secret-manager",
      "name": "Secret Manager",
      "brand": "gcp"
    },
    {
      "key": "gcp-security",
      "name": "Security",
      "brand": "gcp"
    },
    {
      "key": "gcp-security-command-center",
      "name": "Security Command Center",
      "brand": "gcp"
    },
    {
      "key": "gcp-security-health-advisor",
      "name": "Security Health Advisor",
      "brand": "gcp"
    },
    {
      "key": "gcp-security-key-enforcement",
      "name": "Security Key Enforcement",
      "brand": "gcp"
    },
    {
      "key": "gcp-service-discovery",
      "name": "Service Discovery",
      "brand": "gcp"
    },
    {
      "key": "google-sheets",
      "name": "Sheets",
      "brand": "gcp"
    },
    {
      "key": "google-slides",
      "name": "Slides",
      "brand": "gcp"
    },
    {
      "key": "google-cloud-spanner",
      "name": "Spanner",
      "brand": "gcp"
    },
    {
      "key": "gcp-speech-to-text",
      "name": "Speech To Text",
      "brand": "gcp"
    },
    {
      "key": "gcp-stackdriver",
      "name": "Stackdriver",
      "brand": "gcp"
    },
    {
      "key": "gcp-standard-network-tier",
      "name": "Standard Network Tier",
      "brand": "gcp"
    },
    {
      "key": "google-cloud-storage",
      "name": "Storage",
      "brand": "gcp"
    },
    {
      "key": "gcp-stream-suite",
      "name": "Stream Suite",
      "brand": "gcp"
    },
    {
      "key": "google-street-view",
      "name": "Street View",
      "brand": "gcp"
    },
    {
      "key": "google-summer-of-code",
      "name": "Summer Of Code",
      "brand": "gcp"
    },
    {
      "key": "gcp-support",
      "name": "Support",
      "brand": "gcp"
    },
    {
      "key": "google-tag-manager",
      "name": "Tag Manager",
      "brand": "gcp"
    },
    {
      "key": "google-tasks",
      "name": "Tasks",
      "brand": "gcp"
    },
    {
      "key": "gcp-tensorflow-enterprise",
      "name": "Tensorflow Enterprise",
      "brand": "gcp"
    },
    {
      "key": "gcp-text-to-speech",
      "name": "Text To Speech",
      "brand": "gcp"
    },
    {
      "key": "gcp-tools-for-powershell",
      "name": "Tools For Powershell",
      "brand": "gcp"
    },
    {
      "key": "gcp-trace",
      "name": "Trace",
      "brand": "gcp"
    },
    {
      "key": "gcp-traffic-director",
      "name": "Traffic Director",
      "brand": "gcp"
    },
    {
      "key": "gcp-transfer",
      "name": "Transfer",
      "brand": "gcp"
    },
    {
      "key": "gcp-transfer-appliance",
      "name": "Transfer Appliance",
      "brand": "gcp"
    },
    {
      "key": "google-translate",
      "name": "Translate",
      "brand": "gcp"
    },
    {
      "key": "google-tv",
      "name": "TV",
      "brand": "gcp"
    },
    {
      "key": "gcp-user-preferences",
      "name": "User Preferences",
      "brand": "gcp"
    },
    {
      "key": "gcp-vertexai",
      "name": "Vertexai",
      "brand": "gcp"
    },
    {
      "key": "gcp-video-intelligence-api",
      "name": "Video Intelligence API",
      "brand": "gcp"
    },
    {
      "key": "gcp-virtual-private-cloud",
      "name": "Virtual Private Cloud",
      "brand": "gcp"
    },
    {
      "key": "gcp-visual-inspection",
      "name": "Visual Inspection",
      "brand": "gcp"
    },
    {
      "key": "gcp-vmware-engine",
      "name": "Vmware Engine",
      "brand": "gcp"
    },
    {
      "key": "gcp-web-risk",
      "name": "Web Risk",
      "brand": "gcp"
    },
    {
      "key": "gcp-web-security-scanner",
      "name": "Web Security Scanner",
      "brand": "gcp"
    },
    {
      "key": "gcp-workflows",
      "name": "Workflows",
      "brand": "gcp"
    },
    {
      "key": "gcp-workload-identity-pool",
      "name": "Workload Identity Pool",
      "brand": "gcp"
    }
  ],
  "devtool": [
    {
      "key": "30-seconds-of-code",
      "name": "30 seconds of code",
      "brand": "devtool"
    },
    {
      "key": "acode",
      "name": "Acode",
      "brand": "devtool"
    },
    {
      "key": "activeloop",
      "name": "Activeloop",
      "brand": "devtool"
    },
    {
      "key": "actix",
      "name": "Actix",
      "brand": "devtool"
    },
    {
      "key": "actual-budget",
      "name": "Actual Budget",
      "brand": "devtool"
    },
    {
      "key": "adaway",
      "name": "AdAway",
      "brand": "devtool"
    },
    {
      "key": "agora",
      "name": "Agora",
      "brand": "devtool"
    },
    {
      "key": "aiohttp",
      "name": "AIOHTTP",
      "brand": "devtool"
    },
    {
      "key": "aiqfome",
      "name": "Aiqfome",
      "brand": "devtool"
    },
    {
      "key": "airbrake",
      "name": "Airbrake",
      "brand": "devtool"
    },
    {
      "key": "ajv",
      "name": "Ajv",
      "brand": "devtool"
    },
    {
      "key": "akamai",
      "name": "Akamai",
      "brand": "devtool"
    },
    {
      "key": "alacritty",
      "name": "Alacritty",
      "brand": "devtool"
    },
    {
      "key": "alby",
      "name": "Alby",
      "brand": "devtool"
    },
    {
      "key": "aws-amazon-codecatalyst",
      "name": "Amazon CodeCatalyst",
      "brand": "devtool"
    },
    {
      "key": "aws-amazon-corretto",
      "name": "Amazon Corretto",
      "brand": "devtool"
    },
    {
      "key": "android-studio",
      "name": "Android Studio",
      "brand": "devtool"
    },
    {
      "key": "animedotjs",
      "name": "Anime.js",
      "brand": "devtool"
    },
    {
      "key": "ansible",
      "name": "Ansible",
      "brand": "devtool"
    },
    {
      "key": "antennapod",
      "name": "AntennaPod",
      "brand": "devtool"
    },
    {
      "key": "anytype",
      "name": "Anytype",
      "brand": "devtool"
    },
    {
      "key": "netbeans",
      "name": "Apache NetBeans",
      "brand": "devtool"
    },
    {
      "key": "azure-api-connections",
      "name": "API Connections",
      "brand": "devtool"
    },
    {
      "key": "azure-api-management-services",
      "name": "API Management Services",
      "brand": "devtool"
    },
    {
      "key": "apifox",
      "name": "Apifox",
      "brand": "devtool"
    },
    {
      "key": "apm-terminals",
      "name": "APM Terminals",
      "brand": "devtool"
    },
    {
      "key": "apostrophe",
      "name": "Apostrophe",
      "brand": "devtool"
    },
    {
      "key": "appium",
      "name": "Appium",
      "brand": "devtool"
    },
    {
      "key": "azure-application-insights",
      "name": "Application Insights",
      "brand": "devtool"
    },
    {
      "key": "appmanager",
      "name": "AppManager",
      "brand": "devtool"
    },
    {
      "key": "aqua",
      "name": "Aqua",
      "brand": "devtool"
    },
    {
      "key": "ardour",
      "name": "Ardour",
      "brand": "devtool"
    },
    {
      "key": "argo",
      "name": "Argo",
      "brand": "devtool"
    },
    {
      "key": "ariakit",
      "name": "Ariakit",
      "brand": "devtool"
    },
    {
      "key": "artifact-hub",
      "name": "Artifact Hub",
      "brand": "devtool"
    },
    {
      "key": "gcp-artifact-registry",
      "name": "Artifact Registry",
      "brand": "devtool"
    },
    {
      "key": "asana",
      "name": "Asana",
      "brand": "devtool"
    },
    {
      "key": "asciidoctor",
      "name": "Asciidoctor",
      "brand": "devtool"
    },
    {
      "key": "asciinema",
      "name": "asciinema",
      "brand": "devtool"
    },
    {
      "key": "atom",
      "name": "Atom",
      "brand": "devtool"
    },
    {
      "key": "audacity",
      "name": "Audacity",
      "brand": "devtool"
    },
    {
      "key": "audiobookshelf",
      "name": "Audiobookshelf",
      "brand": "devtool"
    },
    {
      "key": "autocannon",
      "name": "AutoCannon",
      "brand": "devtool"
    },
    {
      "key": "autoprefixer",
      "name": "Autoprefixer",
      "brand": "devtool"
    },
    {
      "key": "avajs",
      "name": "avajs",
      "brand": "devtool"
    },
    {
      "key": "awesome-lists",
      "name": "Awesome Lists",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-cloud-control-api",
      "name": "AWS Cloud Control API",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-cloud-development-kit",
      "name": "AWS Cloud Development Kit",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-cloud9",
      "name": "AWS Cloud9",
      "brand": "devtool"
    },
    {
      "key": "aws-res-aws-cloud9-cloud9",
      "name": "AWS Cloud9 Cloud9",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-cloudshell",
      "name": "AWS CloudShell",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-codeartifact",
      "name": "AWS CodeArtifact",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-codebuild",
      "name": "AWS CodeBuild",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-codecommit",
      "name": "AWS CodeCommit",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-codedeploy",
      "name": "AWS CodeDeploy",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-codepipeline",
      "name": "AWS CodePipeline",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-command-line-interface",
      "name": "AWS Command Line Interface",
      "brand": "devtool"
    },
    {
      "key": "aws-cat-developer-tools",
      "name": "AWS Developer Tools",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-fault-injection-service",
      "name": "AWS Fault Injection Service",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-infrastructure-composer",
      "name": "AWS Infrastructure Composer",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-tools-and-sdks",
      "name": "AWS Tools and SDKs",
      "brand": "devtool"
    },
    {
      "key": "aws-aws-x-ray",
      "name": "AWS X Ray",
      "brand": "devtool"
    },
    {
      "key": "axios",
      "name": "Axios",
      "brand": "devtool"
    },
    {
      "key": "azure-azure-devops",
      "name": "Azure DevOps",
      "brand": "devtool"
    },
    {
      "key": "babelio",
      "name": "Babelio",
      "brand": "devtool"
    },
    {
      "key": "babylondotjs",
      "name": "Babylon.js",
      "brand": "devtool"
    },
    {
      "key": "bastyon",
      "name": "Bastyon",
      "brand": "devtool"
    },
    {
      "key": "bat",
      "name": "bat",
      "brand": "devtool"
    },
    {
      "key": "bentoml",
      "name": "BentoML",
      "brand": "devtool"
    },
    {
      "key": "betterdiscord",
      "name": "BetterDiscord",
      "brand": "devtool"
    },
    {
      "key": "bevy",
      "name": "Bevy",
      "brand": "devtool"
    },
    {
      "key": "bigbluebutton",
      "name": "BigBlueButton",
      "brand": "devtool"
    },
    {
      "key": "bioconductor",
      "name": "Bioconductor",
      "brand": "devtool"
    },
    {
      "key": "biome",
      "name": "Biome",
      "brand": "devtool"
    },
    {
      "key": "biomejs",
      "name": "Biomejs",
      "brand": "devtool"
    },
    {
      "key": "bitbucket",
      "name": "Bitbucket",
      "brand": "devtool"
    },
    {
      "key": "bolt",
      "name": "bolt",
      "brand": "devtool"
    },
    {
      "key": "braintrust",
      "name": "Braintrust",
      "brand": "devtool"
    },
    {
      "key": "bspwm",
      "name": "bspwm",
      "brand": "devtool"
    },
    {
      "key": "budibase",
      "name": "Budibase",
      "brand": "devtool"
    },
    {
      "key": "buefy",
      "name": "Buefy",
      "brand": "devtool"
    },
    {
      "key": "buildkite",
      "name": "Buildkite",
      "brand": "devtool"
    },
    {
      "key": "cairo-graphics",
      "name": "Cairo Graphics",
      "brand": "devtool"
    },
    {
      "key": "calibre-web",
      "name": "Calibre-Web",
      "brand": "devtool"
    },
    {
      "key": "canonical-juju",
      "name": "Canonical Juju",
      "brand": "devtool"
    },
    {
      "key": "capacitor",
      "name": "Capacitor",
      "brand": "devtool"
    },
    {
      "key": "caprover",
      "name": "CapRover",
      "brand": "devtool"
    },
    {
      "key": "cardmarket",
      "name": "Cardmarket",
      "brand": "devtool"
    },
    {
      "key": "celery",
      "name": "Celery",
      "brand": "devtool"
    },
    {
      "key": "ceph",
      "name": "Ceph",
      "brand": "devtool"
    },
    {
      "key": "chai",
      "name": "Chai",
      "brand": "devtool"
    },
    {
      "key": "azure-change-analysis",
      "name": "Change Analysis",
      "brand": "devtool"
    },
    {
      "key": "cheerio",
      "name": "Cheerio",
      "brand": "devtool"
    },
    {
      "key": "chef",
      "name": "Chef",
      "brand": "devtool"
    },
    {
      "key": "chezmoi",
      "name": "chezmoi",
      "brand": "devtool"
    },
    {
      "key": "chocolatey",
      "name": "Chocolatey",
      "brand": "devtool"
    },
    {
      "key": "cilium",
      "name": "Cilium",
      "brand": "devtool"
    },
    {
      "key": "circleci",
      "name": "CircleCI",
      "brand": "devtool"
    },
    {
      "key": "claude-code",
      "name": "Claude Code",
      "brand": "devtool"
    },
    {
      "key": "clickhouse",
      "name": "ClickHouse",
      "brand": "devtool"
    },
    {
      "key": "clickup",
      "name": "ClickUp",
      "brand": "devtool"
    },
    {
      "key": "cline",
      "name": "Cline",
      "brand": "devtool"
    },
    {
      "key": "clion",
      "name": "CLion",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-build",
      "name": "Cloud Build",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-code",
      "name": "Cloud Code",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-deploy",
      "name": "Cloud Deploy",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-deployment-manager",
      "name": "Cloud Deployment Manager",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-scheduler",
      "name": "Cloud Scheduler",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-shell",
      "name": "Cloud Shell",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-tasks",
      "name": "Cloud Tasks",
      "brand": "devtool"
    },
    {
      "key": "gcp-cloud-test-lab",
      "name": "Cloud Test Lab",
      "brand": "devtool"
    },
    {
      "key": "cloudflare",
      "name": "Cloudflare",
      "brand": "devtool"
    },
    {
      "key": "azure-cloudtest",
      "name": "CloudTest",
      "brand": "devtool"
    },
    {
      "key": "cncf",
      "name": "CNCF",
      "brand": "devtool"
    },
    {
      "key": "cockpit",
      "name": "Cockpit",
      "brand": "devtool"
    },
    {
      "key": "cocoapods",
      "name": "CocoaPods",
      "brand": "devtool"
    },
    {
      "key": "coda",
      "name": "Coda",
      "brand": "devtool"
    },
    {
      "key": "codacy",
      "name": "Codacy",
      "brand": "devtool"
    },
    {
      "key": "code-climate",
      "name": "Code Climate",
      "brand": "devtool"
    },
    {
      "key": "azure-code-optimization",
      "name": "Code Optimization",
      "brand": "devtool"
    },
    {
      "key": "code-blocks",
      "name": "Code::Blocks",
      "brand": "devtool"
    },
    {
      "key": "codeceptjs",
      "name": "CodeceptJS",
      "brand": "devtool"
    },
    {
      "key": "codecov",
      "name": "Codecov",
      "brand": "devtool"
    },
    {
      "key": "codecrafters",
      "name": "CodeCrafters",
      "brand": "devtool"
    },
    {
      "key": "codemirror",
      "name": "CodeMirror",
      "brand": "devtool"
    },
    {
      "key": "coderwall",
      "name": "Coderwall",
      "brand": "devtool"
    },
    {
      "key": "codesandbox",
      "name": "CodeSandbox",
      "brand": "devtool"
    },
    {
      "key": "commitlint",
      "name": "commitlint",
      "brand": "devtool"
    },
    {
      "key": "common-workflow-language",
      "name": "Common Workflow Language",
      "brand": "devtool"
    },
    {
      "key": "compiler-explorer",
      "name": "Compiler Explorer",
      "brand": "devtool"
    },
    {
      "key": "conda-forge",
      "name": "Conda-Forge",
      "brand": "devtool"
    },
    {
      "key": "confluence",
      "name": "Confluence",
      "brand": "devtool"
    },
    {
      "key": "consul",
      "name": "Consul",
      "brand": "devtool"
    },
    {
      "key": "gcp-container-registry",
      "name": "Container Registry",
      "brand": "devtool"
    },
    {
      "key": "cookiecutter",
      "name": "Cookiecutter",
      "brand": "devtool"
    },
    {
      "key": "coolify",
      "name": "Coolify",
      "brand": "devtool"
    },
    {
      "key": "coveralls",
      "name": "Coveralls",
      "brand": "devtool"
    },
    {
      "key": "cratedb",
      "name": "CrateDB",
      "brand": "devtool"
    },
    {
      "key": "create-react-app",
      "name": "Create React App",
      "brand": "devtool"
    },
    {
      "key": "cryptomator",
      "name": "Cryptomator",
      "brand": "devtool"
    },
    {
      "key": "css-modules",
      "name": "CSS Modules",
      "brand": "devtool"
    },
    {
      "key": "cursor",
      "name": "Cursor",
      "brand": "devtool"
    },
    {
      "key": "cypress",
      "name": "Cypress",
      "brand": "devtool"
    },
    {
      "key": "cytoscapedotjs",
      "name": "Cytoscape.js",
      "brand": "devtool"
    },
    {
      "key": "d",
      "name": "D",
      "brand": "devtool"
    },
    {
      "key": "d-edge",
      "name": "D-EDGE",
      "brand": "devtool"
    },
    {
      "key": "d3",
      "name": "D3",
      "brand": "devtool"
    },
    {
      "key": "dapr",
      "name": "Dapr",
      "brand": "devtool"
    },
    {
      "key": "dark-reader",
      "name": "Dark Reader",
      "brand": "devtool"
    },
    {
      "key": "dask",
      "name": "Dask",
      "brand": "devtool"
    },
    {
      "key": "datadog",
      "name": "Datadog",
      "brand": "devtool"
    },
    {
      "key": "datagrip",
      "name": "DataGrip",
      "brand": "devtool"
    },
    {
      "key": "gcp-debugger",
      "name": "Debugger",
      "brand": "devtool"
    },
    {
      "key": "decentraland",
      "name": "Decentraland",
      "brand": "devtool"
    },
    {
      "key": "deluge",
      "name": "Deluge",
      "brand": "devtool"
    },
    {
      "key": "dependabot",
      "name": "Dependabot",
      "brand": "devtool"
    },
    {
      "key": "devbox",
      "name": "Devbox",
      "brand": "devtool"
    },
    {
      "key": "development-containers",
      "name": "Development Containers",
      "brand": "devtool"
    },
    {
      "key": "azure-devops-starter",
      "name": "DevOps Starter",
      "brand": "devtool"
    },
    {
      "key": "devpost",
      "name": "Devpost",
      "brand": "devtool"
    },
    {
      "key": "azure-devtest-labs",
      "name": "DevTest Labs",
      "brand": "devtool"
    },
    {
      "key": "diagramsdotnet",
      "name": "diagrams.net",
      "brand": "devtool"
    },
    {
      "key": "distrobox",
      "name": "Distrobox",
      "brand": "devtool"
    },
    {
      "key": "dlib",
      "name": "Dlib",
      "brand": "devtool"
    },
    {
      "key": "dlthub",
      "name": "dlthub",
      "brand": "devtool"
    },
    {
      "key": "docker",
      "name": "Docker",
      "brand": "devtool"
    },
    {
      "key": "docsify",
      "name": "Docsify",
      "brand": "devtool"
    },
    {
      "key": "dokku",
      "name": "Dokku",
      "brand": "devtool"
    },
    {
      "key": "dolibarr",
      "name": "Dolibarr",
      "brand": "devtool"
    },
    {
      "key": "dolphin",
      "name": "Dolphin",
      "brand": "devtool"
    },
    {
      "key": "doxygen",
      "name": "Doxygen",
      "brand": "devtool"
    },
    {
      "key": "dozzle",
      "name": "Dozzle",
      "brand": "devtool"
    },
    {
      "key": "drone",
      "name": "Drone",
      "brand": "devtool"
    },
    {
      "key": "dtube",
      "name": "DTube",
      "brand": "devtool"
    },
    {
      "key": "eclipse-adoptium",
      "name": "Eclipse Adoptium",
      "brand": "devtool"
    },
    {
      "key": "eclipse-che",
      "name": "Eclipse Che",
      "brand": "devtool"
    },
    {
      "key": "eclipse-ide",
      "name": "Eclipse IDE",
      "brand": "devtool"
    },
    {
      "key": "eclipse-jetty",
      "name": "Eclipse Jetty",
      "brand": "devtool"
    },
    {
      "key": "eclipse-mosquitto",
      "name": "Eclipse Mosquitto",
      "brand": "devtool"
    },
    {
      "key": "editorconfig",
      "name": "EditorConfig",
      "brand": "devtool"
    },
    {
      "key": "ejs",
      "name": "EJS",
      "brand": "devtool"
    },
    {
      "key": "elastic",
      "name": "Elastic",
      "brand": "devtool"
    },
    {
      "key": "electron-fiddle",
      "name": "Electron Fiddle",
      "brand": "devtool"
    },
    {
      "key": "elk",
      "name": "Elk",
      "brand": "devtool"
    },
    {
      "key": "elm",
      "name": "Elm",
      "brand": "devtool"
    },
    {
      "key": "emacs",
      "name": "Emacs",
      "brand": "devtool"
    },
    {
      "key": "endeavouros",
      "name": "EndeavourOS",
      "brand": "devtool"
    },
    {
      "key": "erpnext",
      "name": "ERPNext",
      "brand": "devtool"
    },
    {
      "key": "gcp-error-reporting",
      "name": "Error Reporting",
      "brand": "devtool"
    },
    {
      "key": "eslint",
      "name": "ESLint",
      "brand": "devtool"
    },
    {
      "key": "event-store",
      "name": "Event Store",
      "brand": "devtool"
    },
    {
      "key": "exercism",
      "name": "Exercism",
      "brand": "devtool"
    },
    {
      "key": "fastlane",
      "name": "Fastlane",
      "brand": "devtool"
    },
    {
      "key": "fastly",
      "name": "Fastly",
      "brand": "devtool"
    },
    {
      "key": "ferretdb",
      "name": "FerretDB",
      "brand": "devtool"
    },
    {
      "key": "filen",
      "name": "Filen",
      "brand": "devtool"
    },
    {
      "key": "fireship",
      "name": "Fireship",
      "brand": "devtool"
    },
    {
      "key": "fish-shell",
      "name": "fish shell",
      "brand": "devtool"
    },
    {
      "key": "flat",
      "name": "Flat",
      "brand": "devtool"
    },
    {
      "key": "flatpak",
      "name": "Flatpak",
      "brand": "devtool"
    },
    {
      "key": "floorp",
      "name": "Floorp",
      "brand": "devtool"
    },
    {
      "key": "flow-launcher",
      "name": "Flow Launcher",
      "brand": "devtool"
    },
    {
      "key": "fluent-bit",
      "name": "Fluent Bit",
      "brand": "devtool"
    },
    {
      "key": "flux",
      "name": "Flux",
      "brand": "devtool"
    },
    {
      "key": "flyway",
      "name": "Flyway",
      "brand": "devtool"
    },
    {
      "key": "format-json-online",
      "name": "Format JSON Online",
      "brand": "devtool"
    },
    {
      "key": "foundry-virtual-tabletop",
      "name": "Foundry Virtual Tabletop",
      "brand": "devtool"
    },
    {
      "key": "framework7",
      "name": "Framework7",
      "brand": "devtool"
    },
    {
      "key": "frappe",
      "name": "Frappe",
      "brand": "devtool"
    },
    {
      "key": "freenas",
      "name": "FreeNAS",
      "brand": "devtool"
    },
    {
      "key": "freetube",
      "name": "FreeTube",
      "brand": "devtool"
    },
    {
      "key": "gemini-cli",
      "name": "Gemini CLI",
      "brand": "devtool"
    },
    {
      "key": "geode",
      "name": "Geode",
      "brand": "devtool"
    },
    {
      "key": "getx",
      "name": "GetX",
      "brand": "devtool"
    },
    {
      "key": "gin",
      "name": "Gin",
      "brand": "devtool"
    },
    {
      "key": "git",
      "name": "Git",
      "brand": "devtool"
    },
    {
      "key": "git-extensions",
      "name": "Git Extensions",
      "brand": "devtool"
    },
    {
      "key": "git-for-windows",
      "name": "Git for Windows",
      "brand": "devtool"
    },
    {
      "key": "git-lfs",
      "name": "Git LFS",
      "brand": "devtool"
    },
    {
      "key": "gitea",
      "name": "Gitea",
      "brand": "devtool"
    },
    {
      "key": "github",
      "name": "GitHub",
      "brand": "devtool"
    },
    {
      "key": "github-actions",
      "name": "GitHub Actions",
      "brand": "devtool"
    },
    {
      "key": "github-pages",
      "name": "GitHub Pages",
      "brand": "devtool"
    },
    {
      "key": "github-sponsors",
      "name": "GitHub Sponsors",
      "brand": "devtool"
    },
    {
      "key": "gitkraken",
      "name": "GitKraken",
      "brand": "devtool"
    },
    {
      "key": "gitlab",
      "name": "GitLab",
      "brand": "devtool"
    },
    {
      "key": "gitpod",
      "name": "Gitpod",
      "brand": "devtool"
    },
    {
      "key": "glance",
      "name": "Glance",
      "brand": "devtool"
    },
    {
      "key": "goland",
      "name": "GoLand",
      "brand": "devtool"
    },
    {
      "key": "gradle",
      "name": "Gradle",
      "brand": "devtool"
    },
    {
      "key": "gradle-play-publisher",
      "name": "Gradle Play Publisher",
      "brand": "devtool"
    },
    {
      "key": "grafana",
      "name": "Grafana",
      "brand": "devtool"
    },
    {
      "key": "grapheneos",
      "name": "GrapheneOS",
      "brand": "devtool"
    },
    {
      "key": "graphql",
      "name": "GraphQL",
      "brand": "devtool"
    },
    {
      "key": "greasy-fork",
      "name": "Greasy Fork",
      "brand": "devtool"
    },
    {
      "key": "greptimedb",
      "name": "GreptimeDB",
      "brand": "devtool"
    },
    {
      "key": "griddotai",
      "name": "Grid.ai",
      "brand": "devtool"
    },
    {
      "key": "grocy",
      "name": "Grocy",
      "brand": "devtool"
    },
    {
      "key": "grunt",
      "name": "Grunt",
      "brand": "devtool"
    },
    {
      "key": "gulp",
      "name": "gulp",
      "brand": "devtool"
    },
    {
      "key": "gunicorn",
      "name": "Gunicorn",
      "brand": "devtool"
    },
    {
      "key": "gutenberg",
      "name": "Gutenberg",
      "brand": "devtool"
    },
    {
      "key": "h3",
      "name": "H3",
      "brand": "devtool"
    },
    {
      "key": "handlebarsdotjs",
      "name": "Handlebars.js",
      "brand": "devtool"
    },
    {
      "key": "harbor",
      "name": "Harbor",
      "brand": "devtool"
    },
    {
      "key": "hashicorp",
      "name": "HashiCorp",
      "brand": "devtool"
    },
    {
      "key": "hasura",
      "name": "Hasura",
      "brand": "devtool"
    },
    {
      "key": "have-i-been-pwned",
      "name": "Have I Been Pwned",
      "brand": "devtool"
    },
    {
      "key": "haystack",
      "name": "Haystack",
      "brand": "devtool"
    },
    {
      "key": "hedgedoc",
      "name": "HedgeDoc",
      "brand": "devtool"
    },
    {
      "key": "helix",
      "name": "Helix",
      "brand": "devtool"
    },
    {
      "key": "helm",
      "name": "Helm",
      "brand": "devtool"
    },
    {
      "key": "heroic-games-launcher",
      "name": "Heroic Games Launcher",
      "brand": "devtool"
    },
    {
      "key": "homarr",
      "name": "Homarr",
      "brand": "devtool"
    },
    {
      "key": "homebrew",
      "name": "Homebrew",
      "brand": "devtool"
    },
    {
      "key": "homebridge",
      "name": "Homebridge",
      "brand": "devtool"
    },
    {
      "key": "homepage",
      "name": "Homepage",
      "brand": "devtool"
    },
    {
      "key": "honeycomb",
      "name": "Honeycomb",
      "brand": "devtool"
    },
    {
      "key": "hoppscotch",
      "name": "Hoppscotch",
      "brand": "devtool"
    },
    {
      "key": "htmx",
      "name": "htmx",
      "brand": "devtool"
    },
    {
      "key": "htop",
      "name": "htop",
      "brand": "devtool"
    },
    {
      "key": "httpie",
      "name": "HTTPie",
      "brand": "devtool"
    },
    {
      "key": "humhub",
      "name": "HumHub",
      "brand": "devtool"
    },
    {
      "key": "hyper",
      "name": "Hyper",
      "brand": "devtool"
    },
    {
      "key": "i18next",
      "name": "i18next",
      "brand": "devtool"
    },
    {
      "key": "i3",
      "name": "i3",
      "brand": "devtool"
    },
    {
      "key": "icinga",
      "name": "Icinga",
      "brand": "devtool"
    },
    {
      "key": "image-toolbox",
      "name": "Image Toolbox",
      "brand": "devtool"
    },
    {
      "key": "imagej",
      "name": "ImageJ",
      "brand": "devtool"
    },
    {
      "key": "immer",
      "name": "Immer",
      "brand": "devtool"
    },
    {
      "key": "immich",
      "name": "Immich",
      "brand": "devtool"
    },
    {
      "key": "inquirer",
      "name": "Inquirer",
      "brand": "devtool"
    },
    {
      "key": "insomnia",
      "name": "Insomnia",
      "brand": "devtool"
    },
    {
      "key": "interactjs",
      "name": "InteractJS",
      "brand": "devtool"
    },
    {
      "key": "intlayer",
      "name": "Intlayer",
      "brand": "devtool"
    },
    {
      "key": "invidious",
      "name": "Invidious",
      "brand": "devtool"
    },
    {
      "key": "invoice-ninja",
      "name": "Invoice Ninja",
      "brand": "devtool"
    },
    {
      "key": "iobroker",
      "name": "ioBroker",
      "brand": "devtool"
    },
    {
      "key": "ipfs",
      "name": "IPFS",
      "brand": "devtool"
    },
    {
      "key": "istio",
      "name": "Istio",
      "brand": "devtool"
    },
    {
      "key": "iterm2",
      "name": "iTerm2",
      "brand": "devtool"
    },
    {
      "key": "jaeger",
      "name": "Jaeger",
      "brand": "devtool"
    },
    {
      "key": "jamstack",
      "name": "Jamstack",
      "brand": "devtool"
    },
    {
      "key": "jasmine",
      "name": "Jasmine",
      "brand": "devtool"
    },
    {
      "key": "jekyll",
      "name": "Jekyll",
      "brand": "devtool"
    },
    {
      "key": "jenkins",
      "name": "Jenkins",
      "brand": "devtool"
    },
    {
      "key": "jest",
      "name": "Jest",
      "brand": "devtool"
    },
    {
      "key": "jetbrains",
      "name": "JetBrains",
      "brand": "devtool"
    },
    {
      "key": "jhipster",
      "name": "JHipster",
      "brand": "devtool"
    },
    {
      "key": "jira",
      "name": "Jira",
      "brand": "devtool"
    },
    {
      "key": "jira-software",
      "name": "Jira Software",
      "brand": "devtool"
    },
    {
      "key": "jitsi",
      "name": "Jitsi",
      "brand": "devtool"
    },
    {
      "key": "joplin",
      "name": "Joplin",
      "brand": "devtool"
    },
    {
      "key": "jsdelivr",
      "name": "jsDelivr",
      "brand": "devtool"
    },
    {
      "key": "jsr",
      "name": "JSR",
      "brand": "devtool"
    },
    {
      "key": "junit5",
      "name": "JUnit5",
      "brand": "devtool"
    },
    {
      "key": "jupyter",
      "name": "Jupyter",
      "brand": "devtool"
    },
    {
      "key": "kamal",
      "name": "Kamal",
      "brand": "devtool"
    },
    {
      "key": "kando",
      "name": "Kando",
      "brand": "devtool"
    },
    {
      "key": "kaniko",
      "name": "Kaniko",
      "brand": "devtool"
    },
    {
      "key": "kedro",
      "name": "Kedro",
      "brand": "devtool"
    },
    {
      "key": "keepassxc",
      "name": "KeePassXC",
      "brand": "devtool"
    },
    {
      "key": "keeweb",
      "name": "KeeWeb",
      "brand": "devtool"
    },
    {
      "key": "keybase",
      "name": "Keybase",
      "brand": "devtool"
    },
    {
      "key": "kibana",
      "name": "Kibana",
      "brand": "devtool"
    },
    {
      "key": "kilo-code",
      "name": "Kilo Code",
      "brand": "devtool"
    },
    {
      "key": "kiro",
      "name": "Kiro",
      "brand": "devtool"
    },
    {
      "key": "knative",
      "name": "Knative",
      "brand": "devtool"
    },
    {
      "key": "knexdotjs",
      "name": "Knex.js",
      "brand": "devtool"
    },
    {
      "key": "known",
      "name": "Known",
      "brand": "devtool"
    },
    {
      "key": "konva",
      "name": "Konva",
      "brand": "devtool"
    },
    {
      "key": "koreader",
      "name": "KOReader",
      "brand": "devtool"
    },
    {
      "key": "ktor",
      "name": "Ktor",
      "brand": "devtool"
    },
    {
      "key": "kubernetes",
      "name": "Kubernetes",
      "brand": "devtool"
    },
    {
      "key": "kubespray",
      "name": "Kubespray",
      "brand": "devtool"
    },
    {
      "key": "azure-lab-accounts",
      "name": "Lab Accounts",
      "brand": "devtool"
    },
    {
      "key": "azure-lab-services",
      "name": "Lab Services",
      "brand": "devtool"
    },
    {
      "key": "langchain",
      "name": "LangChain",
      "brand": "devtool"
    },
    {
      "key": "langflow",
      "name": "Langflow",
      "brand": "devtool"
    },
    {
      "key": "lapce",
      "name": "Lapce",
      "brand": "devtool"
    },
    {
      "key": "laravel-horizon",
      "name": "Laravel Horizon",
      "brand": "devtool"
    },
    {
      "key": "latex",
      "name": "LaTeX",
      "brand": "devtool"
    },
    {
      "key": "lazarus",
      "name": "Lazarus",
      "brand": "devtool"
    },
    {
      "key": "lazyvim",
      "name": "LazyVim",
      "brand": "devtool"
    },
    {
      "key": "leaflet",
      "name": "Leaflet",
      "brand": "devtool"
    },
    {
      "key": "lefthook",
      "name": "Lefthook",
      "brand": "devtool"
    },
    {
      "key": "lens",
      "name": "Lens",
      "brand": "devtool"
    },
    {
      "key": "leptos",
      "name": "Leptos",
      "brand": "devtool"
    },
    {
      "key": "less",
      "name": "Less",
      "brand": "devtool"
    },
    {
      "key": "librariesdotio",
      "name": "Libraries.io",
      "brand": "devtool"
    },
    {
      "key": "libretube",
      "name": "LibreTube",
      "brand": "devtool"
    },
    {
      "key": "libuv",
      "name": "libuv",
      "brand": "devtool"
    },
    {
      "key": "lighthouse",
      "name": "Lighthouse",
      "brand": "devtool"
    },
    {
      "key": "lightning",
      "name": "Lightning",
      "brand": "devtool"
    },
    {
      "key": "linear",
      "name": "Linear",
      "brand": "devtool"
    },
    {
      "key": "llamaindex",
      "name": "LlamaIndex",
      "brand": "devtool"
    },
    {
      "key": "azure-load-testing",
      "name": "Load Testing",
      "brand": "devtool"
    },
    {
      "key": "lobsters",
      "name": "Lobsters",
      "brand": "devtool"
    },
    {
      "key": "localsend",
      "name": "LocalSend",
      "brand": "devtool"
    },
    {
      "key": "lodash",
      "name": "Lodash",
      "brand": "devtool"
    },
    {
      "key": "logseq",
      "name": "Logseq",
      "brand": "devtool"
    },
    {
      "key": "longhorn",
      "name": "Longhorn",
      "brand": "devtool"
    },
    {
      "key": "luau",
      "name": "Luau",
      "brand": "devtool"
    },
    {
      "key": "ludwig",
      "name": "Ludwig",
      "brand": "devtool"
    },
    {
      "key": "lutris",
      "name": "Lutris",
      "brand": "devtool"
    },
    {
      "key": "macports",
      "name": "MacPorts",
      "brand": "devtool"
    },
    {
      "key": "magisk",
      "name": "Magisk",
      "brand": "devtool"
    },
    {
      "key": "mamba-ui",
      "name": "Mamba UI",
      "brand": "devtool"
    },
    {
      "key": "azure-managed-devops-pools",
      "name": "Managed DevOps Pools",
      "brand": "devtool"
    },
    {
      "key": "maplibre",
      "name": "MapLibre",
      "brand": "devtool"
    },
    {
      "key": "marko",
      "name": "Marko",
      "brand": "devtool"
    },
    {
      "key": "mastercomfig",
      "name": "mastercomfig",
      "brand": "devtool"
    },
    {
      "key": "mdbook",
      "name": "mdBook",
      "brand": "devtool"
    },
    {
      "key": "mdn-web-docs",
      "name": "MDN Web Docs",
      "brand": "devtool"
    },
    {
      "key": "mdx",
      "name": "MDX",
      "brand": "devtool"
    },
    {
      "key": "mealie",
      "name": "Mealie",
      "brand": "devtool"
    },
    {
      "key": "metasploit",
      "name": "Metasploit",
      "brand": "devtool"
    },
    {
      "key": "micro-editor",
      "name": "Micro Editor",
      "brand": "devtool"
    },
    {
      "key": "mihon",
      "name": "Mihon",
      "brand": "devtool"
    },
    {
      "key": "milvus",
      "name": "Milvus",
      "brand": "devtool"
    },
    {
      "key": "mobx",
      "name": "MobX",
      "brand": "devtool"
    },
    {
      "key": "mobx-state-tree",
      "name": "MobX-State-Tree",
      "brand": "devtool"
    },
    {
      "key": "mocha",
      "name": "Mocha",
      "brand": "devtool"
    },
    {
      "key": "mock-service-worker",
      "name": "Mock Service Worker",
      "brand": "devtool"
    },
    {
      "key": "modrinth",
      "name": "Modrinth",
      "brand": "devtool"
    },
    {
      "key": "moq",
      "name": "Moq",
      "brand": "devtool"
    },
    {
      "key": "mpv",
      "name": "mpv",
      "brand": "devtool"
    },
    {
      "key": "mui",
      "name": "MUI",
      "brand": "devtool"
    },
    {
      "key": "mumble",
      "name": "Mumble",
      "brand": "devtool"
    },
    {
      "key": "mypy",
      "name": "mypy",
      "brand": "devtool"
    },
    {
      "key": "nano-stores",
      "name": "Nano Stores",
      "brand": "devtool"
    },
    {
      "key": "natsdotio",
      "name": "NATS.io",
      "brand": "devtool"
    },
    {
      "key": "neovim",
      "name": "Neovim",
      "brand": "devtool"
    },
    {
      "key": "netlify",
      "name": "Netlify",
      "brand": "devtool"
    },
    {
      "key": "neutralinojs",
      "name": "Neutralinojs",
      "brand": "devtool"
    },
    {
      "key": "new-relic",
      "name": "New Relic",
      "brand": "devtool"
    },
    {
      "key": "nextflow",
      "name": "Nextflow",
      "brand": "devtool"
    },
    {
      "key": "nf-core",
      "name": "nf-core",
      "brand": "devtool"
    },
    {
      "key": "nginx-proxy-manager",
      "name": "Nginx Proxy Manager",
      "brand": "devtool"
    },
    {
      "key": "ngrok",
      "name": "ngrok",
      "brand": "devtool"
    },
    {
      "key": "nixos",
      "name": "NixOS",
      "brand": "devtool"
    },
    {
      "key": "nodebb",
      "name": "NodeBB",
      "brand": "devtool"
    },
    {
      "key": "nodegui",
      "name": "NodeGui",
      "brand": "devtool"
    },
    {
      "key": "nomad",
      "name": "Nomad",
      "brand": "devtool"
    },
    {
      "key": "normalizedotcss",
      "name": "Normalize.css",
      "brand": "devtool"
    },
    {
      "key": "notepadplusplus",
      "name": "Notepad++",
      "brand": "devtool"
    },
    {
      "key": "notion",
      "name": "Notion",
      "brand": "devtool"
    },
    {
      "key": "nsis",
      "name": "NSIS",
      "brand": "devtool"
    },
    {
      "key": "numba",
      "name": "Numba",
      "brand": "devtool"
    },
    {
      "key": "nunjucks",
      "name": "Nunjucks",
      "brand": "devtool"
    },
    {
      "key": "nushell",
      "name": "Nushell",
      "brand": "devtool"
    },
    {
      "key": "nvm",
      "name": "nvm",
      "brand": "devtool"
    },
    {
      "key": "nx",
      "name": "Nx",
      "brand": "devtool"
    },
    {
      "key": "obsidian",
      "name": "Obsidian",
      "brand": "devtool"
    },
    {
      "key": "obtainium",
      "name": "Obtainium",
      "brand": "devtool"
    },
    {
      "key": "oclif",
      "name": "oclif",
      "brand": "devtool"
    },
    {
      "key": "octoprint",
      "name": "OctoPrint",
      "brand": "devtool"
    },
    {
      "key": "odin",
      "name": "Odin",
      "brand": "devtool"
    },
    {
      "key": "onnx",
      "name": "ONNX",
      "brand": "devtool"
    },
    {
      "key": "open-containers-initiative",
      "name": "Open Containers Initiative",
      "brand": "devtool"
    },
    {
      "key": "open3d",
      "name": "Open3D",
      "brand": "devtool"
    },
    {
      "key": "openjs-foundation",
      "name": "OpenJS Foundation",
      "brand": "devtool"
    },
    {
      "key": "openlayers",
      "name": "Openlayers",
      "brand": "devtool"
    },
    {
      "key": "openmediavault",
      "name": "openmediavault",
      "brand": "devtool"
    },
    {
      "key": "opentofu",
      "name": "OpenTofu",
      "brand": "devtool"
    },
    {
      "key": "openverse",
      "name": "Openverse",
      "brand": "devtool"
    },
    {
      "key": "opnsense",
      "name": "OPNsense",
      "brand": "devtool"
    },
    {
      "key": "opsgenie",
      "name": "Opsgenie",
      "brand": "devtool"
    },
    {
      "key": "optimism",
      "name": "Optimism",
      "brand": "devtool"
    },
    {
      "key": "optuna",
      "name": "Optuna",
      "brand": "devtool"
    },
    {
      "key": "osf",
      "name": "OSF",
      "brand": "devtool"
    },
    {
      "key": "osmand",
      "name": "OsmAnd",
      "brand": "devtool"
    },
    {
      "key": "osmc",
      "name": "OSMC",
      "brand": "devtool"
    },
    {
      "key": "overleaf",
      "name": "Overleaf",
      "brand": "devtool"
    },
    {
      "key": "owasp",
      "name": "OWASP",
      "brand": "devtool"
    },
    {
      "key": "oxc",
      "name": "Oxc",
      "brand": "devtool"
    },
    {
      "key": "packagist",
      "name": "Packagist",
      "brand": "devtool"
    },
    {
      "key": "packer",
      "name": "Packer",
      "brand": "devtool"
    },
    {
      "key": "palantir",
      "name": "Palantir",
      "brand": "devtool"
    },
    {
      "key": "pandoc",
      "name": "Pandoc",
      "brand": "devtool"
    },
    {
      "key": "pangolin",
      "name": "Pangolin",
      "brand": "devtool"
    },
    {
      "key": "paperless-ngx",
      "name": "Paperless-ngx",
      "brand": "devtool"
    },
    {
      "key": "pdm",
      "name": "PDM",
      "brand": "devtool"
    },
    {
      "key": "percy",
      "name": "Percy",
      "brand": "devtool"
    },
    {
      "key": "phabricator",
      "name": "Phabricator",
      "brand": "devtool"
    },
    {
      "key": "phoenix-framework",
      "name": "Phoenix Framework",
      "brand": "devtool"
    },
    {
      "key": "phpmyadmin",
      "name": "phpMyAdmin",
      "brand": "devtool"
    },
    {
      "key": "phpstan",
      "name": "PHPStan",
      "brand": "devtool"
    },
    {
      "key": "phpstorm",
      "name": "PhpStorm",
      "brand": "devtool"
    },
    {
      "key": "pine-script",
      "name": "Pine Script",
      "brand": "devtool"
    },
    {
      "key": "pino",
      "name": "pino",
      "brand": "devtool"
    },
    {
      "key": "piwigo",
      "name": "Piwigo",
      "brand": "devtool"
    },
    {
      "key": "plausible-analytics",
      "name": "Plausible Analytics",
      "brand": "devtool"
    },
    {
      "key": "playwright",
      "name": "Playwright",
      "brand": "devtool"
    },
    {
      "key": "podman",
      "name": "Podman",
      "brand": "devtool"
    },
    {
      "key": "polymer-project",
      "name": "Polymer Project",
      "brand": "devtool"
    },
    {
      "key": "pop-os",
      "name": "Pop!_OS",
      "brand": "devtool"
    },
    {
      "key": "portableappsdotcom",
      "name": "PortableApps.com",
      "brand": "devtool"
    },
    {
      "key": "posthog",
      "name": "PostHog",
      "brand": "devtool"
    },
    {
      "key": "postman",
      "name": "Postman",
      "brand": "devtool"
    },
    {
      "key": "postmark",
      "name": "Postmark",
      "brand": "devtool"
    },
    {
      "key": "pre-commit",
      "name": "pre-commit",
      "brand": "devtool"
    },
    {
      "key": "prek",
      "name": "prek",
      "brand": "devtool"
    },
    {
      "key": "presto",
      "name": "Presto",
      "brand": "devtool"
    },
    {
      "key": "prettier",
      "name": "Prettier",
      "brand": "devtool"
    },
    {
      "key": "probot",
      "name": "Probot",
      "brand": "devtool"
    },
    {
      "key": "prometheus",
      "name": "Prometheus",
      "brand": "devtool"
    },
    {
      "key": "protractor",
      "name": "Protractor",
      "brand": "devtool"
    },
    {
      "key": "pterodactyl",
      "name": "Pterodactyl",
      "brand": "devtool"
    },
    {
      "key": "pug",
      "name": "Pug",
      "brand": "devtool"
    },
    {
      "key": "puppet",
      "name": "Puppet",
      "brand": "devtool"
    },
    {
      "key": "purgecss",
      "name": "PurgeCSS",
      "brand": "devtool"
    },
    {
      "key": "pwa",
      "name": "PWA",
      "brand": "devtool"
    },
    {
      "key": "pycharm",
      "name": "PyCharm",
      "brand": "devtool"
    },
    {
      "key": "pycqa",
      "name": "PyCQA",
      "brand": "devtool"
    },
    {
      "key": "pydantic",
      "name": "Pydantic",
      "brand": "devtool"
    },
    {
      "key": "pyg",
      "name": "PyG",
      "brand": "devtool"
    },
    {
      "key": "pyscaffold",
      "name": "PyScaffold",
      "brand": "devtool"
    },
    {
      "key": "pysyft",
      "name": "PySyft",
      "brand": "devtool"
    },
    {
      "key": "pytest",
      "name": "Pytest",
      "brand": "devtool"
    },
    {
      "key": "qbittorrent",
      "name": "qbittorrent",
      "brand": "devtool"
    },
    {
      "key": "qmk",
      "name": "QMK",
      "brand": "devtool"
    },
    {
      "key": "quad9",
      "name": "Quad9",
      "brand": "devtool"
    },
    {
      "key": "quarto",
      "name": "Quarto",
      "brand": "devtool"
    },
    {
      "key": "quasar",
      "name": "Quasar",
      "brand": "devtool"
    },
    {
      "key": "qubes-os",
      "name": "Qubes OS",
      "brand": "devtool"
    },
    {
      "key": "quicklook",
      "name": "QuickLook",
      "brand": "devtool"
    },
    {
      "key": "quicktype",
      "name": "quicktype",
      "brand": "devtool"
    },
    {
      "key": "radarr",
      "name": "radarr",
      "brand": "devtool"
    },
    {
      "key": "railway",
      "name": "Railway",
      "brand": "devtool"
    },
    {
      "key": "rainmeter",
      "name": "Rainmeter",
      "brand": "devtool"
    },
    {
      "key": "rancher",
      "name": "Rancher",
      "brand": "devtool"
    },
    {
      "key": "ratatui",
      "name": "Ratatui",
      "brand": "devtool"
    },
    {
      "key": "ray",
      "name": "Ray",
      "brand": "devtool"
    },
    {
      "key": "raylib",
      "name": "Raylib",
      "brand": "devtool"
    },
    {
      "key": "rclone",
      "name": "Rclone",
      "brand": "devtool"
    },
    {
      "key": "react-bootstrap",
      "name": "React Bootstrap",
      "brand": "devtool"
    },
    {
      "key": "react-hook-form",
      "name": "React Hook Form",
      "brand": "devtool"
    },
    {
      "key": "react-table",
      "name": "React Table",
      "brand": "devtool"
    },
    {
      "key": "reactive-resume",
      "name": "Reactive Resume",
      "brand": "devtool"
    },
    {
      "key": "reactivex",
      "name": "ReactiveX",
      "brand": "devtool"
    },
    {
      "key": "reactos",
      "name": "ReactOS",
      "brand": "devtool"
    },
    {
      "key": "read-the-docs",
      "name": "Read the Docs",
      "brand": "devtool"
    },
    {
      "key": "reason",
      "name": "Reason",
      "brand": "devtool"
    },
    {
      "key": "redash",
      "name": "Redash",
      "brand": "devtool"
    },
    {
      "key": "redox",
      "name": "Redox",
      "brand": "devtool"
    },
    {
      "key": "redux-saga",
      "name": "Redux-Saga",
      "brand": "devtool"
    },
    {
      "key": "refined-github",
      "name": "Refined GitHub",
      "brand": "devtool"
    },
    {
      "key": "remark",
      "name": "remark",
      "brand": "devtool"
    },
    {
      "key": "render",
      "name": "Render",
      "brand": "devtool"
    },
    {
      "key": "renovate",
      "name": "Renovate",
      "brand": "devtool"
    },
    {
      "key": "replit",
      "name": "Replit",
      "brand": "devtool"
    },
    {
      "key": "reqable",
      "name": "Reqable",
      "brand": "devtool"
    },
    {
      "key": "resharper",
      "name": "ReSharper",
      "brand": "devtool"
    },
    {
      "key": "retro-achievements",
      "name": "Retro Achievements",
      "brand": "devtool"
    },
    {
      "key": "retropie",
      "name": "RetroPie",
      "brand": "devtool"
    },
    {
      "key": "rich",
      "name": "Rich",
      "brand": "devtool"
    },
    {
      "key": "rider",
      "name": "Rider",
      "brand": "devtool"
    },
    {
      "key": "rime",
      "name": "Rime",
      "brand": "devtool"
    },
    {
      "key": "robot-framework",
      "name": "Robot Framework",
      "brand": "devtool"
    },
    {
      "key": "rocksdb",
      "name": "RocksDB",
      "brand": "devtool"
    },
    {
      "key": "rollupdotjs",
      "name": "rollup.js",
      "brand": "devtool"
    },
    {
      "key": "rook",
      "name": "Rook",
      "brand": "devtool"
    },
    {
      "key": "rsbuild",
      "name": "Rsbuild",
      "brand": "devtool"
    },
    {
      "key": "rstudio-ide",
      "name": "RStudio IDE",
      "brand": "devtool"
    },
    {
      "key": "rubocop",
      "name": "RuboCop",
      "brand": "devtool"
    },
    {
      "key": "ruby-on-rails",
      "name": "Ruby on Rails",
      "brand": "devtool"
    },
    {
      "key": "ruby-sinatra",
      "name": "Ruby Sinatra",
      "brand": "devtool"
    },
    {
      "key": "rubymine",
      "name": "RubyMine",
      "brand": "devtool"
    },
    {
      "key": "rundeck",
      "name": "Rundeck",
      "brand": "devtool"
    },
    {
      "key": "rustdesk",
      "name": "RustDesk",
      "brand": "devtool"
    },
    {
      "key": "rxdb",
      "name": "RxDB",
      "brand": "devtool"
    },
    {
      "key": "rye",
      "name": "Rye",
      "brand": "devtool"
    },
    {
      "key": "sagemath",
      "name": "SageMath",
      "brand": "devtool"
    },
    {
      "key": "sanic",
      "name": "Sanic",
      "brand": "devtool"
    },
    {
      "key": "scilab",
      "name": "Scilab",
      "brand": "devtool"
    },
    {
      "key": "scipy",
      "name": "SciPy",
      "brand": "devtool"
    },
    {
      "key": "scrapy",
      "name": "Scrapy",
      "brand": "devtool"
    },
    {
      "key": "scratch",
      "name": "Scratch",
      "brand": "devtool"
    },
    {
      "key": "sefaria",
      "name": "Sefaria",
      "brand": "devtool"
    },
    {
      "key": "selenium",
      "name": "Selenium",
      "brand": "devtool"
    },
    {
      "key": "semver",
      "name": "SemVer",
      "brand": "devtool"
    },
    {
      "key": "sensu",
      "name": "Sensu",
      "brand": "devtool"
    },
    {
      "key": "sentry",
      "name": "Sentry",
      "brand": "devtool"
    },
    {
      "key": "setuptools",
      "name": "Setuptools",
      "brand": "devtool"
    },
    {
      "key": "sharp",
      "name": "sharp",
      "brand": "devtool"
    },
    {
      "key": "shieldsdotio",
      "name": "Shields.io",
      "brand": "devtool"
    },
    {
      "key": "simplex",
      "name": "SimpleX",
      "brand": "devtool"
    },
    {
      "key": "skaffold",
      "name": "Skaffold",
      "brand": "devtool"
    },
    {
      "key": "skeleton",
      "name": "Skeleton",
      "brand": "devtool"
    },
    {
      "key": "slint",
      "name": "Slint",
      "brand": "devtool"
    },
    {
      "key": "snapcraft",
      "name": "Snapcraft",
      "brand": "devtool"
    },
    {
      "key": "snyk",
      "name": "Snyk",
      "brand": "devtool"
    },
    {
      "key": "socket",
      "name": "Socket",
      "brand": "devtool"
    },
    {
      "key": "sonarqube",
      "name": "SonarQube",
      "brand": "devtool"
    },
    {
      "key": "sonarqube-for-ide",
      "name": "SonarQube for IDE",
      "brand": "devtool"
    },
    {
      "key": "sonarr",
      "name": "sonarr",
      "brand": "devtool"
    },
    {
      "key": "sourcetree",
      "name": "Sourcetree",
      "brand": "devtool"
    },
    {
      "key": "spacy",
      "name": "spaCy",
      "brand": "devtool"
    },
    {
      "key": "sphinx",
      "name": "Sphinx",
      "brand": "devtool"
    },
    {
      "key": "splunk",
      "name": "Splunk",
      "brand": "devtool"
    },
    {
      "key": "spyder-ide",
      "name": "Spyder IDE",
      "brand": "devtool"
    },
    {
      "key": "stackblitz",
      "name": "StackBlitz",
      "brand": "devtool"
    },
    {
      "key": "stackedit",
      "name": "StackEdit",
      "brand": "devtool"
    },
    {
      "key": "standardjs",
      "name": "StandardJS",
      "brand": "devtool"
    },
    {
      "key": "starship",
      "name": "Starship",
      "brand": "devtool"
    },
    {
      "key": "statuspage",
      "name": "Statuspage",
      "brand": "devtool"
    },
    {
      "key": "stopstalk",
      "name": "StopStalk",
      "brand": "devtool"
    },
    {
      "key": "stremio",
      "name": "Stremio",
      "brand": "devtool"
    },
    {
      "key": "stylelint",
      "name": "stylelint",
      "brand": "devtool"
    },
    {
      "key": "stylus",
      "name": "Stylus",
      "brand": "devtool"
    },
    {
      "key": "sublime-text",
      "name": "Sublime Text",
      "brand": "devtool"
    },
    {
      "key": "subtitle-edit",
      "name": "Subtitle Edit",
      "brand": "devtool"
    },
    {
      "key": "svgdotjs",
      "name": "SVG.js",
      "brand": "devtool"
    },
    {
      "key": "svgo",
      "name": "SVGO",
      "brand": "devtool"
    },
    {
      "key": "swagger",
      "name": "Swagger",
      "brand": "devtool"
    },
    {
      "key": "sway",
      "name": "Sway",
      "brand": "devtool"
    },
    {
      "key": "sympy",
      "name": "SymPy",
      "brand": "devtool"
    },
    {
      "key": "syncthing",
      "name": "Syncthing",
      "brand": "devtool"
    },
    {
      "key": "system76",
      "name": "System76",
      "brand": "devtool"
    },
    {
      "key": "tailscale",
      "name": "Tailscale",
      "brand": "devtool"
    },
    {
      "key": "talos",
      "name": "Talos",
      "brand": "devtool"
    },
    {
      "key": "task",
      "name": "Task",
      "brand": "devtool"
    },
    {
      "key": "tasmota",
      "name": "Tasmota",
      "brand": "devtool"
    },
    {
      "key": "teamcity",
      "name": "TeamCity",
      "brand": "devtool"
    },
    {
      "key": "tekton",
      "name": "Tekton",
      "brand": "devtool"
    },
    {
      "key": "temporal",
      "name": "Temporal",
      "brand": "devtool"
    },
    {
      "key": "teradata",
      "name": "Teradata",
      "brand": "devtool"
    },
    {
      "key": "terraform",
      "name": "Terraform",
      "brand": "devtool"
    },
    {
      "key": "terragrunt",
      "name": "Terragrunt",
      "brand": "devtool"
    },
    {
      "key": "terser",
      "name": "Terser",
      "brand": "devtool"
    },
    {
      "key": "testcafe",
      "name": "TestCafe",
      "brand": "devtool"
    },
    {
      "key": "textual",
      "name": "Textual",
      "brand": "devtool"
    },
    {
      "key": "the-algorithms",
      "name": "The Algorithms",
      "brand": "devtool"
    },
    {
      "key": "thesvg",
      "name": "theSVG",
      "brand": "devtool"
    },
    {
      "key": "thunderstore",
      "name": "Thunderstore",
      "brand": "devtool"
    },
    {
      "key": "thymeleaf",
      "name": "Thymeleaf",
      "brand": "devtool"
    },
    {
      "key": "tidyverse",
      "name": "Tidyverse",
      "brand": "devtool"
    },
    {
      "key": "tinygrad",
      "name": "tinygrad",
      "brand": "devtool"
    },
    {
      "key": "tmux",
      "name": "tmux",
      "brand": "devtool"
    },
    {
      "key": "todoist",
      "name": "Todoist",
      "brand": "devtool"
    },
    {
      "key": "toml",
      "name": "TOML",
      "brand": "devtool"
    },
    {
      "key": "tooljet",
      "name": "ToolJet",
      "brand": "devtool"
    },
    {
      "key": "tower",
      "name": "Tower",
      "brand": "devtool"
    },
    {
      "key": "tqdm",
      "name": "tqdm",
      "brand": "devtool"
    },
    {
      "key": "traefik",
      "name": "Traefik",
      "brand": "devtool"
    },
    {
      "key": "traefik-mesh",
      "name": "Traefik Mesh",
      "brand": "devtool"
    },
    {
      "key": "transmission",
      "name": "Transmission",
      "brand": "devtool"
    },
    {
      "key": "trello",
      "name": "Trello",
      "brand": "devtool"
    },
    {
      "key": "trilium",
      "name": "Trilium",
      "brand": "devtool"
    },
    {
      "key": "trino",
      "name": "Trino",
      "brand": "devtool"
    },
    {
      "key": "tsdown",
      "name": "tsdown",
      "brand": "devtool"
    },
    {
      "key": "turbopack",
      "name": "Turbopack",
      "brand": "devtool"
    },
    {
      "key": "tuta",
      "name": "Tuta",
      "brand": "devtool"
    },
    {
      "key": "typora",
      "name": "Typora",
      "brand": "devtool"
    },
    {
      "key": "ublock-origin",
      "name": "uBlock Origin",
      "brand": "devtool"
    },
    {
      "key": "umami",
      "name": "Umami",
      "brand": "devtool"
    },
    {
      "key": "underscoredotjs",
      "name": "Underscore.js",
      "brand": "devtool"
    },
    {
      "key": "unocss",
      "name": "UnoCSS",
      "brand": "devtool"
    },
    {
      "key": "unpkg",
      "name": "unpkg",
      "brand": "devtool"
    },
    {
      "key": "uv",
      "name": "uv",
      "brand": "devtool"
    },
    {
      "key": "vagrant",
      "name": "Vagrant",
      "brand": "devtool"
    },
    {
      "key": "vanilla-extract",
      "name": "Vanilla Extract",
      "brand": "devtool"
    },
    {
      "key": "vault",
      "name": "Vault",
      "brand": "devtool"
    },
    {
      "key": "vaultwarden",
      "name": "Vaultwarden",
      "brand": "devtool"
    },
    {
      "key": "vega",
      "name": "Vega",
      "brand": "devtool"
    },
    {
      "key": "velocity",
      "name": "Velocity",
      "brand": "devtool"
    },
    {
      "key": "velog",
      "name": "Velog",
      "brand": "devtool"
    },
    {
      "key": "vencord",
      "name": "Vencord",
      "brand": "devtool"
    },
    {
      "key": "vercel",
      "name": "Vercel",
      "brand": "devtool"
    },
    {
      "key": "victoriametrics",
      "name": "VictoriaMetrics",
      "brand": "devtool"
    },
    {
      "key": "vikunja",
      "name": "Vikunja",
      "brand": "devtool"
    },
    {
      "key": "vim",
      "name": "Vim",
      "brand": "devtool"
    },
    {
      "key": "vite",
      "name": "Vite",
      "brand": "devtool"
    },
    {
      "key": "vitepress",
      "name": "VitePress",
      "brand": "devtool"
    },
    {
      "key": "vitess",
      "name": "Vitess",
      "brand": "devtool"
    },
    {
      "key": "vitest",
      "name": "Vitest",
      "brand": "devtool"
    },
    {
      "key": "voidzero",
      "name": "VoidZero",
      "brand": "devtool"
    },
    {
      "key": "voron-design",
      "name": "Voron Design",
      "brand": "devtool"
    },
    {
      "key": "vowpal-wabbit",
      "name": "Vowpal Wabbit",
      "brand": "devtool"
    },
    {
      "key": "vuedotjs",
      "name": "Vue.js",
      "brand": "devtool"
    },
    {
      "key": "wagtail",
      "name": "Wagtail",
      "brand": "devtool"
    },
    {
      "key": "wakatime",
      "name": "WakaTime",
      "brand": "devtool"
    },
    {
      "key": "wallabag",
      "name": "Wallabag",
      "brand": "devtool"
    },
    {
      "key": "warp",
      "name": "Warp",
      "brand": "devtool"
    },
    {
      "key": "wasmcloud",
      "name": "wasmCloud",
      "brand": "devtool"
    },
    {
      "key": "wasmer",
      "name": "Wasmer",
      "brand": "devtool"
    },
    {
      "key": "web3dotjs",
      "name": "Web3.js",
      "brand": "devtool"
    },
    {
      "key": "webex",
      "name": "Webex",
      "brand": "devtool"
    },
    {
      "key": "weblate",
      "name": "Weblate",
      "brand": "devtool"
    },
    {
      "key": "webmin",
      "name": "Webmin",
      "brand": "devtool"
    },
    {
      "key": "webpack",
      "name": "Webpack",
      "brand": "devtool"
    },
    {
      "key": "webstorm",
      "name": "WebStorm",
      "brand": "devtool"
    },
    {
      "key": "wezterm",
      "name": "WezTerm",
      "brand": "devtool"
    },
    {
      "key": "windsurf",
      "name": "Windsurf",
      "brand": "devtool"
    },
    {
      "key": "wireshark",
      "name": "Wireshark",
      "brand": "devtool"
    },
    {
      "key": "woodpecker",
      "name": "Woodpecker CI",
      "brand": "devtool"
    },
    {
      "key": "azure-workspace-gateway",
      "name": "Workspace Gateway",
      "brand": "devtool"
    },
    {
      "key": "wxt",
      "name": "WXT",
      "brand": "devtool"
    },
    {
      "key": "xcode",
      "name": "Xcode",
      "brand": "devtool"
    },
    {
      "key": "xmpp",
      "name": "XMPP",
      "brand": "devtool"
    },
    {
      "key": "xo",
      "name": "XO",
      "brand": "devtool"
    },
    {
      "key": "xyflow",
      "name": "xyflow",
      "brand": "devtool"
    },
    {
      "key": "yabai",
      "name": "yabai",
      "brand": "devtool"
    },
    {
      "key": "yew",
      "name": "Yew",
      "brand": "devtool"
    },
    {
      "key": "yunohost",
      "name": "YunoHost",
      "brand": "devtool"
    },
    {
      "key": "zed",
      "name": "Zed",
      "brand": "devtool"
    },
    {
      "key": "zed-industries",
      "name": "Zed Industries",
      "brand": "devtool"
    },
    {
      "key": "zigbee2mqtt",
      "name": "Zigbee2MQTT",
      "brand": "devtool"
    },
    {
      "key": "zola",
      "name": "Zola",
      "brand": "devtool"
    },
    {
      "key": "zsh",
      "name": "Zsh",
      "brand": "devtool"
    }
  ],
  "microsoft": [
    {
      "key": "dotnet",
      "name": ".NET",
      "brand": "microsoft"
    },
    {
      "key": "azure-blob",
      "name": "Azure Blob Storage",
      "brand": "microsoft"
    },
    {
      "key": "csharp",
      "name": "C#",
      "brand": "microsoft"
    },
    {
      "key": "edge",
      "name": "Edge",
      "brand": "microsoft"
    },
    {
      "key": "microsoft",
      "name": "Microsoft",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-dotnet",
      "name": "Microsoft .NET",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-access",
      "name": "Microsoft Access",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-azure",
      "name": "Microsoft Azure",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-bing",
      "name": "Microsoft Bing",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-clipchamp",
      "name": "Microsoft Clipchamp",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-copilot",
      "name": "Microsoft Copilot",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-defender",
      "name": "Microsoft Defender",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-designer",
      "name": "Microsoft Designer",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-editor",
      "name": "Microsoft Editor",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-excel",
      "name": "Microsoft Excel",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-office",
      "name": "Microsoft Office",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-onedrive",
      "name": "Microsoft OneDrive",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-onenote",
      "name": "Microsoft OneNote",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-outlook",
      "name": "Microsoft Outlook",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-powerpoint",
      "name": "Microsoft PowerPoint",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-sharepoint",
      "name": "Microsoft SharePoint",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-sql-server",
      "name": "Microsoft SQL Server",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-teams",
      "name": "Microsoft Teams",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-todo",
      "name": "Microsoft Todo",
      "brand": "microsoft"
    },
    {
      "key": "microsoft-word",
      "name": "Microsoft Word",
      "brand": "microsoft"
    },
    {
      "key": "powershell",
      "name": "PowerShell",
      "brand": "microsoft"
    },
    {
      "key": "powertoys",
      "name": "PowerToys",
      "brand": "microsoft"
    },
    {
      "key": "visual-studio",
      "name": "Visual Studio",
      "brand": "microsoft"
    },
    {
      "key": "visual-studio-code",
      "name": "Visual Studio Code",
      "brand": "microsoft"
    },
    {
      "key": "windows",
      "name": "Windows",
      "brand": "microsoft"
    }
  ],
  "hosting": [
    {
      "key": "aternos",
      "name": "Aternos",
      "brand": "hosting"
    },
    {
      "key": "bisecthosting",
      "name": "BisectHosting",
      "brand": "hosting"
    },
    {
      "key": "digitalocean",
      "name": "DigitalOcean",
      "brand": "hosting"
    },
    {
      "key": "dozzle",
      "name": "Dozzle",
      "brand": "hosting"
    },
    {
      "key": "dropbox",
      "name": "Dropbox",
      "brand": "hosting"
    },
    {
      "key": "firebase",
      "name": "Firebase",
      "brand": "hosting"
    },
    {
      "key": "fly",
      "name": "Fly",
      "brand": "hosting"
    },
    {
      "key": "fly-io",
      "name": "Fly.io",
      "brand": "hosting"
    },
    {
      "key": "flywheel",
      "name": "Flywheel",
      "brand": "hosting"
    },
    {
      "key": "gatus",
      "name": "Gatus",
      "brand": "hosting"
    },
    {
      "key": "godaddy",
      "name": "GoDaddy",
      "brand": "hosting"
    },
    {
      "key": "google-cloud",
      "name": "Google Cloud",
      "brand": "hosting"
    },
    {
      "key": "hetzner",
      "name": "Hetzner",
      "brand": "hosting"
    },
    {
      "key": "hostgator",
      "name": "Hostgator",
      "brand": "hosting"
    },
    {
      "key": "hostinger",
      "name": "Hostinger",
      "brand": "hosting"
    },
    {
      "key": "jellyfin",
      "name": "Jellyfin",
      "brand": "hosting"
    },
    {
      "key": "jellyseerr",
      "name": "Jellyseerr",
      "brand": "hosting"
    },
    {
      "key": "kavita",
      "name": "Kavita",
      "brand": "hosting"
    },
    {
      "key": "kodi",
      "name": "Kodi",
      "brand": "hosting"
    },
    {
      "key": "leantime",
      "name": "Leantime",
      "brand": "hosting"
    },
    {
      "key": "linkwarden",
      "name": "Linkwarden",
      "brand": "hosting"
    },
    {
      "key": "localai",
      "name": "LocalAI",
      "brand": "hosting"
    },
    {
      "key": "microsoft-onedrive",
      "name": "Microsoft OneDrive",
      "brand": "hosting"
    },
    {
      "key": "microsoft-sharepoint",
      "name": "Microsoft SharePoint",
      "brand": "hosting"
    },
    {
      "key": "mobilizon",
      "name": "Mobilizon",
      "brand": "hosting"
    },
    {
      "key": "navidrome",
      "name": "Navidrome",
      "brand": "hosting"
    },
    {
      "key": "nhost",
      "name": "Nhost",
      "brand": "hosting"
    },
    {
      "key": "openspeedtest",
      "name": "OpenSpeedTest",
      "brand": "hosting"
    },
    {
      "key": "profclaw",
      "name": "profClaw",
      "brand": "hosting"
    },
    {
      "key": "server-fault",
      "name": "Server Fault",
      "brand": "hosting"
    },
    {
      "key": "serverless",
      "name": "Serverless",
      "brand": "hosting"
    },
    {
      "key": "sonarqube-server",
      "name": "SonarQube Server",
      "brand": "hosting"
    },
    {
      "key": "stirling-pdf",
      "name": "Stirling-PDF",
      "brand": "hosting"
    },
    {
      "key": "tube-archivist",
      "name": "Tube Archivist",
      "brand": "hosting"
    },
    {
      "key": "v0",
      "name": "v0",
      "brand": "hosting"
    },
    {
      "key": "vercel-blob",
      "name": "Vercel Blob",
      "brand": "hosting"
    },
    {
      "key": "vultr",
      "name": "Vultr",
      "brand": "hosting"
    },
    {
      "key": "woodpecker",
      "name": "Woodpecker CI",
      "brand": "hosting"
    },
    {
      "key": "zeabur",
      "name": "Zeabur",
      "brand": "hosting"
    }
  ]
};

// Aliases matching thesvg.org category naming conventions
SVG_CATALOG["DevTools"] = SVG_CATALOG["devtool"];
SVG_CATALOG["Microsoft"] = SVG_CATALOG["microsoft"];
SVG_CATALOG["Hosting"] = SVG_CATALOG["hosting"];

export function getCatalogForBrand(brand?: string): SvgIconItem[] {
  if (!brand) return [];
  const b = brand.toLowerCase();
  if (b === 'devtool' || b === 'devtools') return SVG_CATALOG.devtool || SVG_CATALOG.DevTools || [];
  if (b === 'microsoft') return SVG_CATALOG.microsoft || SVG_CATALOG.Microsoft || [];
  if (b === 'hosting') return SVG_CATALOG.hosting || SVG_CATALOG.Hosting || [];
  if (b === 'aws') return SVG_CATALOG.aws || [];
  if (b === 'azure') return SVG_CATALOG.azure || [];
  if (b === 'gcp') return SVG_CATALOG.gcp || [];
  return (SVG_CATALOG as any)[brand] || (SVG_CATALOG as any)[b] || [];
}

